import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import ImageWithBasePath from "./ImageWithBasePath";
import { Tabs, Tab, Modal, Placeholder } from "react-bootstrap";
import moment from "moment";
import { Noimage, Logout } from "../../common/imagePath";
import {
  Edit,
  RefreshCcw,
  RotateCw,
  ShoppingCart,
  Check,
  CheckCircle,
  MoreVertical,
  Trash2,
  UserPlus,
  Plus,
  PlusCircle,
  MinusCircle,
  ChevronLeft,
  ChevronRight,
} from "feather-icons-react/build/IconComponents";
// import PlusCircle from "feather-icons-react/build/IconComponents/PlusCircle";
// import MinusCircle from "feather-icons-react/build/IconComponents/MinusCircle";
import axios from "axios";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import withReactContent from "sweetalert2-react-content";
// import Swal from "sweetalert2";
import Slider from "react-slick";
import config from "../../config/config";
import { toastError, toastSuccess, toastWarn } from "../../common/Toast";
import {
  AWS_IMAGE_FOLDER_POS,
  AWS_IMAGE_FOLDER_SALES,
  CUSTOM_SELECT_DROPDOWN_STYLE,
  CUSTOM_SELECT_DROPDOWN_STYLE_COMBINE,
  CUSTOM_SELECT_DROPDOWN_STYLE_POS,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../common/Constant";
import { changePriceFormat } from "../../common/common";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import CommonDatePicker from "../DatePicker/CommonDatePicker";
import FilterModal from "../Modal/FilterModal";
import ItemsDetailsModal from "../Modal/ItemsDetailsModal";
import CustomerSupplierDetailModel from "../Modal/CustomerSupplierDetailModel";
import HistoryModel from "../Modal/HistoryModel";
import { checkUserPermission } from "../../common/UserPermission";
import LookupReceiptSaleModal from "../Modal/LookupReceiptSaleModal";
import Deliveriescard from "../Modal/DeliveriesCard";
import Scanner from "../ScannerHtml5/Scanner";
import CommonItemSearch from "../ItemSearch/CommonItemSearch";
import Loader from "../Loader/Loader";
import { uploadAWS } from "../../common/AWSHelper";
// import SeeStock  from '../../assets/img/SeeStock.svg'
import scannericon from "../../assets/img/scannericon.svg";
import outofstock from "../../assets/img/InStockOnly.svg";
import instock from "../../assets/img/AllStock.svg";
import itemuncheck from "../../assets/img/itemuncheck.svg";
import itemcheck from "../../assets/img/itemcheck.svg";
import eyeIcon from "../../assets/img/eyeIcon.svg";
import favourite from "../../assets/img/favourite.svg";
import makeFavourit from "../../assets/img/makeFavourit.svg";
import EMPTYheart from "../../assets/img/EMPTY-heart.svg";
import Heart from "../../assets/img/Heart.svg";
import loadingimage from "../../assets/img/loading-svg.svg";
//import { AppContext } from "../../context/AppContext";
import CurrencySymbols from "../../common/CurrencySymbol";
import { AppContext } from "../../context/AppContext";
import { logDOM } from "@testing-library/react";
import CommonPreviousInvoiceComponent from "../Account/CommonPreviousInvoiceComponent";
import QuickbookSyncMessageComponent from "../StoreConfig/QuickbookSyncMessageComponent";
import DeleteConfirmationModalBanner from "../Modal/DeleteConfirmation";
import CustomerConfirm from "../Modal/CustomerConfirm";
import { Height } from "@mui/icons-material";

// import { Noimage } from '../../common/imagePath';

const PosPage = () => {
  const paramObject = useParams();
  const inputRef = useRef(null);
  const qtyselectRef = useRef(null);
  const searchResultRef = useRef(null);
  let saleId = Number(paramObject?.saleId || 0);
  const navigate = useNavigate();
  console.log(paramObject, "paramObject");

  const {
    registerId,
    fetchData: appconfigdatafetch,
    isManagePOSSale,
    showEmployeeRegister,
    showPosTakePayment,
    SaleQuickPermision,
    AllowQBSync,
    enableAOSForItemAndVariation,
  } = useContext(AppContext);

  console.log(isManagePOSSale, typeof isManagePOSSale, "isManagePOSSale1111");

  const cloneSaleId = localStorage.getItem("Clone") || 0;
  console.log(cloneSaleId, "cloneSaleId");
  console.log(enableAOSForItemAndVariation, "enableAOSForItemAndVariation");

  const searchParams = new URLSearchParams(window.location.search);
  const iParam = searchParams.get("i");
  console.log(iParam, "iParam");

  const globalSearchItemInputRef = useRef(null);
  const searchItemInputRef = useRef(null);
  const searchCartQtyInputRef = useRef(null);
  const MySwal = withReactContent(Swal);
  let PERMISSION_LOOKUPRECEIPT = "/sales-receipt";
  let PERMISSION_ALLRECEIPT = "/sales-all-receipt";
  let PERMISSION_SALE_CUSTOMREPORT = "/custom_search_report";
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  let LatestData = [];
  let updatedData = [];
  const totalRef = useRef(0);
  const token = localStorage.getItem("Token") || "";
  const Location = localStorage.getItem("Location") || 0;
  const LoginId = localStorage.getItem("ID") || 0;
  const Name = localStorage.getItem("Name");
  const EmailId = localStorage.getItem("EmailId");

  const [showMenu, setShowMenu] = useState("Category");
  const [globalFilterInput, setGlobalFilterInput] = useState("");
  const [loading, setLoading] = useState(true);
  const [skeletonLoading, setSkeletonLoading] = useState(false);
  const [saleByIdLoader, setSaleByIdLoader] = useState(true);
  const userRegisterId = localStorage.getItem("UserRegisterId") || 0;
  const masterRegisterId = localStorage.getItem("MasterRegisterId") || 0;
  const [balanceLading, setBalanceLoading] = useState(false);
  const [moduleopen, setModuleopen] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  // REMOVE this: const [allowToShowAOS, setAllowToShowAOS] = useState(false);

  const [aosOpenByItem, setAosOpenByItem] = useState({}); // { "id:variationId": true }
  const [priceOpenByItem, setPriceOpenByItem] = useState({}); // { "id:variationId": true }

  const itemKey = (cat) => `${cat?.id ?? ""}:${cat?.variationId ?? ""}`;

  const openAosFor = (cat) => {
    // fetch once per item then mark it open
    handleFetchCustAOCCard(customerId, cat?.id, cat?.variationId);
    setAosOpenByItem((prev) => ({ ...prev, [itemKey(cat)]: true }));
  };

  const togglePriceFor = (cat) => {
    const key = itemKey(cat);
    setPriceOpenByItem((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // const [QBpermission, setqbpermission] = useState(true);
  console.log(balanceLading, "balanceLading45454");
  console.log(moduleopen, "moduleopen");

  const [category, setCategory] = useState([]);

  const [tags, setTags] = useState([]);

  const [brands, setBrands] = useState([]);

  const [favouriteList, setFavouriteList] = useState([]);

  const [mainFilterData, setMainFilterData] = useState([]);
  const [data, setdata] = useState([]);

  const [backToMenu, setBackToMenu] = useState([]);

  console.log(backToMenu, "backToMenu123");
  console.log(favouriteList, "favouriteList");

  const [cartData, setCartData] = useState([]);

  // draft List state
  const [holdList, setHoldList] = useState([]);
  const [holdListCount, setHoldListCount] = useState(0);

  console.log(cartData, "cartData654654");
  console.log(holdList, "holdList");

  const [customerDetail, setCustomerDetail] = useState({
    Id: 0,
    CompanyName: "",
    FirstName: "",
    LastName: "",
    Email: "",
    PhoneNumber: "",
    Address1: "",
    Address2: "",
    City: "",
    StateProvince: "",
    Zip: "",
    Country: "",
    Route: "",
    Image: "",
    QuickbookID: 0,
    Balance: "",
    IsSubCustomer: 0,
    CustomerType: "",
    Terms: 0,
    TermsQuickBookId: 0,
    label: "",
    value: 0,
    DeliveryFees: 0,
    IsCustomerHasInternalNote: 0,
    InternalNotes: "",
  });
  const [custOptions, setCustOptions] = useState([]);
  const [customerId, setCustomerId] = useState(0);
  const [CustomerPopup, setCustomerPopup] = useState(false);

  const [Module, setmodule] = useState("");
  const [accountsData, setAccountsData] = useState([]);
  console.log(customerId, "customerDetail123");

  const [shippingAddressOption, setShippingAddressOption] = useState([]);
  const [shippingAddressId, setShippingAddressId] = useState(0);
  const [show, setShow] = useState(false);
  const [salesOpenBlanace, setSalesOpenBlanace] = useState([]);

  const [salequickbookid, setSaleQuickbookId] = useState(0); // sync test return memo
  console.log(shippingAddressOption, shippingAddressId, "swdjcvnsdjknjksd465");

  // Update Customer Update Model Section State //
  const [customerShippingUpdateData, setCustomerShippingUpdateData] = useState(
    {}
  );
  const [shippingUpdateOptionId, setShippingUpdateOptionId] = useState(0);

  const [variationlistData, setVariationlistData] = useState([]);
  const [variationFilterValue, setVariationFilterValue] = useState("");

  const [cartPriceRuleSelect, setCartPriceRuleSelect] = useState(3);
  const [itemPriceRuleSelect, setItemPriceRuleSelect] = useState(3);

  const [cartTierPriceList, setCartTierPriceList] = useState([]);
  const [cartTierPriceSelect, setCartTierPriceSelect] = useState(0);
  const [itemTierPriceSelect, setItemTierPriceSelect] = useState(0);

  const [newCartBulkQty, setNewCartBulkQty] = useState("");
  const [newCartBulkPrice, setNewCartBulkPrice] = useState("");

  const [cartItemFilterInput, setcartItemFilterInput] = useState("");
  const [cartCategoryFilterSelect, setCartCategoryFilterSelect] = useState(0);
  const [cartCategoryFilterData, setCartCategoryFilterData] = useState([]);

  const [intervalId, setIntervalId] = useState(null);
  const [toggleItemsFilterSection, setToggleItemsFilterSection] =
    useState(false);

  const [selectedIndex, setSelectedIndex] = useState();
  const [isPriceChange, setIsPriceChange] = useState(0);
  const [customerBalance, setCustomerBalance] = useState(0);
  const [selectqty, setselectqty] = useState(true);

  const [showCustomerBalance, setShowCustomerBalance] = useState(false);
  const [showCustomerAOS, setShowCustomerAOS] = useState(false);
  // use for input section
  const [finalData, setFinalData] = useState({
    FinalGstType: "Percentage",
    FinalGstValue: "",
    FinalShipValue: "",
    FinalDisType: "Percentage",
    FinalDisValue: "",
  });

  // use  for Final Calculation
  const [finalAmountData, setFinalAmountData] = useState({
    subtotal: 0,
    totalDiscount: 0,
    totalTax: 0,
    extraDiscountAmount: 0,
    shipping: 0,
    total: 0,
  });
  const [cartTotalQty, setCartTotalQty] = useState(0);
  const [checkErrorData, setCheckErrorData] = useState(false);
  const [extraPaymentAmount, setExtraPaymentAmount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState({
    label: "Cash",
    value: 1,
    paymentquickbookid: 14,
  });
  const [reciptModel, setReciptModel] = useState(false);
  const [CompanyData, setCompanyData] = useState("");
  const [saleTypeMethod, setSaleTypeMethod] = useState([0]); // Store options
  const [deliveryMethodId, setDeliveryMethodId] = useState(0); // 1
  const [deliveryMethodName, setdeliveryMethodName] = useState("");

  console.log(deliveryMethodId, "deliveryMethodId");
  console.log(saleTypeMethod, deliveryMethodId, "deliveryMethodId");

  const [salePOSId, setSalePOSId] = useState(0);
  const [salesOpenBalance, setSalesOpenBalance] = useState(0);
  const [salesPreviousAmount, setPreviousAmount] = useState(0);
  const [term, setTerm] = useState([]);
  const [selectedTerm, setSelectedTerm] = useState(1);
  const [saleIsVoid, setSaleIsVoid] = useState(0);
  const [salesQuickbookId, setSalesQuickbookId] = useState(0);
  const [selectedTermQuickBookID, setSelectedTermQuickBookID] = useState(0);
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  // const [CurrentDate, setCurrentDate] = useState(moment().format("YYYY-MM-DD"));
  const [dueDate, setDueDate] = useState(moment().format("YYYY-MM-DD"));
  const [runApi, setRunApi] = useState(false);
  const [showAdvanceFilter, setShowAdvanceFilter] = useState(false);
  const [advanceItemFilterInput, setAdvanceItemFilterInput] = useState({
    ItemQty: 0,
    ItemPrice: 0,
  });

  const [salesDeliveryData, setSalesDeliveryData] = useState({});

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [itemSelectAllButton, setItemSelectAllButton] = useState(false);

  const [filterAllStockData, setFilterAllStockData] = useState(true);
  const [Saletype, setSaletype] = useState([]);

  const [selectedtags, setSelectedtags] = useState(""); // Initialize as an empty array for selected tags
  const [tag, setTag] = useState([]);
  let tagOptions = [];

  tagOptions = tag.map((u) => ({
    label: u.Name,
    value: u.ID,
  }));

  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  const handleTagChange = (selectedOptions, action) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)?.join(",")
      : "";

    setSelectedtags(selectedValues);
    console.log("Selected Tags:", selectedValues);
  };

  const handleCustomerPospup = (value) => {
    console.log(value, "value in handleCustomerPospup");

    if (value === "Ok") {
      if (Module == "Customer") {
        setCustomerId(0);
        setCustomerDetail({});
        setShippingAddressId(0);
      } else {
        setCartData([]);
      }
    }

    setCustomerPopup(!CustomerPopup);
  };

  const [tooltipValue, setTooltipValue] = useState({
    id: null,
    variationId: null,
    value: null,
    type: null,
  });

  console.log(extraPaymentAmount, "extraPaymentAmount");
  console.log(checkErrorData, "checkErrorData");

  // Store tooltip index and value
  const [tooltipStates, setTooltipStates] = useState({});
  const tooltipRef = useRef(null);
  const tooltipRefPrice = useRef(null);
  const tooltipRefSum = useRef(null);

  const [opentooltip, setopentooltip] = useState(false); // Default is closed
  // const [opentooltipprice, setopentooltipprice] = useState(false); // Default is closed
  // const pTagRef = useRef(null);
  // const pTagRefprice = useRef(null);

  const [openTooltipIndex, setOpenTooltipIndex] = useState(null);
  const [openTooltipIndexPrice, setOpenTooltipIndexPrice] = useState(null);
  const [openTooltipIndexSum, setopenTooltipIndexSum] = useState(null);
  const [tempQty, setTempQty] = useState({}); // Track which tooltip is open
  const [tempPrice, setTempPrice] = useState({}); // Track which tooltip is open
  const [tempSum, settempSum] = useState({}); // Track which tooltip is open
  const [showAosPrice, setShowAosPrice] = useState(false);
  const [showAosPriceButton, setShowAosPriceButton] = useState(true);

  console.log(tempSum, "temp check tempSum");
  console.log(tempPrice, "temp check tempPrice");
  console.log(tempQty, "temp check tempQty");

  const [QBpermission, setqbpermission] = useState(true);

  const handlepermission = () => {
    axios
      .get(`${config.salesconfigBaseUrl}/sales/quickbookpermission`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res.data.ResponseData[0].AppConfigvalue, "123");
        if (res.data.ResponseData[0].AppConfigvalue == "false") {
          setqbpermission(false);
        } else {
          setqbpermission(true);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    handlepermission();
  }, []);
  // const tooltipRef = useRef(null);
  console.log(tempQty, "tempQty123");

  // const handlepermission = () => {
  //   axios
  //     .get(`${config.salesconfigBaseUrl}/sales/quickbookpermission`, {
  //       headers: {
  //         "Content-Type": "application/json;charset=UTF-8",
  //         Authorization: token,
  //       },
  //     })
  //     .then((res) => {
  //       console.log(res.data.ResponseData[0].AppConfigvalue, "123");
  //       if (res.data.ResponseData[0].AppConfigvalue == "false") {
  //         setqbpermission(false);
  //       } else {
  //         setqbpermission(true);
  //       }
  //     })
  //     .catch((err) => {});
  // };

  useEffect(() => {
    handlepermission();
  }, []);

  const handleConfirm = (index, closeModelOpen = true, findindex) => {
    handelcartList(tempQty[index], findindex, "cartQty");
    setOpenTooltipIndex(null);

    setTempQty((prevTempSum) => {
      const updatedTempSum = { ...prevTempSum };
      delete updatedTempSum[index];
      return updatedTempSum;
    });
    setTimeout(() => {
      if (closeModelOpen) {
        setModuleopen(false);
      }
    }, 500);
  };

  const handleConfirmPrice = (index, closeModelOpen = true, findindex) => {
    handelcartList(tempPrice[index], findindex, "cartPrice");
    setTempPrice((prevTempSum) => {
      const updatedTempSum = { ...prevTempSum };
      delete updatedTempSum[index];
      return updatedTempSum;
    });
    setOpenTooltipIndexPrice(null);
    setTimeout(() => {
      if (closeModelOpen) {
        setModuleopen(false);
      }
    }, 500);
  };

  const handleConfirmSum = (index, closeModelOpen = true, findIndex) => {
    const newPrice = tempSum[index];
    if (newPrice !== undefined) {
      handleInputSumChange(newPrice, findIndex);
      settempSum((prevTempSum) => {
        const updatedTempSum = { ...prevTempSum };
        delete updatedTempSum[index];
        return updatedTempSum;
      });
      setopenTooltipIndexSum(null); // Close tooltip
    }
    setTimeout(() => {
      if (closeModelOpen) {
        setModuleopen(false);
      }
    }, 500);
  };

  const handleCancelSum = (index) => {
    // Cancel and reset
    // settempSum((prevTempSum) => ({ ...prevTempSum, [index]: cat.cartPrice }));
  };

  const handleInputChange = (value, index, item) => {
    // const value = e.target.value;

    let findIndex = item?.variationId > 0 ? item?.variationId : item?.id;
    setTempQty({
      ...tempQty,
      [findIndex]: value === "" ? "" : value,
    });
  };

  const handleInputPriceChange = (value, index, item) => {
    // const value = e.target.value;
    if (value === "" || !isNaN(value)) {
      let findIndex = item?.variationId > 0 ? item?.variationId : item?.id;
      setTempPrice({
        ...tempPrice,
        [findIndex]: value === "" ? "" : value,
      });
    }
  };

  const handleInputSumChange = (newTotalSum, index) => {
    if (!isNaN(newTotalSum)) {
      // Update the cart price based on the new total sum without affecting quantity
      setCartData((prevCartData) => {
        const updatedCart = [...prevCartData];
        const baseQty = updatedCart[index].cartQty || 1;
        const newPrice = newTotalSum / baseQty;
        // toastSuccess(newPrice + " newPrice");
        const newTotal = newPrice * baseQty;

        let discountAmount = 0;
        if (updatedCart[index].cartDiscountType === "percent") {
          discountAmount =
            (newTotalSum * updatedCart[index].cartDiscount) / 100;
        } else if (updatedCart[index].cartDiscountType === "amount") {
          discountAmount = Number(updatedCart[index].cartDiscount || 0);
        } else {
          discountAmount = Number(updatedCart[index].cartDiscount || 0); // fallback
        }

        // Update only the price in the cart data
        // updatedCart[index].cartSubTotal = (newTotal).toFixed(2);
        updatedCart[index].cartSubTotal = newTotal.toFixed(2);
        updatedCart[index].cartTotal = (newTotalSum - discountAmount).toFixed(
          2
        ); // newPrice.toFixed(2);
        updatedCart[index].cartPrice = newPrice;

        return updatedCart;
      });

      // Update temporary sum for the UI display
      settempSum((prevTempSum) => ({
        ...prevTempSum,
        [index]: newTotalSum,
      }));
    }
  };

  const handleQuantityChange = (index, type) => {
    const adjustQuantity = () => {
      setTempQty((prevTempQty) => {
        const currentQty = prevTempQty[index] || 0;
        const newQty =
          type === "increase" ? Number(currentQty) + 1 : Number(currentQty) - 1;
        return {
          ...prevTempQty,
          [index]: newQty,
        };
      });
    };
    const id = setInterval(adjustQuantity, 200); // Adjust speed with the interval time
    setIntervalId(id);

    adjustQuantity();
  };

  const handlePriceChange = (index, type) => {
    const adjustPrice = () => {
      setTempPrice((prevTempPrice) => {
        const currentPrice = prevTempPrice[index] || 0;
        const newPrice =
          type === "increase"
            ? Number(currentPrice) + 1
            : Number(currentPrice) - 1;
        return {
          ...prevTempPrice,
          [index]: Number(newPrice).toFixed(2),
        };
      });
    };
    const id = setInterval(adjustPrice, 200); // Adjust speed with the interval time
    setIntervalId(id);

    adjustPrice();
  };

  const handleSumChange = (index, type) => {
    settempSum((prevTempSum) => {
      const currentSum = Number(prevTempSum[index] || 0);
      const newSum = type === "increase" ? currentSum + 1 : currentSum - 1;
      return {
        ...prevTempSum,
        [index]: newSum >= 0 ? newSum : 0, // Prevent negative values
      };
    });
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setOpenTooltipIndex(null); // Close all tooltips on outside click
        setModuleopen(false);
        setTempQty({});
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        tooltipRefPrice.current &&
        !tooltipRefPrice.current.contains(e.target)
      ) {
        setOpenTooltipIndexPrice(null); // Close the tooltip if clicked outside
        setModuleopen(false);
        setTempPrice({});
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (tooltipRefSum.current && !tooltipRefSum.current.contains(e.target)) {
        setopenTooltipIndexSum(null); // Close the tooltip if clicked outside
        setModuleopen(false);
        settempSum({});
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    appconfigdatafetch();
    function handleClickOutside(event) {
      if (
        searchResultRef.current &&
        !searchResultRef.current.contains(event.target)
      ) {
        setSuggestions([]);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchResultRef]);

  console.log(opentooltip, "opentooltip");

  console.log(selectedTerm, "Saletype");
  const [accountSaleData, setAccountSaleData] = useState({
    InvoiceMessage: "",
    InvoiceStatement: "",
    Attachment: "",
    InvoiceNumber: 0,
    comment: "",
  });

  console.log(accountSaleData, "accountSaleData123");

  const [FileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [btnFileLoader, setBtnFileLoader] = useState({ Receipt: false });
  const [changeFileName, setChangeFileName] = useState(false);

  const [localValues, setLocalValues] = useState();
  const [referenceNumber, setReferenceNumber] = useState("");
  const [depositTo, setDepositTo] = useState(0);
  const [depositToAccountQuickbookId, setDepositToAccountQuickbookId] =
    useState(0);
  const [showDepositToError, setShowDepositToError] = useState(false);
  const [totalReceivingAmount, setTotalReceivingAmount] = useState(0);
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const [memoData, setMemoData] = useState("");
  // const [previosdata, setpreciosdata] = useState([]);
  console.log(accountSaleData, "accountSaleData");
  const [saleTypeId, setSaleTypeId] = useState(1);
  const [AmountPaid, setAmountPaid] = useState(0);
  const [saleOptions, setSaleOptions] = useState([]);
  const [selectedSaleOption, setSelectedSaleOption] = useState("Sale");
  const [radioOption, setRadioOption] = useState("unapplied");
  console.log(AmountPaid, "AmountPaidAmountPaid");

  const handleSaleTypeChange = (id, name) => {
    setSaleTypeId(id);
    setSelectedSaleOption(name);
    BindInvoiceDropdown(id);
  };

  const AddMessageInvoice = (e) => {
    e.preventDefault();
    console.log("Submitted Invoice Message:", accountSaleData.InvoiceMessage);
  };

  const handleChangeAccountSalesData = (e) => {
    const { name, value } = e.target;
    setAccountSaleData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // const [openTooltipIndex, setOpenTooltipIndex] = useState({});
  const [openTooltipPriceIndex, setOpenTooltipPriceIndex] = useState({});

  // Toggle tooltip visibility for quantity
  const handleToggleTooltip = (index) => {
    setOpenTooltipIndex((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the current index
    }));
  };

  // Toggle tooltip visibility for price
  const handleToggleTooltipPrice = (index) => {
    setOpenTooltipPriceIndex((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle the current index
    }));
  };

  // Close all tooltips when needed
  const closeTooltips = () => {
    setOpenTooltipIndex({});
    setOpenTooltipPriceIndex({});
  };
  console.log(registerId, "registerId");

  useEffect(() => {
    if (
      userRegisterId == 0 &&
      isManagePOSSale == 1 &&
      showEmployeeRegister == "true"
    ) {
      navigate("/posregister?type=create");
    }
  }, []);

  const [showItemMoreDetails, setShowItemMoreDetails] = useState(false);
  const [itemDetailModelId, setItemDetailModelId] = useState(0);

  const [showHistoryList, setShowHistoryList] = useState(false);

  const [startScannerCamera, setStartScannerCamera] = useState(false);

  const [isChecked, setIsChecked] = useState(false);
  const [searchBar, SetSearchBar] = useState(false);
  const [changeImagename, setChangeImagename] = useState(false);
  const [Label, setLabel] = useState(false);
  const [companyname, setcompanyname] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [cursor, setcursor] = useState(0);
  const [locationDropdown, setLocationDropdown] = useState([]);
  const [selectedlocation, setSelectedLocation] = useState(0);
  const [selectedCustomerAvgAOS, setSelectedCustomerAvgAOS] = useState(0);

  const timeRef = useRef(null);

  const handleWarehouse = (e) => {
    console.log(e, "event");
    localStorage.setItem("Location", e.value);
    setSelectedLocation(e.value);
    // setLoading(true);
    axios
      .post(
        `${config.authenticationBaseUrl}/users/locationupsert`,
        {
          loginuserid: LoginId,
          locationid: e.value,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
    // setLoading(false);
  };

  useEffect(() => {
    if (Label == true) {
      setChangeImagename(false);
    }
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const filteredData = res.data.ResponseData?.filter((el) =>
          locationarray?.includes(el?.Id)
        );
        console.log(filteredData, "filteredDatadropdown");
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const location = localStorage.getItem("Location");
  const locationvariable = JSON.parse(localStorage.getItem("LocationVariable"));
  const locationarray =
    locationvariable?.LocationID !== undefined
      ? locationvariable?.LocationID?.split(",")
      : [];

  let locationDropdownOption = [];
  const Dropdown = locationDropdown.map((u, i) => {
    if (
      locationarray?.includes(`${u.Id}`) &&
      !locationvariable?.isSPAdmin !== "true"
    )
      locationDropdownOption[i] = { label: u.Name, value: u.Id };
  });

  useEffect(() => {
    setSelectedLocation(location);
  }, [location]);

  const handleInputChangeGlobalSearch = (event) => {
    const value = event.target.value;
    setInputValue(event.target.value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const fetchDataGloabalSearch = async () => {
    if (inputValue != "") {
      setSkeletonLoading(true);
      axios
        .get(
          `${config.generalBaseUrl}/generals/globalsearch?inputvalue=${inputValue}&loginuserId=${LoginId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          const data = response.data.ResponseData;
          setSuggestions(data);
          setSkeletonLoading(false);
        })
        .catch((error) => {});
    } else {
      setSuggestions([]);
      setSkeletonLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchDataGloabalSearch(inputValue);
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [inputValue]);

  useEffect(() => {
    const updateTime = () => {
      timeRef.current.innerText = moment().format("MM/DD/YYYY h:mm A");
    };
    updateTime();
    const intervalId = setInterval(updateTime, 1000);

    return () => clearInterval(intervalId);
  }, []);

  console.log(
    typeof registerId,
    typeof isManagePOSSale,
    Number(registerId),
    "isManagePOSSale"
  );

  const signOut = () => {
    if (Number(userRegisterId) > 0 && Number(isManagePOSSale) === 1) {
      // toastError("error");
      setTimeout(() => {
        navigate(`/posregister?type=close&Id=${userRegisterId}`);
      }, 500);
    } else {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/login"; // Forces full page reload
    }
  };

  // const callbackItemGrid = (payload) => {
  //   console.log(payload, "payload=>8789745561421");

  //   // handleFetchCustAOC(customerId, payload?.ItemId, payload?.VariationId);

  //   // setCartData((prev) => {
  //   //           const updatedCart = prev.map((cartItem) => {
  //   //             if (
  //   //               cartItem.id === responseItem.ItemID &&
  //   //               cartItem.variationId === responseItem.ItemVariationID
  //   //             ) {
  //   //               return {
  //   //                 ...cartItem,
  //   //                 AvgUnitPrice: responseItem.AvgUnitPrice,
  //   //                 AvgQuantity: responseItem.AvgQuantity,
  //   //               };
  //   //             }
  //   //             return cartItem;
  //   //           });

  //   //           return updatedCart;
  //   //         });

  //   setCartData((prev) => {
  //     let updatedCart = [...prev];

  //     payload.forEach((item, index) => {
  //       const existingItemIndex = updatedCart.findIndex(
  //         (cartItem) =>
  //           cartItem.id === item.ItemId &&
  //           cartItem.variationId === item.VariationId
  //       );

  //       if (existingItemIndex > -1) {
  //         // toastSuccess("update call", updatedCart[existingItemIndex]?.ItemId);
  //         // If the item already exists, update its quantity and price
  //         const updatedObject = {
  //           ...updatedCart[existingItemIndex],
  //           cartQty:
  //             Number(item.newQty) +
  //             Number(updatedCart[existingItemIndex]?.cartQty),
  //           cartPrice: item.RecallPrice || 0,
  //           cartSubTotal:
  //             (item.RecallPrice || 0) *
  //             (Number(item.newQty) +
  //               Number(updatedCart[existingItemIndex]?.cartQty)),
  //           cartTotal:
  //             (item.RecallPrice || 0) *
  //             (Number(item.newQty) +
  //               Number(updatedCart[existingItemIndex]?.cartQty) -
  //               Number(updatedCart[existingItemIndex]?.cartTotalDiscount)),
  //         };

  //         const filterArray = updatedCart?.filter(
  //           (_, i) => i != existingItemIndex
  //         );
  //         updatedCart = [updatedObject, ...filterArray];
  //       } else {
  //         updatedCart.unshift({
  //           id: item.ItemId,
  //           src: "",
  //           alt: "",
  //           title: item.ItemName,
  //           itemsCount: 0,
  //           ParentId: 0,
  //           type: "Product",
  //           IsShowEcommerceMenu: 1,
  //           isInCart: false,
  //           cartQty: item.newQty == 0 ? 1 : item.newQty,
  //           cartPrice: item.RecallPrice || 0,
  //           Tier1Price: item.Tier1,
  //           Tier2Price: item.Tier2,
  //           Tier3Price: item.Tier3,
  //           Tier4Price: item.Tier4,
  //           Tier5Price: item.Tier5,
  //           RecallPrice: item.RecallPrice || 0,
  //           UnitPrice: item.UnitPrice,
  //           variationId: item.VariationId,
  //           cartDiscountType: "percent",
  //           cartDiscount: 0,
  //           cartTaxType: "Percentage",
  //           cartTax: 0,
  //           cartTotal: Number(item?.newQty) * Number(item?.RecallPrice || 0),
  //           cartSubTotal: Number(item?.newQty) * Number(item?.RecallPrice || 0),
  //           cartTotalDiscount: 0,
  //           cartTotalTax: 0,
  //           CategoryID: item.CategoryID,
  //           CategoryName: item.CategoryName,
  //           CostPrice: item.CostPrice,
  //           QuickBookId: item.itemquickbookid,
  //           CurrantQTY:
  //             item.VariationId > 0
  //               ? item?.VariationQuantity
  //               : item?.Itemquantity,
  //           rowIndex: cartData?.length + index + 1,
  //           isFavourite: false,
  //           // Itemnumber: item.Itemnumber,
  //           ItemNumber: item.Itemnumber,
  //         });
  //       }
  //     });

  //     return updatedCart;
  //   });
  // };

  // Helper: fetch AOC data for single item; returns the responseItem or null
  const handleFetchCustAOC = async (CustomerID, ItemID, VarID) => {
    if (!(CustomerID > 0)) return null;
    try {
      const res = await axios.get(
        `${config.salesconfigBaseUrl}/sales/customerAvgAoc?CustomerID=${CustomerID}&ItemID=${ItemID}&VarID=${VarID}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      );
      const responseItem = res.data.ResponseData?.[0] || null;
      return responseItem;
    } catch (err) {
      console.error("Error fetching Avg AOC:", err);
      return null;
    }
  };

  const handleFetchCustAOCCard = async (CustomerID, ItemID, VarID) => {
    if (!(CustomerID > 0)) return null;
    try {
      const res = await axios.get(
        `${config.salesconfigBaseUrl}/sales/customerAvgAoc?CustomerID=${CustomerID}&ItemID=${ItemID}&VarID=${VarID}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      );
      const responseItem = res.data.ResponseData?.[0];
      if (responseItem) {
        setCartData((prev) => {
          const updatedCart = prev.map((cartItem) => {
            if (
              cartItem.id === responseItem.ItemID &&
              cartItem.variationId === responseItem.ItemVariationID
            ) {
              return {
                ...cartItem,
                AvgUnitPrice: responseItem.AvgUnitPrice,
                AvgQuantity: responseItem.AvgQuantity,
              };
            }
            return cartItem;
          });
          return updatedCart;
        });
      }
    } catch (err) {
      console.error("Error fetching Avg AOC:", err);
      return null;
    }
  };

  const callbackItemGrid = async (payloadArray) => {
    if (!Array.isArray(payloadArray) || payloadArray.length === 0) return;

    console.log(payloadArray, "payload=>8789745561421");

    // First: upsert all items from payloadArray into cartData
    setCartData((prev) => {
      let updatedCart = [...prev];

      payloadArray.forEach((item, index) => {
        const itemId = item.ItemId;
        const variationId = item.VariationId;
        const existingIndex = updatedCart.findIndex(
          (ci) => ci.id === itemId && ci.variationId === variationId
        );

        const baseQty = Number(item.newQty) === 0 ? 1 : Number(item.newQty);
        const recallPrice = Number(item.RecallPrice || 0);

        if (existingIndex > -1) {
          const existing = updatedCart[existingIndex];
          const newQty = baseQty + Number(existing.cartQty || 0);
          const cartSubTotal = recallPrice * newQty;
          const cartTotal =
            recallPrice * (newQty - Number(existing?.cartTotalDiscount || 0));

          const updatedObject = {
            ...existing,
            cartQty: newQty,
            cartPrice: recallPrice,
            cartSubTotal,
            cartTotal,
            RecallPrice: recallPrice,
            UnitPrice: item.UnitPrice,
            Tier1Price: item.Tier1,
            Tier2Price: item.Tier2,
            Tier3Price: item.Tier3,
            Tier4Price: item.Tier4,
            Tier5Price: item.Tier5,
            CategoryID: item.CategoryID,
            CategoryName: item.CategoryName,
            CostPrice: item.CostPrice,
            QuickBookId: item.itemquickbookid,
            CurrantQTY:
              variationId > 0 ? item?.VariationQuantity : item?.Itemquantity,
            ItemNumber: item.Itemnumber,
          };

          // move updated item to front
          updatedCart = [
            updatedObject,
            ...updatedCart.filter((_, i) => i !== existingIndex),
          ];
        } else {
          // new insertion
          updatedCart.unshift({
            id: itemId,
            src: "",
            alt: "",
            title: item.ItemName,
            itemsCount: 0,
            ParentId: 0,
            type: "Product",
            IsShowEcommerceMenu: 1,
            isInCart: false,
            cartQty: baseQty,
            cartPrice: recallPrice,
            Tier1Price: item.Tier1,
            Tier2Price: item.Tier2,
            Tier3Price: item.Tier3,
            Tier4Price: item.Tier4,
            Tier5Price: item.Tier5,
            RecallPrice: recallPrice,
            UnitPrice: item.UnitPrice,
            variationId: variationId,
            cartDiscountType: "percent",
            cartDiscount: 0,
            cartTaxType: "Percentage",
            cartTax: 0,
            cartTotal: baseQty * recallPrice,
            cartSubTotal: baseQty * recallPrice,
            cartTotalDiscount: 0,
            cartTotalTax: 0,
            CategoryID: item.CategoryID,
            CategoryName: item.CategoryName,
            CostPrice: item.CostPrice,
            QuickBookId: item.itemquickbookid,
            CurrantQTY:
              variationId > 0 ? item?.VariationQuantity : item?.Itemquantity,
            rowIndex: prev?.length + index + 1,
            isFavourite: false,
            ItemNumber: item.Itemnumber,
          });
        }
      });

      return updatedCart;
    });

    // Then: for each item, fetch its AOC and merge asynchronously
    // for (const item of payloadArray) {
    //   const itemId = item.ItemId;
    //   const variationId = item.VariationId;

    //   const responseItem = await handleFetchCustAOC(
    //     customerId,
    //     itemId,
    //     variationId
    //   );
    //   if (responseItem) {
    //     setCartData((prev) => {
    //       return prev.map((cartItem) => {
    //         // Note: responseItem uses ItemID / ItemVariationID
    //         if (
    //           cartItem.id === responseItem.ItemID &&
    //           cartItem.variationId === responseItem.ItemVariationID
    //         ) {
    //           return {
    //             ...cartItem,
    //             AvgUnitPrice: responseItem.AvgUnitPrice,
    //             AvgQuantity: responseItem.AvgQuantity,
    //           };
    //         }
    //         return cartItem;
    //       });
    //     });
    //   }
    // }
  };

  console.log(selectedTerm, "selectedTerm123");

  const handleTermChange = (selectedOption) => {
    setSelectedTerm(selectedOption?.value || null);
    setSelectedTermQuickBookID(selectedOption?.QuickBookID || null);
    if (selectedOption?.actualValue == 0 || selectedOption?.actualValue > 0) {
      const newDueDate = moment(startDate).add(
        selectedOption.actualValue,
        "days"
      );
      setDueDate(newDueDate); // Convert moment object back to JavaScript Date
    }
  };

  // Handle changes in invoice date
  const handleChangeCustomStartingDate = (selectedDate) => {
    if (selectedDate) {
      setStartDate(selectedDate);

      // Recalculate due date if a term is selected
      if (selectedTerm) {
        const termDays =
          termOptions.find((option) => option.value === selectedTerm)
            ?.actualValue || 0;
        const newDueDate = moment(selectedDate).add(termDays, "days").toDate(); // Convert back to Date for setDueDate
        setDueDate(moment(newDueDate).format("YYYY-MM-DD"));
      }
    }
  };

  const handleChangeCustomEndingDate = (SelectedDate) => {
    if (SelectedDate && SelectedDate.length > 0) {
      setDueDate(SelectedDate);
    }
  };

  useEffect(() => {
    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/CompanyInformation`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res?.data, "###");
        setCompanyData(res.data.ResponseData[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getShippingAddressByCustomerId(customerId);
  }, [show]);

  console.log(reciptModel, "reciptModel");
  const unitType = [
    { value: "Percentage", label: "%" },
    { value: "Fixed", label: "$" },
  ];

  const defaultSellingPriceType = [
    {
      label: "Default Selling Price",
      value: 1, // unit price
    },
    {
      label: "Tier Price",
      value: 2, // tire price
    },
    {
      label: "Recall Price",
      value: 3, // recall
    },
  ];

  console.log(customerShippingUpdateData, "customerShippingUpdateData");
  console.log(customerDetail, "customerDetail");
  console.log(cartData, "cartDatalist");
  console.log(category, "categorylist");
  console.log(brands, showMenu, "brandslist");
  console.log(tags, showMenu, "tagsList");
  console.log(mainFilterData, showMenu, "mainFilterData");

  console.log(backToMenu, "backToMenu");

  const getCategoryData = async (catId) => {
    LatestData = [];
    await axios
      .post(
        `${config.ecommBackendBaseUrl}/general/categoryandsubcategorylisting`,
        { ParentID: catId }
      )
      .then((res) => {
        const finalData = res.data.ResponseData?.CategoryDetails.map((el) => {
          return {
            id: el.ID,
            src: el.Imagename,
            alt: el.Name,
            title: el.Name ? el.Name : "",
            itemsCount: el.ItemCount,
            ParentId: el.ParentId,
            type: "Category",
            IsShowEcommerceMenu: Number(el.IsShowEcommerceMenu),
            isInCart: false,
            cartQty: 0,
            cartPrice: 0,
            parentName: el.parentName ? el.parentName : "",
            // subCategory: res.data.ResponseData?.CategoryDetails?.filter(
            //   (cat) => cat.ParentId == el.ID
            // ) // Filter subcategories
            //   .map((subEl) => ({
            //     id: subEl.ID,
            //     src: subEl.Imagename,
            //     alt: subEl.Name,
            //     title: subEl.Name ? subEl.Name : "",
            //     itemsCount: subEl.ItemCount,
            //     ParentId: subEl.ParentId,
            //     IsShowEcommerceMenu: Number(subEl.IsShowEcommerceMenu),
            //   subCategory: []
            //   })), // Map subcategories with the same structure
          };
        });
        setCategory(finalData);
        LatestData = finalData;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getCatrgorySelectData = () => {
    axios
      .get(`${config.categoriesBaseUrl}/categories/categoriesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        const categorytypeDropdown = res.data.ResponseData.map((u, i) => {
          return {
            label: u.Name,
            value: u.ID,
          };
        });
        setCartCategoryFilterData(categorytypeDropdown);
      });
  };

  const getCustomerfavouriteitemslist = (custId) => {
    // setSkeletonLoading(true);
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/customerfavouriteitemslist?CustomerId=${custId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("Console From Sales ==>: ", res.data.ResponseData);
        const favouriteListData = res.data.ResponseData;
        const finalArray = favouriteListData?.map((item) => {
          const mappedItem = {
            id: Number(item.ItemID || 0),
            src: item.Image,
            alt: item.ItemName,
            title: item.ItemName,
            itemsCount: 0,
            ParentId: 0,
            type: "Product",
            IsShowEcommerceMenu: 1,
            isInCart: false,
            cartQty: 1,
            cartPrice:
              Number(item.RecallPrice || 0) > 0
                ? Number(item.RecallPrice || 0)
                : Number(item.Price || 0),
            Tier1Price: Number(item.Tier1Price || 0),
            Tier2Price: Number(item.Tier2Price || 0),
            Tier3Price: Number(item.Tier3Price || 0),
            Tier4Price: Number(item.Tier4Price || 0),
            Tier5Price: Number(item.Tier5Price || 0),
            RecallPrice: Number(item.RecallPrice || 0),
            UnitPrice: Number(item.UnitPrice || 0),
            variationId: Number(item.VariationID || 0),
            cartDiscountType: "percent",
            cartDiscount: 0,
            cartTaxType: "Percentage",
            cartTax: 0,
            cartTotal: 1 * Number(item.RecallPrice || 0),
            cartSubTotal: 1 * Number(item.RecallPrice || 0),
            cartTotalDiscount: 0, // by percentage
            cartTotalTax: 0,
            CategoryID: Number(item.CategoryID || 0),
            CostPrice: Number(item.CostPrice || 0),
            QuickBookId: Number(item.QuickBookId || 0), //item.SaleItemQuickbookId,
            CurrantQTY: Number(item.CurrantQTY || 0),
            ItemNumber: item.ItemNumber,
            isFavourite: true,
          };
          return mappedItem;
        });
        setFavouriteList(finalArray);
        // setSkeletonLoading(false);
      })
      .catch((err) => {
        console.log(err);
        // setSkeletonLoading(false);
      });
  };

  const getBrandsData = () => {
    LatestData = [];
    axios
      .get(`${config.brandBaseUrl}/brands/brandsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        const filterBrandData = res.data.ResponseData?.map((el) => {
          return {
            id: el.ID,
            src: el.Imagename,
            alt: el.Name,
            title: el.Name ? el.Name : "",
            itemsCount: el.Count,
            ParentId: 0,
            IsShowEcommerceMenu: 1,
            type: "Brands",
            isInCart: false,
            cartQty: 0,
            cartPrice: 0,
          };
        });

        LatestData = [...filterBrandData, ...LatestData];
        setBrands(filterBrandData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getTagsData = () => {
    LatestData = [];
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Portal`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        const filterBrandData = res.data.ResponseData?.map((el) => {
          return {
            id: el.ID,
            src: "",
            alt: el.Name,
            title: el.Name ? el.Name : "",
            itemsCount: el.ItemCount,
            ParentId: 0,
            IsShowEcommerceMenu: 1,
            type: "Tags",
            isInCart: false,
            cartQty: 0,
            cartPrice: 0,
          };
        });
        setTags(filterBrandData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getCustomerData = () => {
    setLoading(true);
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const customerOption = response.data.ResponseData?.map((el) => {
          return {
            ...el,
            label: el.CompanyName,
            value: el.Id,
            address: el.Address1,
            LastName: el.LastName,
            FirstName: el.FirstName,
            address2: el.Address2,
            City: el.City,
            StateProvince: el.StateProvince,
            Country: el.Country,
            email: el.Email,
            customerquickbookId: el.QuickbookID,
            PhoneNumber: el.PhoneNumber,
          };
        });
        setCustOptions([
          // { value: 0, label: "Walk in Customer" },
          ...customerOption,
        ]);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const getShippingAddressByCustomerId = (custID) => {
    setLoading(true);
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/ShiipingAdresssbyID?CustomerID=${custID}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const shippingDataOptions = res.data.ResponseData?.map((el) => {
          return {
            ...el,
            label: [
              el.Address1,
              el.Address2,
              el.City,
              el.StateProvince,
              el.Zip,
              el.Country,
            ]
              .filter(Boolean)
              .join(", "),
            value: el.ID,
            LastSaleAddressID: el.LastSaleAddressID,
          };
        });
        setShippingAddressOption(shippingDataOptions);

        if (saleId == 0) {
          //&& shippingAddressId == 0
          setShippingAddressId(
            shippingDataOptions?.find((item) => item.ShippingDefault == 1)
              ?.value ||
              shippingDataOptions?.find(
                (item) => Number(item.LastSaleAddressID) > 0
              )?.LastSaleAddressID ||
              ""
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setLoading(false);
  };

  const getCustomerBalanceById = (custID) => {
    setBalanceLoading(true);
    axios
      .get(
        `${config.customersBaseUrl}/customers/customerbalancebyid?id=${custID}&location=${Location}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(
          res?.data?.ResponseData[0]?.OpenBalance,
          "customer balance data"
        );
        const customerBalance = res?.data?.ResponseData[0]?.OpenBalance || 0;
        setCustomerBalance(customerBalance);
        setBalanceLoading(false);
        setLoading(false);
      })
      .catch((err) => {
        setBalanceLoading(false);
        setLoading(false);
      });
  };

  const checkBalance = () => {
    setShowCustomerBalance(true);
    getCustomerBalanceById(customerId);
  };

  const getRoleTierData = () => {
    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/Roletierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        // console.log(response.data?.ResponseData, "response of tire list")
        const tierData = response.data?.ResponseData?.map((tire) => ({
          label: tire.Name,
          value: tire.Code,
          id: tire.ID,
        }));
        setCartTierPriceList(tierData);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const getSaleById = () => {
    if (saleId > 0 || cloneSaleId > 0) {
      let saleIdApi = saleId > 0 ? saleId : cloneSaleId;
      setSaleByIdLoader(true);
      axios
        .get(`${config.salesconfigBaseUrl}/sales/findbyid?id=${saleIdApi}`, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        })
        .then((res) => {
          localStorage.removeItem("Clone");
          console.log("Console From Sales ==>: ", res.data.ResponseData);
          const SuspendedData = res.data.ResponseData.unSuspendData[0];
          const PaymentData = res.data.ResponseData.paymentData;
          const TaxData = res.data.ResponseData.TaxData;
          const SalesItem = res.data.ResponseData.SalesItems;
          const CustomerDetails = res.data.ResponseData.CustomerDetails[0];
          const SalesDeliveryDetails =
            res.data.ResponseData.SalesDeliveryDetails[0];

          console.log(SuspendedData, "CustomerDetails");
          setSaleTypeId(SuspendedData?.Type);
          setAmountPaid(
            SuspendedData?.AmountPaid == "0.00" ? 0 : SuspendedData?.AmountPaid
          );
          setSelectedSaleOption(SuspendedData?.SalesType);
          setCustomerId(CustomerDetails?.Id);
          getShippingAddressByCustomerId(CustomerDetails?.Id);
          getCustomerfavouriteitemslist(CustomerDetails?.Id);
          const customerFilterData = {
            // Id: CustomerDetails?.Id,
            // CompanyName: CustomerDetails?.CompanyName,
            // FirstName: CustomerDetails?.FirstName,
            // LastName: CustomerDetails?.LastName,
            // Email: CustomerDetails?.Email,
            // PhoneNumber: CustomerDetails?.PhoneNumber,
            // Address1: Address1,
            // Address2: "",
            // City: "TALLAHASSEE",
            // StateProvince: "Fl",
            // Zip: "32308",
            // Country: "USA",
            // QuickbookID: 10,
            // Image: "",
            // Balance: "1562991.7500000000",
            // Terms: "0",
            // Route: "OUT OF STATE",
            // IsSubCustomer: 0,
            // TermsQuickBookId: 0,
            ...CustomerDetails,
            CustomerType: "Customer",
            label: CustomerDetails?.CompanyName,
            value: CustomerDetails?.Id,
            DeliveryFees: Number(SalesDeliveryDetails?.DeliveryFees || 0),
          };
          setCustomerDetail(customerFilterData);

          // add items on the cart
          console.log(SalesItem, "salesitem");
          const mappedSaleItems = SalesItem.map((item, index) => {
            const mappedItem = {
              id: Number(item.ItemId || 0),
              src: item.ImageName,
              alt: item.Items,
              title: item.Items,
              itemsCount: 0,
              ParentId: 0,
              type: "Product",
              IsShowEcommerceMenu: 1,
              isInCart: true,
              cartQty: Number(item.itemquantity || 0),
              cartPrice: Number(item.Price || 0),
              Tier1Price: Number(item.Tier1 || 0),
              Tier2Price: Number(item.Tier2 || 0),
              Tier3Price: Number(item.Tier3 || 0),
              Tier4Price: Number(item.Tier4 || 0),
              Tier5Price: Number(item.Tier5 || 0),
              RecallPrice: Number(item.RecallPrice || 0),
              UnitPrice: Number(item.UnitPrice || 0),
              variationId: Number(item.VariationId || 0),
              // cartDiscountType: "Percentage",
              cartDiscount: Number(item.itemdiscount || 0),
              cartTaxType: "Percentage",
              cartTax: 0,
              cartTotal: Number(item.Total || 0),
              cartSubTotal:
                Number(item.itemquantity || 0) * Number(item.Price || 0),
              cartTotalDiscount:
                item.DiscountType == "percent"
                  ? (Number(item.itemquantity || 0) *
                      Number(item.Price || 0) *
                      Number(item.itemdiscount || 0)) /
                    100
                  : Number(item.itemdiscount || 0), // by percentage
              cartTotalTax: 0,
              CategoryID: Number(item.CategoryID || 0),
              CostPrice: Number(item.CostPrice || 0),
              QuickBookId: Number(item.QuickbookID || 0), //item.SaleItemQuickbookId,
              CurrantQTY: Number(item.ItemCurrentQuantity || 0),
              ItemNumber: item.Itemnumber,
              rowIndex: index + 1,
              SaleItemID: cloneSaleId > 0 ? 0 : Number(item.SaleItemID || 0), // added
              SaleItemQuickbookId:
                cloneSaleId > 0 ? 0 : Number(item.SaleItemQuickbookId || 0), // added
              isFavourite: false,
              cartDiscountType: item.DiscountType,
            };

            console.log(mappedItem, "mappedItemcheck");

            // SaleItemID: Clone > 0 ? 0 : item.SaleItemID,
            // ItemId: item.ItemId,
            // SaleId: Clone > 0 ? 0 : item.SaleId,
            // UnitPrice: parseFloat(item.UnitPrice),
            // Price: parseFloat(item.Price),
            // RecallPrice: parseFloat(item.RecallPrice),
            // ItemName: item.Items,
            // itemquantity: parseFloat(item.itemquantity),
            // itemdiscount: parseFloat(item.itemdiscount),
            // CostPrice: parseFloat(item.CostPrice),
            // Ischecked: item.Ischecked,
            // Total: parseFloat(item.Total),
            // Module: item.Module,
            // Itemkitid: item.ItemKitId,
            // VariationName: item.VariationName,
            // // locationid: selectedLocation,
            // locationid: Location,
            // ItemCurrentQuantity: parseFloat(item.ItemCurrentQuantity),
            // VariationQuantity: parseFloat(item.VariationQuantity),
            // Description: item.Description,
            // VariationId: item.VariationId,
            // AttributeId: item.AttributeId,
            // CategoryID: item.CategoryID,
            // CategoryName: item.CategoryName,
            // Itemnumber: item.Itemnumber,
            // Allowaltdescription: item.Allowaltdescription,
            // IsItemserialnumber: item.IsItemserialnumber,
            // RecallPrice: item.RecallPrice,
            // Tier1: item.Tier1,
            // Tier2: item.Tier2,
            // Tier3: item.Tier3,
            // Tier4: item.Tier4,
            // Tier5: item.Tier5,
            // QuickbookId: item.QuickbookID,
            // SaleItemQuickbookId: item.SaleItemQuickbookId,
            // mainIndex: index + 1,
            // isReCallPrice: item.isReCallPrice,

            return mappedItem;
          });
          setCartData(mappedSaleItems);

          // setFinalAmountData((prev) => ({...prev, extraDiscountAmount: Number(SuspendedData?.Discountentiresale || 0)}));

          // setFinalAmountData({
          //   subtotal: 0,
          //   totalDiscount: 0,
          //   totalTax: 0,
          //   extraDiscountAmount: Number(SuspendedData?.Discountentiresale || 0),
          //   shipping: 0,
          //   total: 0,
          // })

          // toastSuccess(Number(SalesDeliveryDetails?.Discountentiresale || 0)+' check descount')
          setFinalData({
            FinalGstType: "Percentage",
            FinalGstValue: "",
            FinalShipValue: Number(SalesDeliveryDetails?.DeliveryFees || 0),
            FinalDisType: "Fixed",
            FinalDisValue: Number(SuspendedData?.Discountentiresale || 0),
          });

          setSelectedTerm(SuspendedData?.TermsID || 0);
          setSaleIsVoid(SuspendedData?.IsVoid || 0);
          setSaleQuickbookId(SuspendedData.Type); // not sale quickbook id iys type only chekcing for return sync
          setSelectedTermQuickBookID(SuspendedData?.TermsQuickBookID || null);
          setDueDate(
            cloneSaleId > 0
              ? moment(startDate)
                  .add(SuspendedData?.TermsValue || 0, "days")
                  .toDate()
              : SuspendedData?.DueDate
          );
          setStartDate(
            cloneSaleId > 0 ? startDate : SuspendedData?.InvoiceDate
          );
          setSalesQuickbookId(cloneSaleId > 0 ? 0 : SuspendedData?.QuickBookId);

          setDeliveryMethodId(SuspendedData.DeliveryMethodId);
          setSalesDeliveryData({
            ...SalesDeliveryDetails,
            deliveryMethodId: SuspendedData?.DeliveryMethodId || 0,
          });

          setAccountSaleData({
            InvoiceMessage: SuspendedData?.InvoiceMessage,
            InvoiceStatement: SuspendedData?.InvoiceStatement,
            Attachment: SuspendedData?.Attachment,
            InvoiceNumber: SuspendedData?.InvoiceNumber,
            comment: SuspendedData?.Comments,
          });

          setShippingAddressId(SuspendedData?.shippingaddress);

          setSelectedtags(SuspendedData?.TagId);
          if (res.data.ResponseCode == "SUCCESS") {
            setSaleByIdLoader(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setSaleByIdLoader(false);
        });

      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/salesopenbalancebyid?SaleId=${saleIdApi}&CustomerId=${customerId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData, "setSalesOpenBlanace444");
          let SaleOpenBalance = res.data.ResponseData[0].SaleBalance;
          let salesPrevAMount = res.data.ResponseData[0].SaleAmount;
          let openBalance = SaleOpenBalance == null ? 0 : SaleOpenBalance;
          console.log(SaleOpenBalance, openBalance, "SaleOpenBalance1111111");
          setSalesOpenBalance(openBalance);
          setPreviousAmount(salesPrevAMount);
        })
        .catch((err) => {
          console.log(err);
        });

      // setSaleByIdLoader(false);
    }
  };

  const getAccountsList = () => {
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/accountddl?type=3&undepositedfunds=true`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const mappedAccountData = res.data.ResponseData.map((item) => {
          const mappedItem = {
            label: item.Name,
            value: item.ID,
            Amount: item.Amount,
            DepositQuickbookId: item.QuickbookId,
            parentName: item.ParentName ? item.ParentName.trim() : "",
            AccountType: item.AccountType,
          };
          return mappedItem;
        });
        setAccountsData(mappedAccountData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getPaymentMethodsList = () => {
    axios
      .get(
        `${config.generalBaseUrl}/generals/transactionpaymentdropdown?module=receive_payment`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const Option = res.data.ResponseData.map((u) => ({
          label: u.Paymenttypename,
          value: u.ID,
          paymentquickbookid: u.PaymentQuickbookId,
        }));
        setPaymentMethod(Option);
        setSelectedPaymentMethod(
          Option?.find((el) => el.label === "Cash") || {}
        );
      });
  };

  const customerWarningMessage = () => {
    toastWarn("please Select Customer First");
    return;
  };

  const handelErrorCartData = (checkErrorData) => {
    if (checkErrorData) {
      // const errorData = [...cartData];
      // setCartData(errorData)

      setCartData((prevCartData) => {
        // Separate error items and non-error items
        const errorItems = [];
        const nonErrorItems = [];
        prevCartData.forEach((item) => {
          const price = Number(item.cartPrice || 0);
          const qty = Number(item.cartQty || 0);
          const discount = Number(item.cartTotalDiscount || 0);
          const total = Number(item.cartTotal || 0);
          // If the logic fails, it's an error item
          if (!(price * qty + discount === total)) {
            errorItems.push(item);
          } else {
            nonErrorItems.push(item);
          }
        });
        // Place error items at the start
        return [...errorItems, ...nonErrorItems];
      });
    } else {
      toastSuccess("Cart data is valid");
    }
  };

  const handleFocus = (event) => {
    event.target.select();
  };

  useEffect(() => {
    // if(saleByIdLoader){
    //   setLoading(true);
    // }
    getCategoryData(0);
    getBrandsData();
    getTagsData();
    getCustomerData();
    getRoleTierData();
    getCatrgorySelectData();
    getSaleById();
    getAccountsList();
    getPaymentMethodsList();
    // if(saleByIdLoader){
    //   setLoading(false);
    // }
  }, []);

  const products = [
    { value: "walkInCustomer", label: "Walk in Customer" },
    { value: "john", label: "John" },
    { value: "smith", label: "Smith" },
    { value: "ana", label: "Ana" },
    { value: "elza", label: "Elza" },
  ];
  const gst = [
    { value: "5", label: "GST 5%" },
    { value: "10", label: "GST 10%" },
    { value: "15", label: "GST 15%" },
    { value: "20", label: "GST 20%" },
    { value: "25", label: "GST 25%" },
    { value: "30", label: "GST 30%" },
  ];
  const shipping = [
    { value: "15", label: "15" },
    { value: "20", label: "20" },
    { value: "25", label: "25" },
    { value: "30", label: "30" },
  ];
  const discount = [
    { value: "10", label: "10%" },
    { value: "15", label: "15%" },
    { value: "20", label: "20%" },
    { value: "25", label: "25%" },
    { value: "30", label: "30%" },
  ];
  const tax = [
    { value: "exclusive", label: "Exclusive" },
    { value: "inclusive", label: "Inclusive" },
  ];
  const discounttype = [
    { value: "percentage", label: "Percentage" },
    { value: "earlyPaymentDiscounts", label: "Early payment discounts" },
  ];

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "Are You Sure, You want to Generate this Invoice",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, confirm it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Order Successfully Confirmed!",
          text: "Your invoice has been Generated.",
          className: "btn btn-success",
          confirmButtonText: "View Receipt",
          customClass: {
            confirmButton: "btn btn-success",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            // Open the #print-receipt modal using querySelector
            console.log("clicked view receipt");
          }
        });
      } else {
        MySwal.close();
      }
    });
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [openTooltipIndexPrice]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [openTooltipIndex]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current?.focus();
      inputRef.current?.select();
    }
  }, [openTooltipIndexSum]);

  useEffect(() => {
    if (showMenu != "Global Search") {
      const mainDataFilterByModel =
        showMenu === "Brands"
          ? brands
          : showMenu === "Tags"
          ? tags
          : showMenu === "Favourite"
          ? favouriteList
          : category;

      console.log(mainDataFilterByModel, "mainDataFilterByModel");
      setMainFilterData(handleReturnFavourateData(mainDataFilterByModel));
      setdata(handleReturnFavourateData(mainDataFilterByModel));
    } else {
      if (!globalFilterInput) {
        setShowMenu("Category");
        // setMainFilterData(category);
      }
    }
  }, [category, tags, brands, showMenu, globalFilterInput]);

  const fetchData = async (value) => {
    setSkeletonLoading(true);
    await axios
      .get(
        `${config.ecommBackendBaseUrl}/products/homesearchitem?categoryid=0&filtertext=${value}&module=pos&loginId=${customerId}&RoleId=${customerDetail?.RoleTierID}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log("ressssspsosossns", response.data.ResponseData);

        const data = response.data.ResponseData;
        console.log(data, "finaldata 0");
        const categoryesGlobalSearchData = data?.categorydata?.map((el) => {
          return {
            id: el?.ID,
            src: el?.Imagename ? el?.Imagename : "",
            alt: el?.Name,
            title: el?.Name ? el.Name : "",
            itemsCount: el?.ItemCount,
            ParentId: el?.ParentId,
            type: "Category",
            IsShowEcommerceMenu: 1,
            isInCart: false,
            cartQty: 0,
            cartPrice: el.UnitPrice ? el.UnitPrice : 0,
            parentName: el.ParentName ? el.ParentName : "",
          };
        });

        const brandsGlobalSearchData = data?.branddata?.map((el) => {
          return {
            id: el?.ID,
            src: el?.Imagename ? el?.Imagename : "",
            alt: el?.Name,
            title: el?.Name ? el?.Name : "",
            itemsCount: el?.ItemCount,
            ParentId: 0,
            type: "Brands",
            IsShowEcommerceMenu: 1,
            isInCart: false,
            cartQty: 0,
            cartPrice: 0,
          };
        });

        const itemsGlobalSearchData = data?.responsedata?.map((el) => {
          return {
            id: el?.ItemID,
            src: el?.Image ? el?.Image : "",
            alt: el?.ItemName,
            title: el?.ItemName ? el?.ItemName : "",
            itemsCount: el?.TotalVariation,
            ParentId: 0,
            type: "Product",
            IsShowEcommerceMenu: 1,
            isInCart: false,
            cartQty: 1,
            cartPrice: el?.RecallPrice, // for show and cart price
            Tier1Price: el?.Tier1Price,
            Tier2Price: el?.Tier2Price,
            Tier3Price: el?.Tier3Price,
            Tier4Price: el?.Tier4Price,
            Tier5Price: el?.Tier5Price,
            RecallPrice: el?.RecallPrice,
            UnitPrice: el?.UnitPrice,
            variationId: el?.VariationID,
            cartDiscountType: "percent", //"Percentage"
            cartDiscount: 0,
            cartTaxType: "Percentage", //"Percentage"
            cartTax: 0,
            cartTotal: 0,
            cartSubTotal: 0,
            cartTotalDiscount: 0,
            cartTotalTax: 0,
            CategoryID: el.CategoryID,
            CategoryName: el.CategoryName,
            CostPrice: el?.CostPrice,
            QuickBookId: el.QuickBookId,
            CurrantQTY: el?.CurrantQTY || 0,
            ItemNumber: el?.ItemNumber || "",
            // Itemnumber: el?.ItemNumber || "",
            isFavourite: false,
          };
        });

        console.log(itemsGlobalSearchData, "itemsGlobalSearchData");

        if (itemsGlobalSearchData?.length === 0) {
          toastError("Product Not Found!");
        }
        if (
          itemsGlobalSearchData?.length === 1 &&
          itemsGlobalSearchData[0].ItemNumber === value
        ) {
          const findIndex = cartData.findIndex(
            (el) =>
              el.id == itemsGlobalSearchData[0].id &&
              el.variationId == itemsGlobalSearchData[0].variationId
          );
          console.log(findIndex, "findIndex");
          if (findIndex != -1) {
            handelcartList(
              Number(cartData[findIndex].cartQty || 0) + 1,
              findIndex,
              "cartQty",
              itemsGlobalSearchData[0],
              true
            );
            toastSuccess("Item Qty Updated to Cart");
          } else {
            setCartData((prev) => [
              {
                ...itemsGlobalSearchData[0],
                rowIndex: prev?.length + 1,
                cartTotal: Number(
                  1 * itemsGlobalSearchData[0]?.RecallPrice
                ).toFixed(2),
                cartSubTotal: Number(
                  1 * itemsGlobalSearchData[0]?.RecallPrice
                ).toFixed(2),
              },
              ...prev,
            ]);
            toastSuccess("Item Added to Cart");
          }
          setGlobalFilterInput("");
          setSelectedIndex(-1);
        } else {
          const finaldata = [
            ...categoryesGlobalSearchData,
            ...brandsGlobalSearchData,
            ...itemsGlobalSearchData,
          ];

          setMainFilterData(handleReturnFavourateData(finaldata));
          setdata(handleReturnFavourateData(finaldata));
        }
        setShowMenu("Global Search");
        setSkeletonLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setSkeletonLoading(false);
      });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (globalFilterInput) {
        fetchData(globalFilterInput);
      }
    }, 600);
    return () => {
      clearTimeout(timer);
    };
  }, [globalFilterInput]);

  const handelGlobalSearchApi = async (value) => {
    if (customerId > 0) {
      setGlobalFilterInput(value);
    } else {
      customerWarningMessage();
    }
  };

  const handelclearGlobalFilter = () => {
    setGlobalFilterInput("");
  };

  const handelMainFilter = async (filterData) => {
    console.log(filterData, "753159");
    LatestData = [];

    console.log(filterData, filterData.itemsCount > 0, "684sd684dfv");
    if (filterData.type !== "Product" || filterData.itemsCount > 0) {
      if (
        filterData.id != 0 &&
        !backToMenu.some((el) => el.id === filterData.id)
      ) {
        setBackToMenu([
          ...backToMenu,
          { id: filterData.id, type: filterData.type },
        ]);
      }

      let itemCategoryId = 0;
      let itemBrandId = 0;
      let itemTagId = 0;

      setSkeletonLoading(true);

      if (filterData.type === "Category") {
        await getCategoryData(filterData.id);
        if (filterData.id === 0) {
          setSkeletonLoading(false);
          return;
        }
        itemCategoryId = filterData.id;
        itemBrandId = 0;
        itemTagId = 0;
      } else if (filterData.type === "Brands") {
        console.log(filterData.id, "filterData123");
        itemCategoryId = 0;
        itemBrandId = filterData.id;
        itemTagId = 0;
      } else if (filterData.type === "Tags") {
        itemCategoryId = 0;
        itemBrandId = 0;
        itemTagId = filterData.id;
      }

      if (filterData.type == "Product") {
        await handelItemVariationAPi(filterData.id);
        setSkeletonLoading(false);
        return;
      }

      console.log(itemCategoryId, itemBrandId, itemTagId, "itemTagId");

      try {
        const [productResponse] = await Promise.all([
          axios.get(
            `${config.ecommBackendBaseUrl}/products/productfilteration?MinPrice=0&MaxPrice=10000000000&CategoryID=${itemCategoryId}&BrandID=${itemBrandId}&TagID=${itemTagId}&AttributeID=&PriceOrder=&LatestProduct=1&PageNumber=&PageSize=&FilterText=&LoginUserID=${Location}&CustomerId=${customerId}&model=1&RoleId=${customerDetail?.RoleTierID}`
          ),
        ]);

        const productData = productResponse.data.ResponseData?.map((el) => ({
          id: el?.ItemID,
          src: el?.Image ? el?.Image : "",
          alt: el?.ItemName,
          title: el?.ItemName ? el?.ItemName : "",
          itemsCount: Number(el?.TotalVariation),
          ParentId: 0,
          type: "Product",
          IsShowEcommerceMenu: 1,
          isInCart: false,
          cartQty: 1,
          cartPrice: el?.RecallPrice,
          Tier1Price: el?.Tier1Price,
          Tier2Price: el?.Tier2Price,
          Tier3Price: el?.Tier3Price,
          Tier4Price: el?.Tier4Price,
          Tier5Price: el?.Tier5Price,
          RecallPrice: el?.RecallPrice,
          UnitPrice: el?.Price,
          variationId: 0,
          cartDiscountType: "percent",
          cartDiscount: 0,
          cartTaxType: "Percentage",
          cartTax: 0,
          cartTotal: 0,
          cartSubTotal: 0,
          cartTotalDiscount: 0,
          cartTotalTax: 0,
          CategoryID: el.CategoryID,
          CostPrice: el.CostPrice,
          QuickBookId: el.QuickBookId,
          CurrantQTY: el.Quantity,
          ItemNumber: el?.Itemnumber,
          isFavourite: false,
        }));

        LatestData.push(...handleReturnFavourateData(productData));
        setdata(LatestData);
        setMainFilterData(LatestData);
        setselectqty(!selectqty);
      } catch (error) {
        console.error(error);
      } finally {
        setSkeletonLoading(false);
      }
    } else {
      const findIndex = cartData.findIndex(
        (el) =>
          el.id == filterData.id && el.variationId == filterData.variationId
      );
      console.log(findIndex, "findIndex");
      if (findIndex != -1) {
        if (!moduleopen) {
          let updatedObject = cartData[findIndex];
          const filterArray = cartData?.filter((_, i) => i != findIndex);
          setOpenTooltipIndex(0);
          handleInputChange(
            Number(updatedObject.cartQty || 0) +
              Number(filterData?.cartQty || 0),
            0,
            updatedObject
          );
          setOpenTooltipIndexPrice(null);
          setopenTooltipIndexSum(null);
          setModuleopen(true);
          updatedObject.cartPrice = filterData.cartPrice;
          updatedObject.cartTotal = Number(
            updatedObject?.cartQty * filterData?.cartPrice
          ).toFixed(2);
          updatedObject.cartSubTotal = Number(
            updatedObject?.cartQty * filterData?.cartPrice
          ).toFixed(2);

          setCartData([updatedObject, ...filterArray]);
        } else {
          handelcartList(
            Number(cartData[findIndex].cartQty || 0) +
              Number(filterData?.cartQty || 0),
            findIndex,
            "cartQty",
            cartData[findIndex],
            true
          );
          handelcartList(
            filterData?.cartPrice,
            findIndex,
            "cartPrice",
            cartData[findIndex],
            true
          );
          toastSuccess(
            "Item Qty Updated."
            // `Item: ${filterData.title} Qty in Cart is ${filterData.cartQty + 1}`
          );
        }
      } else {
        setCartData((prev) => [
          {
            ...filterData,
            rowIndex: prev?.length + 1,
            cartQty: filterData?.cartQty,
            cartTotal: Number(
              filterData?.cartQty * filterData?.cartPrice
            ).toFixed(2),
            cartSubTotal: Number(
              filterData?.cartQty * filterData?.cartPrice
            ).toFixed(2),
          },
          ...prev,
        ]);
        // toastSuccess("Item Added to cart");
        // toastSuccess(`Item: ${filterData.title} Added to cart`);
      }
    }
  };

  const productHandleChange = (value, index, field, type, item) => {
    console.log(type, value, "qty input");
    if (type == "item") {
      let UpdateList = [...mainFilterData];
      const findIndex = UpdateList.findIndex(
        (el) => el.id == item.id && el.variationId == item.variationId
      );
      UpdateList[findIndex][field] = value;
      UpdateList[findIndex].isInCart = true;
      setMainFilterData(UpdateList);
      setSelectedIndex(index);
      setIsPriceChange(1);
    } else {
      let UpdateList = [...variationlistData];
      const findIndex = UpdateList.findIndex(
        (el) => el.id == item.id && el.variationId == item.variationId
      );
      UpdateList[findIndex][field] = value;
      UpdateList[findIndex].isInCart = true;
      setVariationlistData(UpdateList);
    }
  };

  const handleMouseDown = (index, field, type, action, cat, from) => {
    console.log(index, field, type, action, cat, from, "check value");

    const adjustQuantity = () => {
      let newQty = 0;

      if (field === "cartPrice") {
        newQty =
          action === "increase"
            ? (Number(cat.cartPrice) + 1).toFixed(2)
            : (Number(cat.cartPrice) - 1).toFixed(2);
      } else {
        newQty =
          action === "increase"
            ? Number(cat.cartQty) + 1
            : Number(cat.cartQty) - 1;
      }

      if (newQty < 0) return; // Prevent negative values

      if (from === "fromcart") {
        handelcartList(newQty, index, field);
      } else {
        productHandleChange(newQty, index, field, type, cat);
      }
    };

    const id = setInterval(adjustQuantity, 200); // Repeat adjustment
    setIntervalId(id);

    // Trigger adjustment immediately
    adjustQuantity();
  };

  const handleMouseUp = () => {
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null); // Reset the interval ID
    }
  };
  //   // Clear the interval
  //   if (intervalId) {
  //     clearInterval(intervalId);
  //     setIntervalId(null);
  //   }
  // };

  const handelBackToMenu = () => {
    const newBackToMenu = [...backToMenu];

    const backid = newBackToMenu[newBackToMenu.length - 2];
    const removeObj = newBackToMenu.pop();

    console.log(removeObj, "removeObj123");

    setBackToMenu(newBackToMenu);

    console.log(removeObj, "removeObj");

    setShowMenu(removeObj?.type);
    if (removeObj?.type === "Tags") {
      getTagsData();
    } else if (removeObj?.type === "Brands") {
      getBrandsData();
    } else if (backid?.type == undefined) {
      handelMainFilter({ type: "Category", id: backid?.id ? backid?.id : 0 }); //"Category"
    } else {
      handelMainFilter({ type: backid?.type, id: backid?.id ? backid?.id : 0 }); //"Category"
    }
  };

  const handleFilterChange = () => {
    setFilterAllStockData(!filterAllStockData);
  };

  const handelcartList = (
    value,
    index,
    field,
    item = null,
    showOnTop = false
  ) => {
    console.log(value, index, field, "input of cartlist");
    let cartUpdateList = [...cartData];
    if (item) {
      const findIndex = cartData.findIndex(
        (el) => el.id == item.id && el.variationId == item.variationId
      );
      console.log(findIndex, "findIndex");
      cartUpdateList[findIndex][field] = value;
      // Calculate the cartTotal based on updated values
      let qty = parseFloat(cartUpdateList[findIndex].cartQty) || 0;
      let price = parseFloat(cartUpdateList[findIndex].cartPrice) || 0;
      let discount = parseFloat(cartUpdateList[findIndex].cartDiscount) || 0;
      let tax = parseFloat(cartUpdateList[findIndex].cartTax) || 0;
      let discountType = cartUpdateList[findIndex].cartDiscountType;
      let taxType = cartUpdateList[findIndex].cartTaxType;

      // Calculate subtotal (qty * price)
      let subtotal = qty * price;

      // Calculate discount
      let discountAmount = 0;
      if (discountType === "percent") {
        discountAmount = (subtotal * discount) / 100;
      } else if (discountType === "amount") {
        discountAmount = discount;
      }

      // Calculate taxable amount after discount
      let taxableAmount = subtotal - discountAmount;

      // Calculate tax
      let taxAmount = 0;
      if (taxType === "Percentage") {
        taxAmount = (taxableAmount * tax) / 100;
      } else if (taxType === "Fixed") {
        taxAmount = tax;
      }

      // Calculate total
      let total = taxableAmount + taxAmount;

      // Update the total in the cart item
      cartUpdateList[findIndex].cartTotal = total.toFixed(2); // Keeping it to 2 decimal places if needed
      cartUpdateList[findIndex].cartSubTotal = subtotal;
      cartUpdateList[findIndex].cartTotalDiscount = discountAmount;
      cartUpdateList[findIndex].cartTotalTax = taxAmount;

      if (showOnTop) {
        const updatedObject = cartUpdateList[findIndex];
        const filterArray = cartUpdateList?.filter((_, i) => i != findIndex);
        setCartData([updatedObject, ...filterArray]);
      } else {
        // Update the state with the new values
        setCartData(cartUpdateList);
      }
    } else {
      cartUpdateList[index][field] = value;
      // Calculate the cartTotal based on updated values
      let qty = parseFloat(cartUpdateList[index].cartQty) || 0;
      let price = parseFloat(cartUpdateList[index].cartPrice) || 0;
      let discount = parseFloat(cartUpdateList[index].cartDiscount) || 0;
      let tax = parseFloat(cartUpdateList[index].cartTax) || 0;
      let discountType = cartUpdateList[index].cartDiscountType;
      let taxType = cartUpdateList[index].cartTaxType;

      // Calculate subtotal (qty * price)
      let subtotal = qty * price;

      // Calculate discount
      let discountAmount = 0;
      if (discountType === "percent") {
        discountAmount = (subtotal * discount) / 100;
      } else if (discountType === "amount") {
        discountAmount = discount;
      }

      // Calculate taxable amount after discount
      let taxableAmount = subtotal - discountAmount;

      // Calculate tax
      let taxAmount = 0;
      if (taxType === "Percentage") {
        taxAmount = (taxableAmount * tax) / 100;
      } else if (taxType === "Fixed") {
        taxAmount = tax;
      }

      // Calculate total
      let total = taxableAmount + taxAmount;

      // Update the total in the cart item
      cartUpdateList[index].cartTotal = total.toFixed(2); // Keeping it to 2 decimal places if needed
      cartUpdateList[index].cartSubTotal = subtotal;
      cartUpdateList[index].cartTotalDiscount = discountAmount;
      cartUpdateList[index].cartTotalTax = taxAmount;

      // Update the state with the new values
      if (showOnTop) {
        const updatedObject = cartUpdateList[index];
        const filterArray = cartUpdateList?.filter((_, i) => i != index);
        setCartData([updatedObject, ...filterArray]);
      } else {
        // Update the state with the new values
        setCartData(cartUpdateList);
      }
    }
  };

  const handelRemoveFromCart = (v_id, i_id) => {
    const cartUpdateList = cartData.filter(
      (item) => !(item.variationId === v_id && item.id === i_id)
    );
    // let cartUpdateList = cartData.filter((_, i) => i !== index); // Filter out the item at the given index
    setCartData(cartUpdateList); // Update the state with
  };

  const handelCustomerSelect = (e) => {
    if (e) {
      setShowCustomerBalance(false);
      setShowCustomerAOS(false);
      console.log(e, "Customerdatacheck");
      setCustomerId(e.value);
      setCustomerDetail(e);
      setAccountSaleData((prevValues) => ({
        ...prevValues,
        ["InvoiceMessage"]: e.InternalNotes,
      }));
      getShippingAddressByCustomerId(e.value);
      getCustomerfavouriteitemslist(e.value);
      setSelectedTerm(Number(e.Terms));
      if (e?.TermDay) {
        console.log(e?.TermDay, "e?.TermDay");

        const newDueDate =
          e.TermDay == 1
            ? moment() // current date
            : moment(startDate).add(e.TermDay, "days");

        setDueDate(newDueDate); // moment object is fine; convert to Date if needed with .toDate()
      }
    } else {
      setCustomerId(0); //e.value
      setCustomerDetail({}); //e
      setShippingAddressId(0);
      setAccountSaleData((prevValues) => ({
        ...prevValues,
        ["InvoiceMessage"]: "",
      }));
    }
  };

  // add edit Shipping Address
  const handelCustomerShippingAddressInputUpdate = (value, field) => {
    setCustomerShippingUpdateData((prev) => {
      return { ...prev, [field]: value };
    });
  };

  // add new customer Shipping address
  const clearShippingAddressSelected = () => {
    setShippingUpdateOptionId(0);
    setCustomerShippingUpdateData({
      ID: 0,
      Address1: "",
      Address2: "",
      City: "",
      StateProvince: "",
      Zip: "",
      Country: "",
    });
  };

  // Add edit select Shipping Address
  const handelCustomerShippingAddressUpdateSelect = (e) => {
    setShippingUpdateOptionId(e ? e.value : 0);
    setCustomerShippingUpdateData(e ? e : {});
  };

  // add edit Submit Shipping Address
  const handelUpdateShippingAddressSubmit = (e) => {
    let reqobj = {
      ID: shippingUpdateOptionId,
      CustomerId: customerId,
      Add1: customerShippingUpdateData.Address1,
      Add2: customerShippingUpdateData.Address2,
      City: customerShippingUpdateData.City,
      StateProvince: customerShippingUpdateData.StateProvince,
      Zip: customerShippingUpdateData.Zip,
      Country: customerShippingUpdateData.Country,
      loginuserID: LoginId,
    };
    console.log(reqobj, "ShippingupdateSubmit");
    setLoading(true);
    // return
    axios
      .post(
        `${config.customersBaseUrl}/customers/CustomerShipingAddByID`,
        reqobj,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        toastSuccess("Shipping Address Add Suessfully");
        setShippingUpdateOptionId(0);
        setCustomerShippingUpdateData({});
        getShippingAddressByCustomerId(customerId);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  // const handelSubmitInvoice = () => {

  //   const Itemdata = cartData.map(cart => {
  //     return {
  //         SaleItemID: 0,
  //         ItemId: cart.id,
  //         SaleId: 0,
  //         UnitPrice: cart.UnitPrice,
  //         Price: cart.cartPrice,
  //         RecallPrice: cart.RecallPrice,
  //         ItemName: cart.title,
  //         itemquantity: cart.cartQty,
  //         itemdiscount: cart.cartTotalDiscount,
  //         CostPrice: cart.CostPrice,
  //         Ischecked: 0,
  //         Total: cart.cartTotal,
  //         Module: "Item",
  //         Itemkitid: 0,
  //         VariationName: cart.itemsCount > 0 ? cart.title : "",
  //         locationid: Location,
  //         ItemCurrentQuantity: 0,
  //         VariationQuantity: 0,
  //         Description: "",
  //         VariationId: cart.variationId,
  //         AttributeId: 0,
  //         CategoryID: cart.CategoryID,
  //         CategoryName: "",
  //         Itemnumber: "",
  //         Allowaltdescription: "",
  //         IsItemserialnumber: "",
  //         Tier1: cart.Tier1Price,
  //         Tier2: cart.Tier2Price,
  //         Tier3: cart.Tier3Price,
  //         Tier4: cart.Tier4Price,
  //         Tier5: cart.Tier5Price,
  //         QuickbookId: 0,
  //         SaleItemQuickbookId: 0,
  //         Isdefault: 0,
  //         Tax1: null,
  //         Tax2: null,
  //         Tax3: null,
  //         Tax4: null,
  //         Tax5: null,
  //         TaxCum1: null,
  //         TaxCum2: null,
  //         TaxCum3: null,
  //         TaxCum4: null,
  //         TaxCum5: null,
  //         TaxName1: null,
  //         TaxName2: null,
  //         TaxName3: null,
  //         TaxName4: null,
  //         TaxName5: null,
  //         TaxType1: null,
  //         TaxType2: null,
  //         TaxType3: null,
  //         TaxType4: null,
  //         TaxType5: null,
  //         TaxVal1: null,
  //         TaxVal2: null,
  //         TaxVal3: null,
  //         TaxVal4: null,
  //         TaxVal5: null,
  //         Cummalative: 0,
  //         mainIndex: 1,
  //         isReCallPrice: "",
  //         TaxGroup1: 0,
  //         TaxGroup1Value: 0,
  //         taxes: 0,
  //         finaltax: finalAmountData.totalTax,
  //         LineTax: cart.cartTotalTax,
  //         Tax: 0
  //     }
  //   })

  //   const deliveryData = {
  //     Id: 0,
  //     Saleid: 0,
  //     EmployeId: 0,
  //     Shippingzoneid: 0,
  //     Taxclassid: 0,
  //     DeliveryFees: changePriceFormat(finalAmountData.shipping),
  //     Status: 0,
  //     EstimatedShippingDate: "",
  //     EstimatedDeliveryDate: "",
  //     TranckingNumber: "",
  //     Comments: "",
  //     Duration: "",
  //     LocationId: Location,
  //     CategoryId: "",
  //     FirstName: customerDetail.FirstName,
  //     LastName: customerDetail.LastName,
  //     Email: customerDetail.Email,
  //     PhoneNumber: customerDetail.PhoneNumber,
  //     ContactPrefrence: "",
  //     Address1: customerDetail.Address1,
  //     Address2: customerDetail.Address2,
  //     City: customerDetail.City,
  //     State: customerDetail.StateProvince,
  //     Zip: customerDetail.Zip,
  //     Country: customerDetail.Country,
  //     homenumber: 0
  //   };

  //   const Itemobj = {};
  //   Itemobj.saleitemsXML = Itemdata;
  //   let itemjsonstring = JSON.stringify(Itemobj);

  //   let customValuesData = {};
  //   customValuesData.customValueXML = [];
  //   let customvaluejsonstring = JSON.stringify(customValuesData);

  //   let paymentData = {};
  //   paymentData.paymentValueXML = [];
  //   let paymentvaluejsonstring = JSON.stringify(paymentData);

  //   let taxValuesData = {};
  //   taxValuesData.itemTaxXML = [];
  //   let taxjsonstring = JSON.stringify(taxValuesData);

  //   let salesDeliveryDataJSON = {};
  //   salesDeliveryDataJSON.salesDeliveryDataXML = deliveryData;
  //   let salesDeliveryDataString = JSON.stringify(salesDeliveryDataJSON);

  //   let SalesData = {
  //     xmlsalesitems: itemjsonstring,
  //     xmlcustomfieldvalue: customvaluejsonstring,
  //     xmlitemspayment: paymentvaluejsonstring,
  //     xmlsalesitemtax: taxjsonstring,
  //     xmlsalesdeliverydata: salesDeliveryDataString,

  //     saletime: moment().format("YYYY-MM-DD"),
  //     id: 0,
  //     customerid: customerDetail.Id,
  //     comment: '',
  //     locationid: Location,
  //     saletypeid: 1,
  //     suspended: 0,
  //     storeaccountpayment: 0,
  //     totalquantitypurchased: cartTotalQty,
  //     totalquantityreceived: 0,
  //     subtotal: finalAmountData.subtotal,
  //     total: finalAmountData.total,
  //     showcommentonreceipt: 0,
  //     estimate: 0,
  //     layaway: 0,
  //     discountreason: 'Additional Discount',
  //     discountentiresale: finalAmountData.extraDiscountAmount,
  //     paymentcurrency: 'USD',
  //     addcoupons: '',
  //     invoiceno: '',
  //     invoicemessage: '',
  //     invoicestatement: '',
  //     duedate: moment().format("YYYY-MM-DD"),
  //     termsid: 0,
  //     termidquickbook: 0,
  //     receipt: '',
  //     status: 1,
  //     tagids: '',
  //     billingaddress: customerDetail.Address1 + customerDetail.Address2 + customerDetail.City + customerDetail.StateProvince + customerDetail.Zip + customerDetail.Country,
  //     emailaddress: customerDetail.Email,
  //     loginuserid: LoginId,
  //     quickbookid: 0,
  //     customerquickbookid: customerDetail.QuickbookID,
  //     customername: customerDetail.CompanyName,
  //     shippingaddress: shippingAddressOption?.find(
  //       (el) => el.value === shippingAddressId
  //     ).label,
  //     salequickbookid: 0,
  //     custtierId: cartTierPriceSelect, // role tire price select id
  //     deliveryMethodId: 0,
  //     deliveryFees: Number(finalData?.FinalShipValue) || 0,
  //   };

  //   axios
  //     .post(`${config.salesconfigBaseUrl}/sales/upsert`, SalesData, {
  //       headers: {
  //         "Content-Type": "application/json;charset=UTF-8",
  //         "Access-Control-Allow-Origin": "*",
  //         Authorization: token,
  //       },
  //     })
  //     .then((res) => {
  //       if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
  //         toastSuccess(SUCCESS_MESSAGE);
  //         console.log(res.data, "responseData")
  //         toastSuccess(`data inserded successfully ${res.data.ResponseID}`)
  //         // setLoading(false);
  //       } else if (res.data.ResponseCode === "ERROR") {
  //         toastError(ERROR_MESSAGE);
  //         // setLoading(false);
  //       }
  //     })
  //     .catch((error) => {
  //       // setLoading(false);
  //     });
  // };

  const BindInvoiceDropdown = (pSaleTypeID) => {
    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/autogenerateinvoicenumber?typeid=${
          pSaleTypeID > 0 ? pSaleTypeID : saleTypeId
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        let invoiceNumber = res.data.ResponseData[0].InvoiceNumber;
        // setAccountSaleData((prevValues) => ({
        //   ...prevValues,
        //   ["InvoiceNumber"]: invoiceNumber,
        // }));
      });
    // }
  };

  function formatAddress(customer) {
    const parts = [
      customer.Address1,
      customer.Address2,
      customer.City,
      customer.StateProvince,
      customer.Zip,
      customer.Country,
    ];

    return parts
      .filter((part) => part && part.trim() !== "") // Remove empty fields
      .map((part) => part.trim().replace(/,+$/, "")) // Trim spaces and trailing commas
      .join(", ");
  }

  console.log(formatAddress(customerDetail), "customer address");
  const handelSubmitInvoice = (type) => {
    // if(type === "Payment" && depositTo == 0) {
    //   toastError("Please select account");
    //   return
    // }
    // Show confirmation prompt before proceeding

    // if (paramObject?.saleId > 0 && finalAmountData.total < AmountPaid) {
    //   toastError("Total amount Cannot Be less Than Total paid Amount ");
    //   return;
    // }

    if (deliveryMethodId === 0 && saleTypeId == 1) {
      Swal.fire({
        title: "Error",
        text: "Delivery Method is Required",
        icon: "error",
        confirmButtonText: "OK", // Ensures only an OK button is shown
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to generate this invoice?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, generate it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // Proceed with API call if confirmed
        Swal.fire({
          title: "Submitting Invoice...",
          text: "Please wait while we process your request.",
          showConfirmButton: false,
          allowOutsideClick: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        console.log("check one onBlur");

        // Prepare data for the API call
        const Itemdata = cartData.map((cart) => {
          return {
            SaleItemID: cart?.SaleItemID ? cart?.SaleItemID : 0,
            ItemId: cart.id,
            SaleId: saleId,
            UnitPrice: cart.UnitPrice,
            Price: cart.cartPrice,
            RecallPrice: cart.RecallPrice,
            ItemName: cart.title,
            itemquantity: cart.cartQty,
            itemdiscount: cart.cartDiscount,
            CostPrice: cart.CostPrice,
            Ischecked: 0,
            Total: cart.cartTotal,
            Module: "Item",
            Itemkitid: 0,
            VariationName: cart.itemsCount > 0 ? cart.title : "",
            locationid: Location,
            ItemCurrentQuantity: cart.CurrantQTY,
            VariationQuantity: 0,
            Description: "",
            VariationId: cart.variationId,
            AttributeId: 0,
            CategoryID: cart.CategoryID,
            CategoryName: "",
            Itemnumber: cart?.ItemNumber ? cart.ItemNumber : "",
            Allowaltdescription: "",
            IsItemserialnumber: "",
            Tier1: cart.Tier1Price,
            Tier2: cart.Tier2Price,
            Tier3: cart.Tier3Price,
            Tier4: cart.Tier4Price,
            Tier5: cart.Tier5Price,
            QuickbookId: cart.QuickBookId,
            SaleItemQuickbookId: cart.SaleItemQuickbookId
              ? cart.SaleItemQuickbookId
              : 0,
            Isdefault: 0,
            Tax1: null,
            Tax2: null,
            Tax3: null,
            Tax4: null,
            Tax5: null,
            TaxCum1: null,
            TaxCum2: null,
            TaxCum3: null,
            TaxCum4: null,
            TaxCum5: null,
            TaxName1: null,
            TaxName2: null,
            TaxName3: null,
            TaxName4: null,
            TaxName5: null,
            TaxType1: null,
            TaxType2: null,
            TaxType3: null,
            TaxType4: null,
            TaxType5: null,
            TaxVal1: null,
            TaxVal2: null,
            TaxVal3: null,
            TaxVal4: null,
            TaxVal5: null,
            Cummalative: 0,
            mainIndex: 1,
            isReCallPrice: "",
            TaxGroup1: 0,
            TaxGroup1Value: 0,
            taxes: 0,
            finaltax: finalAmountData.totalTax,
            LineTax: cart.cartTotalTax,
            Tax: 0,
            DiscountType: cart.cartDiscountType,
          };
        });

        let deliveryData = {};
        if (salesDeliveryData) {
          deliveryData = {
            Id: salesDeliveryData?.Id,
            Saleid: saleId, // for new pass 0
            EmployeId: salesDeliveryData?.EmployeId,
            Shippingzoneid: salesDeliveryData?.Shippingzoneid,
            Taxclassid: salesDeliveryData?.Taxclassid,
            DeliveryFees: salesDeliveryData?.DeliveryFees,
            Status: salesDeliveryData?.Status,
            EstimatedShippingDate: salesDeliveryData?.EstimatedShippingDate,
            EstimatedDeliveryDate: salesDeliveryData?.EstimatedDeliveryDate,
            TranckingNumber: salesDeliveryData?.TranckingNumber,
            Comments: salesDeliveryData?.Comments,
            Duration: salesDeliveryData?.Duration,
            LocationId: Location,
            CategoryId: salesDeliveryData?.CategoryId,
            FirstName: salesDeliveryData?.FirstName,
            LastName: salesDeliveryData?.LastName,
            Email: salesDeliveryData?.Email,
            PhoneNumber: salesDeliveryData?.PhoneNumber,
            ContactPrefrence: salesDeliveryData?.ContactPrefrence,
            Address1: salesDeliveryData?.Address1,
            Address2: salesDeliveryData?.Address2,
            City: salesDeliveryData?.City,
            State: salesDeliveryData?.StateProvince,
            Zip: salesDeliveryData?.Zip,
            Country: salesDeliveryData?.Country,
            homenumber: 0,
            Ispickup: salesDeliveryData?.Ispickup, // more field Isdelivery, Ispickup, Loginuserid
          };
        }
        console.log("check two onBlur");

        const Itemobj = { saleitemsXML: Itemdata };
        let itemjsonstring = JSON.stringify(Itemobj);

        let customValuesData = { customValueXML: [] };
        let customvaluejsonstring = JSON.stringify(customValuesData);

        let paymentData = { paymentValueXML: [] };
        let paymentvaluejsonstring = JSON.stringify(paymentData);

        let taxValuesData = { itemTaxXML: [] };
        let taxjsonstring = JSON.stringify(taxValuesData);

        let salesDeliveryDataJSON = { salesDeliveryDataXML: deliveryData };
        let salesDeliveryDataString = JSON.stringify(salesDeliveryDataJSON);

        console.log("check three onBlur");

        let SalesData = {
          saletime: moment(startDate).format("YYYY-MM-DD"),
          xmlsalesitems: itemjsonstring,
          xmlcustomfieldvalue: customvaluejsonstring,
          xmlitemspayment: paymentvaluejsonstring,
          xmlsalesitemtax: taxjsonstring,
          xmlsalesdeliverydata: salesDeliveryDataString, // done
          id: saleId,
          customerid: customerDetail.Id,
          comment: accountSaleData.comment,
          locationid: Location,
          saletypeid: saleTypeId,
          suspended: 0,
          storeaccountpayment: 0,
          totalquantitypurchased: cartTotalQty,
          totalquantityreceived: 0,
          subtotal: finalAmountData.subtotal,
          total: finalAmountData.total,
          showcommentonreceipt: 0,
          estimate: 0,
          layaway: 0,
          discountreason: "Additional Discount",
          discountentiresale: finalAmountData.extraDiscountAmount,
          paymentcurrency: "USD",
          addcoupons: "",
          invoiceno: accountSaleData.InvoiceNumber,
          invoicemessage: accountSaleData.InvoiceMessage,
          invoicestatement: accountSaleData.InvoiceStatement,
          duedate: moment(dueDate).format("YYYY-MM-DD"),
          termsid: selectedTerm || customerDetail.Terms,
          termidquickbook:
            selectedTermQuickBookID || customerDetail.TermsQuickBookId,
          receipt: "",
          status: 1,
          tagids: selectedtags,
          billingaddress: formatAddress(customerDetail),
          emailaddress: customerDetail.Email,
          loginuserid: LoginId,
          quickbookid: salesQuickbookId,
          customerquickbookid: customerDetail.QuickbookID,
          customername: customerDetail.CompanyName,
          shippingaddress: shippingAddressId,
          // shippingaddress: shippingAddressOption?.find(
          //   (el) => el.value === shippingAddressId
          // )?.label || "",
          salequickbookid: salequickbookid, //as in manage sales it passed Type
          custtierId: cartTierPriceSelect, // role tier price select id
          deliveryMethodId: deliveryMethodId ? deliveryMethodId : 0,
          deliveryFees: Number(finalData?.FinalShipValue) || 0,
          registerId: isManagePOSSale == 1 ? userRegisterId : 0,
          masterRegisterId: isManagePOSSale == 1 ? masterRegisterId : 0,
          SalesgenerateType: "Pos",
          SaleQuickPermision: SaleQuickPermision,
        };

        console.log(SalesData, "SalesData onBlur");
        // return;
        // setLoading(true);
        axios
          .post(`${config.salesconfigBaseUrl}/sales/upsert`, SalesData, {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          })
          .then((res) => {
            if (
              res.data.ResponseCode === "SUCCESS" &&
              res.data.ResponseID > 0
            ) {
              if (type === "Sale") {
                handleClearData();
                localStorage.setItem(
                  "isCustomerChange",
                  JSON.stringify(res.data.ResponseData[0].IsCustomerUpdate)
                );
                MySwal.close();
                setLoading(false);
                if (
                  paramObject?.saleId > 0 &&
                  finalAmountData.total < Number(AmountPaid)
                ) {
                  let reqobj = {
                    SaleId: paramObject?.saleId,
                    sbtractvalue: Number(AmountPaid) - finalAmountData.total,
                    Type: saleTypeId == 1 ? "Invoice" : "Creditcard",
                  };

                  axios
                    .post(
                      `${config.salesconfigBaseUrl}/sales/paymentSettleByModule`,
                      reqobj
                    )
                    .then((res) => {})
                    .catch((err) => {});
                }

                setTimeout(() => {
                  navigate(`/sales-receipt/${res.data.ResponseID}`);
                }, 200);
                // Swal.fire({
                //   icon: "success",
                //   title: "Success!",
                //   text: `Data inserted successfully. Response ID: ${res.data.ResponseID}`,
                //   confirmButtonText: "view Receipt",
                // }).then((result) => {
                //   if (result.isConfirmed) {
                //     navigate(`/sales-receipt/${res.data.ResponseID}`);
                //     // setSalePOSId(res.data.ResponseID);
                //     // setReciptModel(true);
                //   }
                // });
              } else if (type === "Payment") {
                SubmitReceivePayment(res.data.ResponseData[0]);
              }
            } else if (res.data.ResponseCode === "ERROR") {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "An error occurred while processing your request.",
              });
              toastError(ERROR_MESSAGE);
            }
            setLoading(false);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Request Failed",
              text: `Error: ${error.message || "Something went wrong!"}`,
            });
            setLoading(false);
          });
      } else {
        // User cancelled the action
        Swal.fire({
          icon: "info",
          title: "Cancelled",
          text: "Invoice generation has been cancelled.",
        });
      }
    });
  };

  const handelItemVariationAPi = async (itemId) => {
    setVariationlistData([]);
    await axios
      .get(
        `${
          config.ecommBackendBaseUrl
        }/products/detail?itemid=${itemId}&loginuserid=${customerId}&roleId=${
          customerDetail?.RoleTierID || 0
        }`
      )
      .then((response) => {
        const CategoryName =
          response?.data?.ResponseData?.ItemDetails[0]?.CategoryName || "";
        const data = response?.data?.ResponseData?.VaraiationsList?.map(
          (el) => {
            return {
              id: el?.ItemID,
              src: el?.Image ? el?.Image : "",
              alt: el?.Name,
              title: el?.Name ? el?.Name : "",
              itemsCount: 0,
              ParentId: 0,
              type: "Product",
              IsShowEcommerceMenu: 1,
              isInCart: false,
              cartQty: 1,
              cartPrice: el?.RecallPrice > 0 ? el?.RecallPrice : el?.Price, // for show and cart price and add a role wise price
              Tier1Price: el?.Tier1Price,
              Tier2Price: el?.Tier2Price,
              Tier3Price: el?.Tier3Price,
              Tier4Price: el?.Tier4Price,
              Tier5Price: el?.Tier5Price,
              RecallPrice: el?.RecallPrice,
              UnitPrice: el?.Price,
              variationId: el?.VariationID,
              cartDiscountType: "percent", //"Percentage"
              cartDiscount: 0,
              cartTaxType: "Percentage", //"Percentage"
              cartTax: 0,
              cartTotal: 0,
              cartSubTotal: 0,
              cartTotalDiscount: 0,
              cartTotalTax: 0,
              CategoryID: el.CategoryID,
              CostPrice: el.CostPrice,
              CurrantQTY: el?.VariationQuantity,
              QuickBookId: el.QuickBookId,
              isFavourite: false,
              CategoryName: CategoryName,
              ItemNumber: el.ItemNumber,
            };
          }
        );
        // setVariationlistData(data);
        setMainFilterData([]);
        setMainFilterData(handleReturnFavourateData(data));
        setdata(data);
      })
      .catch((error) => ({ error: JSON.stringify(error) }));
  };

  const handelCartFilterChange = (value, field) => {
    if (field === "priceRule") {
      setCartPriceRuleSelect(value);
      if (value != 2) {
        setCartTierPriceSelect(0);
        cartData?.map((el, index) =>
          handelcartList(
            value === 1 ? el.UnitPrice : el.RecallPrice,
            index,
            "cartPrice"
          )
        );
      }
    } else if (field === "roleTier") {
      setCartTierPriceSelect(value);
      cartData?.map((el, index) =>
        handelcartList(
          value === 1
            ? el.Tier1Price
            : value === 2
            ? el.Tier2Price
            : value === 3
            ? el.Tier3Price
            : value === 4
            ? el.Tier4Price
            : el.Tier5Price,
          index,
          "cartPrice"
        )
      );
    } else {
      cartData.forEach((item, index) => {
        const titleMatches = item.title
          ?.toLowerCase()
          .includes(cartItemFilterInput?.toLowerCase());
        const categoryMatches =
          cartCategoryFilterSelect <= 0 ||
          item?.CategoryID === cartCategoryFilterSelect;

        if (titleMatches && categoryMatches) {
          handelcartList(value, index, field);
        }
      });
      // cartData?.map((el, index) => handelcartList(value, index, field));
    }

    console.log(cartData, "cartData");
  };

  const handelItemFilterChange = (value, field) => {
    if (field === "priceRule") {
      setItemPriceRuleSelect(value);
      if (value != 2) {
        setItemTierPriceSelect(0);
        setMainFilterData((prevData) =>
          prevData.map((el) => ({
            ...el,
            cartPrice: value === 1 ? el.UnitPrice : el.RecallPrice,
          }))
        );
      }
    } else if (field === "roleTier") {
      setItemTierPriceSelect(value);
      setMainFilterData((prevData) =>
        prevData.map((el) => ({
          ...el,
          cartPrice:
            value === 1
              ? el.Tier1Price
              : value === 2
              ? el.Tier2Price
              : value === 3
              ? el.Tier3Price
              : value === 4
              ? el.Tier4Price
              : el.Tier5Price,
        }))
      );
    }
  };

  const handleAdvanceFilterInput = (value, field) => {
    if (mainFilterData?.filter)
      setMainFilterData((prevFilterData) =>
        prevFilterData.map((el) =>
          el.type === "Product" && el.isInCart === true
            ? { ...el, [field]: Number(value) }
            : el
        )
      );
  };

  const handleAdvanceFilterBulkToCart = () => {
    const newCartData = [...cartData]; // Make a copy of current cart data

    // Filter and process the items to add/update
    const itemsToProcess = mainFilterData?.filter(
      (el) =>
        el?.type === "Product" &&
        el.itemsCount === 0 &&
        (filterAllStockData ? Number(el.CurrantQTY) > 0 : true)
    );

    itemsToProcess?.forEach((item) => {
      const findIndex = newCartData.findIndex(
        (cat) => cat.id === item.id && cat.variationId === item.variationId
      );

      if (findIndex !== -1) {
        // Update the existing item
        newCartData[findIndex] = {
          ...newCartData[findIndex],
          cartQty: Number(item?.cartQty),
          cartPrice: Number(item?.cartPrice),
          cartTotal: Number(item?.cartQty * item?.cartPrice).toFixed(2),
          cartSubTotal: Number(item?.cartQty * item?.cartPrice).toFixed(2),
        };
      } else {
        // Add a new item
        newCartData.unshift({
          ...item,
          rowIndex: newCartData.length + 1, // Correct rowIndex
          cartTotal: Number(item?.cartQty * item?.cartPrice).toFixed(2),
          cartSubTotal: Number(item?.cartQty * item?.cartPrice).toFixed(2),
        });
      }
    });

    // Update the state once
    setCartData(newCartData);
  };

  const handelFinalAmount = (value, field) => {
    setFinalData((prev) => {
      return { ...prev, [field]: value };
    });

    if (field === "FinalShipValue") {
      setSalesDeliveryData((prev) => {
        return { ...prev, DeliveryFees: value || 0 };
      });
      setCustomerDetail((prev) => {
        return { ...prev, DeliveryFees: value || 0 };
      });
      setFinalData((prev) => {
        return { ...prev, FinalShipValue: value };
      });
    }

    if (field === "FinalGstType") {
      cartData?.map((el, index) => handelcartList(value, index, "cartTaxType"));
    } else if (field === "FinalGstValue") {
      cartData?.map((el, index) =>
        handelcartList(finalData.FinalGstType, index, "cartTaxType")
      );
      cartData?.map((el, index) =>
        handelcartList(value ? value : 0, index, "cartTax")
      );
    }
  };

  useEffect(() => {
    // Calculate subtotal
    const subtotal = cartData.reduce(
      (acc, item) => acc + parseFloat(item.cartPrice) * item.cartQty,
      0
    );

    // Calculate total discount (based on the type)
    const totalDiscount = cartData.reduce((acc, item) => {
      let discountAmount = 0;
      if (item.cartDiscountType === "percent") {
        discountAmount =
          (parseFloat(item.cartPrice) * item.cartQty * item.cartDiscount) / 100;
      } else if (item.cartDiscountType === "amount") {
        discountAmount = parseFloat(item.cartDiscount); // * item.cartQty;
      }
      return acc + discountAmount;
    }, 0);

    // Calculate total tax (based on the type)
    const totalTax = cartData.reduce((acc, item) => {
      let taxAmount = 0;
      if (item.cartTaxType === "Percentage") {
        taxAmount =
          ((parseFloat(item.cartPrice) * item.cartQty -
            totalDiscount / cartData.length) *
            item.cartTax) /
          100;
      } else if (item.cartTaxType === "Fixed") {
        taxAmount = parseFloat(item.cartTax) * item.cartQty;
      }
      return acc + taxAmount;
    }, 0);

    // Calculate additional discount
    let extraDiscountAmount = 0;
    if (finalData?.FinalDisType === "Percentage") {
      extraDiscountAmount = (subtotal * finalData?.FinalDisValue || 0) / 100;
    } else if (finalData?.FinalDisType === "Fixed") {
      extraDiscountAmount = finalData?.FinalDisValue || 0;
    }

    // Example shipping cost (you can replace with your logic)
    const shipping = Number(finalData?.FinalShipValue) || 0;

    // Calculate the total
    const total =
      subtotal - totalDiscount - extraDiscountAmount + totalTax + shipping;

    // Log or store the values as required
    const finalAmountObject = {
      subtotal,
      totalDiscount,
      totalTax,
      extraDiscountAmount,
      shipping,
      total,
    };
    console.log(finalAmountObject, "finalDataofSale");

    setFinalAmountData(finalAmountObject);
    setTotalReceivingAmount(saleId > 0 ? salesOpenBalance : total);
    const totalcartQtyCount = cartData.reduce(
      (acc, item) => Number(acc) + Number(item.cartQty || 0),
      0
    );
    setCartTotalQty(totalcartQtyCount);

    const CheckErrorDataStatus = cartData.some(
      (item) =>
        !(
          (
            Number(item.cartPrice || 0) * Number(item.cartQty || 0) -
            Number(item.cartTotalDiscount || 0)
          ).toFixed(2) == Number(item.cartTotal).toFixed(2)
        )
    );
    setCheckErrorData(CheckErrorDataStatus);
  }, [cartData, finalData]);

  useEffect(() => {
    if (checkErrorData) {
      handelErrorCartData(checkErrorData);
    }
  }, [checkErrorData]);

  const handelAddItemBulkVariation = () => {
    variationlistData
      ?.filter((el) =>
        el?.title.toLowerCase().includes(variationFilterValue?.toLowerCase())
      )
      .map((cat) => {
        handelMainFilter(cat);
      });
  };
  useEffect(() => {
    axios
      .get(`${config.deliveriesBaseUrl}/deliveries/deliverymethodlist`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const deliveryData = response.data.ResponseData?.map((el) => {
          return { label: el.Name, value: el.ID };
        });
        setSaleTypeMethod(deliveryData || []);

        // Set the delivery method name based on the matching ID or the first available value
        // let defaultDeliveryMethodName = "";
        // if (deliveryMethodId > 0) {
        //   const matchedDeliveryMethod = response.data.ResponseData?.find(
        //     (el) => el.ID === deliveryMethodId
        //   );
        //   if (matchedDeliveryMethod) {
        //     defaultDeliveryMethodName = matchedDeliveryMethod.Name;
        //   } else {
        //     console.log("Delivery method not found");
        //   }
        // } else if (response.data.ResponseData?.length > 0) {
        //   defaultDeliveryMethodName = response.data.ResponseData[0].Name;
        //   // setDeliveryMethodId(response.data.ResponseData[0].ID); // Set default ID if needed
        // }

        // setdeliveryMethodName(defaultDeliveryMethodName);

        console.log(response.data.ResponseData, "=====deliverymethodlist");
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.generalBaseUrl}/generals/termsddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const termsData = res.data.ResponseData || [];
        // setTerm(res.data.ResponseData || []); // Ensure `ResponseData` exists
        setTerm(termsData);
        const selectTermsObj = termsData?.find((el) => el.ID === 1);
        if (selectTermsObj && saleId == 0) {
          setSelectedTerm(selectTermsObj?.ID);
          setSelectedTermQuickBookID(selectTermsObj?.QuickBookID);
        }
      })
      .catch((err) => {
        console.error("Error fetching terms dropdown:", err);
      });

    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        const responseData = response.data.ResponseData;

        if (Array.isArray(responseData) && responseData.length > 0) {
          setSaleOptions(responseData);

          // Set default selection based on the current saleTypeId
          const defaultOption = responseData.find(
            (option) => option.ID === saleTypeId
          );
          // setSelectedSaleOption(
          //   defaultOption ? defaultOption.SalesType : "Sale"
          // );
        }
      });

    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Account`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setTag(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(
        `${config.quickbooksBaseUrl}/quickbooks/companyname?loginuserid=${LoginId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log(res?.data, "###");
        setcompanyname(res?.data);
        setLabel(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [deliveryMethodId]);

  const termOptions = term.map((u) => ({
    label: u.Name,
    value: u.ID,
    actualValue: u.Value,
    QuickBookID: u.QuickBookID,
  }));

  const salesTypeDropdownOption = Saletype.map((u) => ({
    label: u.SalesType,
    value: u.ID,
  }));

  // Set default value when Saletype is available
  useEffect(() => {
    if (Saletype.length > 0) {
      setSaleTypeId(Saletype[0].ID); // Set default to the first SalesType ID
    }
  }, [Saletype]);

  const handleChangeSalesType = (selectedOption) => {
    // Update the state when the user selects a new option
    setSaleTypeId(selectedOption.value);
  };

  console.log(salesTypeDropdownOption, "salesTypeID132");

  const callbackSalesDeliveryModel = (payload, mappedItem) => {
    console.log(payload, "545454");
    // const deliveryTaxAvailable = taxData.some(
    //   (item) => item.type === "deliveryTax"
    // );

    // const deliveryTaxXmlTaxAvailable = taxXml.some(
    //   (item) => item.type === "deliveryTax"
    // );
    // console.log("deliveryTaxAvailable", deliveryTaxAvailable);
    // if (deliveryTaxAvailable && deliveryTaxXmlTaxAvailable) {
    //   const updatedTaxData = taxData.filter(
    //     (item) => item.type !== "deliveryTax"
    //   );

    //   const updatedTaxXmldata = taxXml.filter(
    //     (item) => item.type != "deliveryTax"
    //   );
    //   // console.log("updatedTaxData::>>", updatedTaxData);
    //   setTaxData([...updatedTaxData, ...mappedItem]);
    //   setTaxXml([...updatedTaxXmldata, ...mappedItem]);
    // } else {
    //   setTaxData([...taxData, ...mappedItem]);
    //   setTaxXml([...taxXml, ...mappedItem]);
    // }

    setDeliveryMethodId(payload.deliveryMethodId);
    if (payload == "CancelDelivery") {
      setDeliveryMethodId(payload.deliveryMethodId);
      setSalesDeliveryData(null);
      setFinalAmountData((prev) => {
        return { ...prev, shipping: 0 };
      });
      // setIsChangedData(true);
    } else {
      setDeliveryMethodId(payload.deliveryMethodId);
      setFinalData((prev) => {
        return { ...prev, FinalShipValue: payload?.DeliveryFees || 0 };
      });
      setCustomerDetail((prev) => {
        return { ...prev, DeliveryFees: payload?.DeliveryFees || 0 };
      });
      setFinalAmountData((prev) => {
        return { ...prev, shipping: payload?.DeliveryFees || 0 };
      });
      setSalesDeliveryData(payload);
      setShippingAddressId(payload.Id);
    }
  };

  const callbackScannerBulkCartData = (scanCartData) => {
    const callBackData = scanCartData?.map((item) => {
      return {
        id: item?.ID,
        src: item?.Image ? item?.Image : "",
        alt: item?.Name,
        title: item?.Name ? item?.Name : "",
        itemsCount: item?.TotalVariation,
        ParentId: 0,
        type: "Product",
        IsShowEcommerceMenu: 1,
        isInCart: true,
        cartQty: item?.inputQuantity,
        cartPrice: item?.FinalPrice, // for show and cart price
        Tier1Price: item?.Tier1Price,
        Tier2Price: item?.Tier2Price,
        Tier3Price: item?.Tier3Price,
        Tier4Price: item?.Tier4Price,
        Tier5Price: item?.Tier5Price,
        RecallPrice: item?.RecallPrice,
        UnitPrice: item?.Unitprice,
        variationId: item?.variationId,
        cartDiscountType: "percent", //"Percentage"
        cartDiscount: 0,
        cartTaxType: "Percentage", //"Percentage"
        cartTax: 0,
        cartTotal: Number(item?.inputQuantity) * Number(item?.RecallPrice),
        cartSubTotal: Number(item?.inputQuantity) * Number(item?.RecallPrice),
        cartTotalDiscount: 0,
        cartTotalTax: 0,
        CategoryID: item.CategoryId,
        CostPrice: item.Costprice,
        QuickBookId: item.QuickBookId,
        CurrantQTY: item?.Quantity,
        isFavourite: false,
      };
    });

    callBackData?.forEach((e) => {
      const findIndex = cartData.findIndex(
        (el) => el.id == e.id && el.variationId == e.variationId
      );
      console.log(findIndex, "findIndex");
      if (findIndex != -1) {
        handelcartList(
          Number(cartData[findIndex].cartQty || 0) + e?.cartQty,
          findIndex,
          "cartQty"
        );
        handelcartList(e?.cartPrice, findIndex, "cartPrice");
      } else {
        setCartData((prev) => [
          {
            ...e,
            cartQty: e?.cartQty,
            cartTotal: Number(e?.cartQty * e?.cartPrice).toFixed(2),
            cartSubTotal: Number(e?.cartQty * e?.cartPrice).toFixed(2),
          },
          ...prev,
        ]);
      }
    });
    setStartScannerCamera(false);
    console.log(scanCartData, "scanCartData");
    toastSuccess("Sacned Product Successfully Added to Cart");
  };

  const sortedData = [...mainFilterData].sort((a, b) =>
    a.title.localeCompare(b.title)
  );

  // const callbackItemSearch = (payloads) => {
  //   console.log(payloads, "item search result");
  //   if (payloads?.length > 0) {
  //     const item = payloads[0];
  //     const findIndex = cartData.findIndex(
  //       (cat) => cat.id == item.ItemId && cat.variationId == item.VariationId
  //     );

  //     const itemName =
  //       (item?.VariationName ? item?.VariationName : item?.ItemName) || "";
  //     const finalObject = {
  //       id: item?.ItemId,
  //       src: item?.ImageName ? item?.ImageName : "",
  //       alt: itemName,
  //       title: itemName,
  //       itemsCount: 0,
  //       ParentId: 0,
  //       type: "Product",
  //       IsShowEcommerceMenu: 1,
  //       isInCart: true,
  //       cartQty: 1, // findIndex > -1 ? cartData[findIndex].cartQty + 1 : 1, // + 1
  //       cartPrice:
  //         findIndex > -1 ? cartData[findIndex].cartPrice : item?.RecallPrice, // for show and cart price
  //       Tier1Price: item?.Tier1,
  //       Tier2Price: item?.Tier2,
  //       Tier3Price: item?.Tier3,
  //       Tier4Price: item?.Tier4,
  //       Tier5Price: item?.Tier5,
  //       RecallPrice: item?.RecallPrice,
  //       UnitPrice: item?.UnitPrice,
  //       variationId: item?.VariationId,
  //       cartDiscountType: "percent", //"Percentage"
  //       cartDiscount: 0,
  //       cartTaxType: "Percentage", //"Percentage"
  //       cartTax: 0,
  //       cartTotal: 1 * Number(item?.RecallPrice),
  //       cartSubTotal: 1 * Number(item?.RecallPrice),
  //       cartTotalDiscount: 0,
  //       cartTotalTax: 0,
  //       CategoryID: item.CategoryID,
  //       CostPrice: item.CostPrice,
  //       QuickBookId: item.QuickbookId,
  //       CurrantQTY: item?.Itemquantity,
  //       isFavourite: false,
  //     };
  //     handelMainFilter(finalObject);
  //     setTimeout(() => {
  //       handleSearchQtyInputRef();
  //     }, 200);
  //     // setCartData((prev)=> [finalObject, ...prev])
  //   }
  // };

  const callbackItemSearch = async (payloads) => {
    console.log(payloads, "item search result");
    if (!Array.isArray(payloads) || payloads.length === 0) return;
    const item = payloads[0];

    const itemId = item?.ItemId;
    const variationId = item?.VariationId;
    if (itemId == null || variationId == null) return;

    const itemName =
      (item?.VariationName ? item?.VariationName : item?.ItemName) || "";
    const recallPrice = Number(item?.RecallPrice || 0);

    // Upsert / increment cart item
    setCartData((prev) => {
      const existingIndex = prev.findIndex(
        (ci) => ci.id === itemId && ci.variationId === variationId
      );
      let updatedCart = [...prev];

      if (existingIndex > -1) {
        const existing = updatedCart[existingIndex];
        const newQty = Number(existing.cartQty || 0) + 1;
        const cartSubTotal = recallPrice * newQty;
        const cartTotal =
          recallPrice * (newQty - Number(existing?.cartTotalDiscount || 0));

        const updatedObject = {
          ...existing,
          cartQty: newQty,
          cartPrice: recallPrice,
          cartSubTotal,
          cartTotal,
        };

        updatedCart = [
          updatedObject,
          ...updatedCart.filter((_, i) => i !== existingIndex),
        ];
      } else {
        const finalObject = {
          id: itemId,
          src: item?.ImageName ? item?.ImageName : "",
          alt: itemName,
          title: itemName,
          itemsCount: 0,
          ParentId: 0,
          type: "Product",
          IsShowEcommerceMenu: 1,
          isInCart: true,
          cartQty: 1,
          cartPrice: recallPrice,
          Tier1Price: item?.Tier1,
          Tier2Price: item?.Tier2,
          Tier3Price: item?.Tier3,
          Tier4Price: item?.Tier4,
          Tier5Price: item?.Tier5,
          RecallPrice: recallPrice,
          UnitPrice: item?.UnitPrice,
          variationId: variationId,
          cartDiscountType: "percent",
          cartDiscount: 0,
          cartTaxType: "Percentage",
          cartTax: 0,
          cartTotal: 1 * recallPrice,
          cartSubTotal: 1 * recallPrice,
          cartTotalDiscount: 0,
          cartTotalTax: 0,
          CategoryID: item.CategoryID,
          CostPrice: item.CostPrice,
          QuickBookId: item.QuickbookId || item.itemquickbookid,
          CurrantQTY: item?.Itemquantity,
          isFavourite: false,
        };
        updatedCart = [finalObject, ...updatedCart];
      }

      return updatedCart;
    });

    // Optional external filter action
    const finalObjectForFilter = {
      id: itemId,
      src: item?.ImageName ? item?.ImageName : "",
      alt: itemName,
      title: itemName,
      cartQty: 1,
      cartPrice: recallPrice,
      variationId,
      // ... you can include other fields if needed like in handelMainFilter previously
    };
    handelMainFilter(finalObjectForFilter);

    setTimeout(() => {
      handleSearchQtyInputRef();
    }, 200);

    // Fetch and apply AOC asynchronously
    const responseItem = await handleFetchCustAOC(
      customerId,
      itemId,
      variationId
    );
    if (responseItem) {
      setCartData((prev) =>
        prev.map((cartItem) => {
          if (
            cartItem.id === responseItem.ItemID &&
            cartItem.variationId === responseItem.ItemVariationID
          ) {
            return {
              ...cartItem,
              AvgUnitPrice: responseItem.AvgUnitPrice,
              AvgQuantity: responseItem.AvgQuantity,
            };
          }
          return cartItem;
        })
      );
    }
  };

  const handleSearchQtyInputRef = (event) => {
    if (searchItemInputRef.current) {
      searchCartQtyInputRef.current.focus();
      searchCartQtyInputRef.current.select(); // Optional: Select the Discount input value
    }
  };

  const handleGlobalSearchQtyInputRef = () => {
    if (globalSearchItemInputRef.current) {
      globalSearchItemInputRef.current.focus();
      globalSearchItemInputRef.current.select(); // Ensures text is selected
    }
  };

  const handleQtyKeyDown = (event) => {
    if (event.key === "Enter" && searchItemInputRef.current) {
      searchItemInputRef.current.focus();
      searchItemInputRef.current.select(); // Optional: Select the Discount input value
    }
  };

  const handleClearData = () => {
    getCategoryData(0);
    getPaymentMethodsList(0);
    setGlobalFilterInput("");
    // setShowMenu("Category");
    setBackToMenu([]);
    setCartData([]);
    setCustomerDetail({});
    setCustomerId(0);
    setShippingAddressId(0);
    setShippingAddressOption([]);
    setShippingUpdateOptionId(0);
    setCustomerShippingUpdateData({
      ID: 0,
      Address1: "",
      Address2: "",
      City: "",
      StateProvince: "",
      Zip: "",
      Country: "",
    });
    setCartPriceRuleSelect(3);
    setVariationFilterValue("");
    setNewCartBulkPrice("");
    setNewCartBulkQty("");
    setCartCategoryFilterSelect(0);
    setcartItemFilterInput("");
    setToggleItemsFilterSection(false);
    setFinalData({
      FinalGstType: "Percentage",
      FinalGstValue: "",
      FinalShipValue: "",
      FinalDisType: "Percentage",
      FinalDisValue: "",
    });
    setFinalAmountData({
      subtotal: 0,
      totalDiscount: 0,
      totalTax: 0,
      extraDiscountAmount: 0,
      shipping: 0,
      total: 0,
    });
    setPaymentMethod([]);
    setCartTotalQty(0);
    setDeliveryMethodId(0);
    setSalePOSId(0);
    setSelectedTerm(1);
    setSelectedTermQuickBookID(1);
    setDueDate(moment().format("YYYY-MM-DD"));
    setStartDate(moment().format("YYYY-MM-DD"));
    setRunApi(false);
    setAdvanceItemFilterInput({
      ItemQty: 0,
      ItemPrice: 0,
    });
    setSalesDeliveryData({});
    setFilterAllStockData(true);
    setSaleTypeId(1);
    setShowItemMoreDetails(false);
    setItemDetailModelId(0);
    setShowHistoryList(false);
    setStartScannerCamera(false);
    // setFilterQtyDataList(0);
    setTooltipStates({});
    setAccountSaleData({
      InvoiceMessage: "",
      InvoiceStatement: "",
      Attachment: "",
    });
    // setIsOpen(false);
    setSelectedtags("");
    setReferenceNumber("");
    setDepositToAccountQuickbookId(0);
    setDepositTo(0);
    setExtraPaymentAmount(0);
    setRadioOption("unapplied");
    setShowDepositToError(false);
    setTotalReceivingAmount(0);
    setMemoData("");
    setAttachmentUrl("");
    setSalesQuickbookId(0);
    setFavouriteList([]);
    setSalesOpenBalance(0);
    setSelectedPaymentMethod({
      label: "Cash",
      value: 1,
      paymentquickbookid: 14,
    });
    if (tooltipRef.current) {
      tooltipRef.current.contains(null);
    }
    if (tooltipRefPrice.current) {
      tooltipRefPrice.current.contains(null);
    }
    if (tooltipRefSum.current) {
      tooltipRefSum.current.contains(null);
    }
  };

  const cancleEdit = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "Are You Sure, You want to Cancel Changes",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, Cancel it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        handleClearData();
        setTimeout(() => {
          navigate("/pos");
        }, 200);
        toastSuccess("Changes Cancel Successfully done");
      } else {
        MySwal.close();
      }
    });
  };

  // useEffect(() => {
  //   handelMainFilter();
  // }, [filterQtyDataList]);

  const backmenuhome = () => {
    setBackToMenu([]);
    getCategoryData(0);
    setShowMenu(
      "Category"
      // <>
      //   <i className="fa fa-home"></i> POS
      // </>
    );
  };

  const uploadFilePDF = async (file, type, attachmentType) => {
    setBtnFileLoader({ [type]: true });

    await uploadAWS(file, AWS_IMAGE_FOLDER_POS, (data) => {
      console.log(data, type, "data1452");
      if (data) {
        if (type === "SalesAttachment") {
          setFileName(file.name);
          setAccountSaleData((prevValues) => ({
            ...prevValues,
            ["Attachment"]: data,
          }));
        } else if (type === "PaymentAttachment") {
          setAttachmentUrl(data);
        }
      }
    });
  };

  const handleFileChange = (event, attachmentType) => {
    setChangeFileName(true);

    if (validation(event.target.name, event?.currentTarget?.files[0])) {
      uploadFilePDF(
        event?.currentTarget?.files[0],
        event.target.name,
        attachmentType
      );
    }

    const files = event.target.files;
    console.log(files, "files[i]");
    if (files) {
      let images = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          images.push({
            name: files[i].name,
            preview: e.target.result,
          });
        };
        reader.readAsDataURL(files[i]);
      }
    }
  };

  const validation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  // Load draft from local storage on component mount --- Start
  const loadDraft = (savedDraft) => {
    getShippingAddressByCustomerId(savedDraft.customerId);
    getCustomerfavouriteitemslist(savedDraft.customerId);
    setCustomerId(savedDraft.customerId);
    setCustomerDetail(savedDraft.customerDetail);
    setCartData(savedDraft.cartData);
    setFinalData(savedDraft.finalData);
    setFinalAmountData(savedDraft.finalAmountData);
    setSelectedTerm(savedDraft?.selectedTerm);
    setSelectedTermQuickBookID(savedDraft?.selectedTermQuickBookID);
    setDueDate(savedDraft?.dueDate);
    setStartDate(savedDraft?.startDate);
    setDeliveryMethodId(savedDraft.deliveryMethodId);
    setSalesDeliveryData(savedDraft?.salesDeliveryData);
    setAccountSaleData(savedDraft?.accountSaleData);
    setShippingAddressId(savedDraft?.shippingAddressId);
    setSelectedtags(savedDraft?.selectedtags);
  };

  useEffect(() => {
    if (saleId === 0) {
      const savedDraft = JSON.parse(localStorage.getItem("posDraft"));
      if (savedDraft) {
        loadDraft(savedDraft);
        console.log("Draft getData:", savedDraft);
      }
    }
  }, []);

  // getShippingAddressByCustomerId for getting shipping address for sale
  const createDraft = () => {
    return {
      customerId,
      customerDetail,
      cartData,
      finalData,
      finalAmountData,
      selectedTerm,
      selectedTermQuickBookID,
      dueDate,
      startDate,
      deliveryMethodId,
      salesDeliveryData,
      // salesDeliveryData:{...salesDeliveryData, deliveryMethodId: deliveryMethodId },
      accountSaleData,
      shippingAddressId,
      selectedtags,
    };
  };
  // Save draft to local storage whenever any state changes
  useEffect(() => {
    if (saleId === 0) {
      const posDraft = createDraft();
      localStorage.setItem("posDraft", JSON.stringify(posDraft));
      console.log("Draft auto-saved:", posDraft);
    }
  }, [
    customerId,
    customerDetail,
    cartData,
    finalData,
    finalAmountData,
    selectedTerm,
    selectedTermQuickBookID,
    dueDate,
    startDate,
    deliveryMethodId,
    salesDeliveryData,
    accountSaleData,
    shippingAddressId,
    selectedtags,
  ]);

  // hold list of the customer getting from the customer
  useEffect(() => {
    const storedHoldList = JSON.parse(localStorage.getItem("holdList")) || [];
    setHoldList(storedHoldList);
  }, []);

  useEffect(() => {
    const count = holdList?.filter((el) => el?.isChecked)?.length || 0;
    setHoldListCount(count);
    localStorage.setItem("holdList", JSON.stringify(holdList));
  }, [holdList]);

  const handelAddToDraft = () => {
    if (saleId === 0) {
      const savedDraft = JSON.parse(localStorage.getItem("posDraft"));
      if (savedDraft && savedDraft?.customerId > 0) {
        setHoldList((prevHoldList) => {
          const maxDraftId = prevHoldList.reduce(
            (maxId, hold) => Math.max(maxId, hold.DraftId),
            0
          );
          return [
            {
              ...savedDraft,
              DraftId: maxDraftId + 1,
              isChecked: false,
              draftDate: moment().format("MM-DD-YYYY hh:mm:ss A"),
            },
            ...prevHoldList,
          ];
        });
        handleClearData();
      } else {
        toastError("No data Found in Draft");
      }
    } else {
      toastError("you Can't Add to Draft, because are in Sale Edit");
    }
  };

  const handelDraftSelect = (check, index) => {
    const daftUpdateList = [...holdList];
    daftUpdateList[index].isChecked = check;
    setHoldList(daftUpdateList);
  };

  const removeDraft = () => {
    setHoldList((prevHoldList) =>
      prevHoldList.filter((item) => !item?.isChecked)
    );
    // console.log("Draft removed:", id);
  };

  const retrieveDraft = (draft) => {
    if (saleId === 0) {
      // const draft = holdList.find((item) => item.isChecked);
      if (draft) {
        loadDraft(draft);
        console.log("Draft retrieved:", draft);
        setHoldList((prevHoldList) =>
          prevHoldList.filter((item) => item?.DraftId != draft?.DraftId)
        );
      } else {
        console.error("Draft not found");
      }
    } else {
      toastError("you Can't retrieve Draft, because are in Sale Edit");
    }
  };

  const handlePaymentChangeInput = (event, fieldName) => {
    if (fieldName === "ReferenceNumber") {
      setReferenceNumber(event.target.value);
    } else if (fieldName === "DepositTo") {
      setDepositToAccountQuickbookId(
        event?.DepositQuickbookId === undefined ? 0 : event?.DepositQuickbookId
      );
      setDepositTo(event?.value === undefined ? 0 : event?.value);
      setShowDepositToError(
        event?.value !== undefined || depositTo == 0 ? false : true
      );
    } else if (fieldName === "AmountReceived") {
      console.log(event?.target?.value, "valuessss");
      console.log(
        saleId > 0 ? salesOpenBalance : finalAmountData.total,
        "valuessss2"
      );
      console.log(
        event?.target?.value >
          (saleId > 0 ? salesOpenBalance : finalAmountData.total),
        "valuessss3"
      );
      setTotalReceivingAmount(event?.target?.value);
      if (
        event?.target?.value >
        (saleId > 0 ? salesOpenBalance : finalAmountData.total)
      ) {
        setExtraPaymentAmount(
          // event.target.value - (saleId > 0 ? salesOpenBalance : finalAmountData.total)
          Math.max(
            event.target.value -
              (saleId > 0 ? salesOpenBalance : finalAmountData.total),
            0
          )
        );
      } else {
        setExtraPaymentAmount(0);
      }
      // setShowAmountReceivedError(event?.target?.value < 0 ? true : false);
    } else if (fieldName === "Memo") {
      setMemoData(event.target.value);
    }
  };

  const handleRadioChange = (e) => {
    console.log(e.target.value, "Radio Option");
    setRadioOption(e.target.value);
  };

  const SubmitReceivePayment = (salesData) => {
    console.log(salesData, "checksaledata");
    const paymentInvoiceData = [
      {
        RowNumber: 0,
        TxnID: 0,
        CustomerID: customerDetail.Id,
        CustomerName: `${customerDetail.FirstName} ${customerDetail.LastName}`,
        Description: "",
        DueDate: "",
        OriginalAmount: finalAmountData.total,
        OpenBalance: finalAmountData.total,
        InvoiceNo: salesData.ID,
        InvoiceDate: moment(startDate).format("YYYY-MM-DD"),
        CreatedDate: "",
        Type: "Invoice",
        SalesQuickbookId: saleId > 0 ? salesQuickbookId : salesData.QuickBookId,
        ID: salesData.SaleId,
        SalePaymentID: 0,
        AmountPaid: "0.00",
        CustomerQuickbookID: customerDetail.QuickbookID,
        PaymentMethodQuickbookId: selectedPaymentMethod.paymentquickbookid,
        IsJournalEntry: 0,
        MatchTxnID: 0,
        CreatedDateOrder: "",
        TotalReceivedAmount: "0.00",
        PaymentDateAll: "0",
        PaymentMethodIdAll: 0,
        AttachmentUrlAll: "",
        MemoDataAll: "",
        DepositToAccountQuickbookIdAll: 0,
        DepositToAll: 0,
        ReferenceNumberAll: "",
        PaymentMethodQuickbookIdAll: 0,
        TxnQuickbookId: 0,
        Payment:
          saleId === 0
            ? totalReceivingAmount < finalAmountData.total
              ? totalReceivingAmount
              : finalAmountData.total
            : totalReceivingAmount < salesOpenBalance
            ? totalReceivingAmount
            : salesOpenBalance,
        // Payment: totalReceivingAmount < finalAmountData.total ? totalReceivingAmount : finalAmountData.total,
        isInvoice: 1,
        isCreditJournalEntry: 0,
      },
    ];
    console.log(paymentInvoiceData, "checkpaymentInvoiceData");

    const paymentDataObject = {};
    paymentDataObject.XMLBill = paymentInvoiceData;

    let paymentDataJsonString = JSON.stringify(paymentDataObject);

    let amountReceived =
      radioOption === "unapplied"
        ? totalReceivingAmount
        : radioOption === "chnageBack"
        ? totalReceivingAmount - extraPaymentAmount > 0
          ? totalReceivingAmount - extraPaymentAmount
          : totalReceivingAmount
        : 0; // Default case if neither condition matches

    let receivePaymentData = {
      TransactionId: 0,
      InvoiceXml: paymentDataJsonString,
      CustomerId: customerDetail.Id,
      PaymentDate: moment(startDate).format("YYYY-MM-DD"),
      PaymentMethod: selectedPaymentMethod.value,
      DepositTo: depositTo,
      Memo: memoData,
      RefNo: referenceNumber,
      AttechMents: attachmentUrl,
      AmountReceived: amountReceived,
      LogninUser: LoginId,
      QuickBookId: 0,
      LocationId: Location,
      CustomerQuickBookId: customerDetail.QuickbookID,
      PaymentQuickbookId: selectedPaymentMethod.paymentquickbookid,
      DepositToAccountQuickbookId: depositToAccountQuickbookId,
      changeReturnAmount: radioOption === "chnageBack" ? extraPaymentAmount : 0,
    };
    console.log(receivePaymentData, "receivePaymentData");

    let previosdata = [
      {
        SalesQuickbookId: saleId > 0 ? salesQuickbookId : salesData.QuickBookId,
        Type:
          salesData.SaleType == 1
            ? "Invoice"
            : salesData.SaleType == 2
            ? "CreditMemo"
            : "",
        AmountPaid: totalReceivingAmount,
        IsJournalEntry: 0,
      },
    ];

    // setpreciosdata(array);

    Swal.fire({
      title: "Submitting Payment...",
      text: "Please wait while we process your request.",
      showConfirmButton: false,
      allowOutsideClick: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    // API CALL FOR Payment Insert
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/salesreceivingsupsertV2`,
        receivePaymentData,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          // setpreviousid(res.data.ResponseID);
          const txnId = res.data.ResponseID;
          const RollBackId = res.data.ResponseData;
          if (!QBpermission) {
            handleClearData();
            setLoading(false);
            setTimeout(() => {
              MySwal.close();
              navigate(`/sales-receipt/${salesData.ID}`);
            }, 200);
          }

          // if success then sync payment with QB
          if (QBpermission) {
            Swal.fire({
              title: "Syncing Payment with Quickbook...",
              text: "Please wait while we process your request.",
              showConfirmButton: false,
              allowOutsideClick: false,
              willOpen: () => {
                Swal.showLoading();
              },
            });

            axios
              .post(
                `${config.salesconfigBaseUrl}/sales/salesreceivingsQuickbookupsert`,
                {
                  ...receivePaymentData,
                  previousid: txnId,
                  RollBackId: RollBackId,
                  previosdata: previosdata,
                },
                {
                  headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    Authorization: token,
                  },
                }
              )
              .then((res) => {
                if (res.data.ResponseCode === "SUCCESS") {
                  // MySwal.close();
                  setLoading(false);
                  handleClearData();
                  setTimeout(() => {
                    MySwal.close();
                    navigate(`/sales-receipt/${salesData.ID}`);
                  }, 200);
                  // Swal.fire({
                  //   icon: "success",
                  //   title: "Success!",
                  //   text: `Data inserted successfully. Response ID: ${salesData.ID}`,
                  //   confirmButtonText: "view Receipt",
                  // }).then((result) => {
                  //   if (result.isConfirmed) {
                  //     navigate(`/sales-receipt/${salesData.ID}`);
                  //     // setSalePOSId(res.data.ResponseID);
                  //     // setReciptModel(true);
                  //   }
                  // });
                  toastSuccess(SUCCESS_MESSAGE);
                } else {
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "An error occurred while processing your payment sync.",
                    confirmButtonText: "view Receipt",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      navigate(`/sales-receipt/${salesData.ID}`);
                    }
                  });
                  handleClearData();
                  toastError(ERROR_MESSAGE);
                }
              });
            toastSuccess(SUCCESS_MESSAGE);
          }
        }
      });
    setLoading(false);
  };

  const handelItemIsCheck = (item) => {
    const findIndex = mainFilterData.findIndex(
      (el) => el.id == item.id && el.variationId == item.variationId
    );
    const updatedArray = [...mainFilterData];
    updatedArray[findIndex].isInCart = !updatedArray[findIndex].isInCart;
    setMainFilterData(updatedArray);
  };

  const handelSelectedItemAddTocart = () => {
    const newCartData = [...cartData];
    let updatedMainFilterData = [...mainFilterData];

    updatedMainFilterData = updatedMainFilterData?.map((item) => {
      if (item.isInCart) {
        const findIndex = newCartData.findIndex(
          (cat) => cat.id === item.id && cat.variationId === item.variationId
        );

        if (findIndex !== -1) {
          const updatedObject = {
            ...newCartData[findIndex],
            cartQty: Number(item?.cartQty),
            cartPrice: Number(item?.cartPrice),
            cartTotal: Number(item?.cartQty * item?.cartPrice).toFixed(2),
            cartSubTotal: Number(item?.cartQty * item?.cartPrice).toFixed(2),
          };

          newCartData.splice(findIndex, 1);
          newCartData.unshift(updatedObject);
        } else {
          newCartData.unshift({
            ...item,
            rowIndex: newCartData.length + 1,
            cartTotal: Number(item?.cartQty * item?.cartPrice).toFixed(2),
            cartSubTotal: Number(item?.cartQty * item?.cartPrice).toFixed(2),
          });
        }

        return { ...item, isInCart: false };
      }
      return item;
    });

    setCartData(newCartData);
    setMainFilterData(updatedMainFilterData);
    setItemSelectAllButton(false);
    setAdvanceItemFilterInput({
      ItemQty: 0,
      ItemPrice: 0,
    });
  };

  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "111%",
      height: "34px",
      // marginTop: "10px",
      // marginLeft: "20px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "111%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
      },
    }),
  };

  const handelFavourite = (data) => {
    let updatedMainFilterData = [...mainFilterData];
    updatedMainFilterData = updatedMainFilterData?.map((item) => {
      if (item?.id === data?.id && item?.variationId === data?.variationId) {
        return { ...item, isFavourite: !item?.isFavourite };
      } else {
        return item;
      }
    });
    setMainFilterData(updatedMainFilterData);

    // setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/favouriteUpsert`,
        {
          itemId: data?.id,
          variationId: data?.variationId ? data?.variationId : 0,
          customerId: customerId,
          loginId: LoginId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          // toastSuccess("Updated Favourite List");
          getCustomerfavouriteitemslist(customerId);
        } else {
          toastError(res.data.ResponseMessage);
        }
        // setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // setLoading(false);
      });
  };

  const findAndSetFavourite = (item) => {
    return favouriteList?.some(
      (el) => el.id === item.id && el.variationId === item.variationId
    )
      ? true
      : false;
  };

  // const handleSelectAdvanceFilterSelectAll = (select) => {
  //   let updatedMainFilterData = [...mainFilterData];
  //   updatedMainFilterData = updatedMainFilterData
  //     ?.filter(
  //       (el) =>
  //         el?.type === "Product" &&
  //         el.itemsCount === 0 &&
  //         (filterAllStockData ? Number(el.CurrantQTY) > 0 : true)
  //     )
  //     ?.map((item) => {
  //       return { ...item, isInCart: select };
  //     });
  //   setMainFilterData(updatedMainFilterData);
  // };

  const handleSelectAdvanceFilterSelectAll = (select) => {
    const updatedMainFilterData = mainFilterData.map((item) => {
      // Check if the item meets the condition
      if (
        item?.type === "Product" &&
        item.itemsCount === 0 &&
        (filterAllStockData ? Number(item.CurrantQTY) > 0 : true)
      ) {
        return { ...item, isInCart: select }; // Update isInCart only for matching items
      }
      return item; // Keep other items unchanged
    });

    setMainFilterData(updatedMainFilterData);
  };

  const handleReturnFavourateData = (array) => {
    const updatedMainFilter = array.map((mainFilterItem) => {
      const matchingItem = favouriteList.find(
        (finalItem) =>
          finalItem.id === mainFilterItem.id &&
          finalItem.variationId === mainFilterItem.variationId &&
          mainFilterItem.type === "Product"
      );
      if (matchingItem) {
        return { ...mainFilterItem, isFavourite: true };
      }
      return { ...mainFilterItem, isFavourite: false };
    });
    return updatedMainFilter;
  };

  const handelEncryptObject = () => {
    const userData = {
      customerId: customerDetail?.Id,
      RoleId: customerDetail?.RoleTierID,
      loginId: LoginId,
      c: "sonarpos",
      websiteUrl: window.location.origin,
      backendUrl: config.ecommBackendBaseUrl,
      backtoOriginalUrl: window.location.href,
      backToCall: 0,
      from: "pos",
    };
    const finalData = btoa(JSON.stringify(userData));
    const resultData = JSON.parse(atob(finalData));
    console.log(finalData, resultData, "finadataencrypt");
    return finalData;
  };

  const dropDownData = (
    <>
      <div className="dropdown col-auto ml-3">
        <button
          style={{ marginTop: "0px" }}
          className="border-radius-pos-toggle btn btn-primary toggle-specified-height"
          type="button"
          onClick={backmenuhome}
        >
          <>
            <i className="fa fa-home"></i> POS
          </>
        </button>

        {/* Middle div triggering the dropdown */}
        <div
          id="dropdownMenuButton"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          className="border-radius-pos-toggle-arrow btn btn-secondary dropdown-toggle toggle-specified-height"
          onClick={(e) => e.preventDefault()} // Prevent default button behavior
        ></div>

        {/* Dropdown menu */}
        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <li>
            <button
              type="button"
              className={`dropdown-item ${
                showMenu === "Category" ? "active" : ""
              }`}
              onClick={() => setShowMenu("Category")}
            >
              Category
            </button>
          </li>
          <li>
            <button
              type="button"
              className={`dropdown-item ${
                showMenu === "Brands" ? "active" : ""
              }`}
              onClick={() => setShowMenu("Brands")}
            >
              Brands
            </button>
          </li>
          <li>
            <button
              type="button"
              className={`dropdown-item ${showMenu === "Tags" ? "active" : ""}`}
              onClick={() => setShowMenu("Tags")}
            >
              Tags
            </button>
          </li>
          <li>
            <button
              type="button"
              className={`dropdown-item ${
                showMenu === "Favourite" ? "active" : ""
              }`}
              onClick={() => {
                if (customerId > 0) {
                  // getCustomerfavouriteitemslist(customerId);
                  setShowMenu("Favourite");
                } else {
                  customerWarningMessage();
                }
              }}
            >
              Favourite
            </button>
          </li>
        </ul>
      </div>
    </>
  );

  useEffect(() => {
    if (iParam) {
      try {
        const decryptedData = JSON.parse(atob(iParam)) || [];

        if (decryptedData?.length > 0) {
          console.log(decryptedData, "decryptedData");
          const callbackArray = [...decryptedData];
          setCartData((prev) => {
            let updatedCart = [...prev];

            callbackArray.forEach((item, index) => {
              const existingItemIndex = updatedCart.findIndex(
                (cartItem) =>
                  cartItem.id === item.ID &&
                  cartItem.variationId === item.variationId
              );

              if (existingItemIndex > -1) {
                // If the item already exists, update its quantity and price
                const updatedObject = {
                  ...updatedCart[existingItemIndex],
                  cartQty:
                    Number(item.inputQuantity) +
                    Number(updatedCart[existingItemIndex]?.cartQty),
                  cartPrice: item.RecallPrice,
                };

                const filterArray = updatedCart?.filter(
                  (_, i) => i != existingItemIndex
                );
                updatedCart = [updatedObject, ...filterArray];
              } else {
                updatedCart.unshift({
                  id: item.ID,
                  src: item.Image || "",
                  alt: item.Name,
                  title: item.Name,
                  itemsCount: 0,
                  ParentId: 0,
                  type: "Product",
                  IsShowEcommerceMenu: 1,
                  isInCart: false,
                  cartQty: item.inputQuantity,
                  cartPrice: item.RecallPrice,
                  Tier1Price: item.Tier1Price,
                  Tier2Price: item.Tier2Price,
                  Tier3Price: item.Tier3Price,
                  Tier4Price: item.Tier4Price,
                  Tier5Price: item.Tier5Price,
                  RecallPrice: item.RecallPrice,
                  UnitPrice: item.Unitprice,
                  variationId: item.variationId,
                  cartDiscountType: "percent",
                  cartDiscount: 0,
                  cartTaxType: "Percentage",
                  cartTax: 0,
                  cartTotal:
                    Number(item?.inputQuantity) * Number(item?.RecallPrice),
                  cartSubTotal:
                    Number(item?.inputQuantity) * Number(item?.RecallPrice),
                  cartTotalDiscount: 0,
                  cartTotalTax: 0,
                  CategoryID: item.CategoryId,
                  CategoryName: item.CategoryName || "",
                  CostPrice: item.Costprice,
                  QuickBookId: item.QuickBookId,
                  CurrantQTY: item.CurrantQTY || 0,
                  rowIndex: cartData?.length + index + 1,
                  isFavourite: false,
                  ItemNumber: item.Itemnumber,
                });
              }
            });

            return updatedCart;
          });
        }
        navigate();
      } catch (error) {
        console.error("Error decoding iParam", error);
      }
    }
  }, [iParam]);

  const HandelCustomerSupplierDetailModel = () => {
    setShowCustomerModal(true);
  };

  const handleVoid = (saletypeid, id, qbid) => {
    let rowdata = [];

    const obj = {
      quickbookid: qbid,
      type: saletypeid,
    };

    rowdata.push(obj);

    const deleteRequestParam = {
      quickbookarray: rowdata,
      saleids: id,
      locationid: Location,
      loginuserid: LoginId,
      isSaleVoid: 1,
      salequickbookid: qbid,
    };

    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );

    setDeleteModalOpen(true);
  };

  const handelDeliveryMethod = (value) => {
    if (customerId === 0) {
      customerWarningMessage();
      return;
    }
    setDeliveryMethodId(value);
  };

  // Filter data
  const filteredData = mainFilterData?.filter((el) =>
    el?.type === "Product"
      ? filterAllStockData
        ? Number(el.CurrantQTY) > 0
        : true
      : true
  );

  useEffect(() => {
    const handleKeyDown = (e) => {
      console.log(e.key, selectedIndex, "256348");
      if (!moduleopen) {
        if (!filteredData || filteredData.length === 0) return;

        if (e.key === "ArrowRight") {
          setSelectedIndex((prev) => (prev + 1) % filteredData.length);
        } else if (e.key === "ArrowLeft") {
          setSelectedIndex(
            (prev) => (prev - 1 + filteredData.length) % filteredData.length
          );
        } else if (e.key === "ArrowDown" && selectedIndex === -1) {
          // if the cursor is on the global search
          setSelectedIndex(0);
        } else if (e.key === "ArrowDown") {
          setSelectedIndex((prev) => (prev + 3) % filteredData.length);
        } else if (e.key === "ArrowUp" && selectedIndex <= 2) {
          // if the cursor is on the top row
          setSelectedIndex(-1);
          setTimeout(() => {
            handleGlobalSearchQtyInputRef();
          }, 200);
        } else if (e.key === "ArrowUp") {
          setSelectedIndex(
            (prev) => (prev - 3 + filteredData.length) % filteredData.length
          );
        } else if (e.key == "Enter") {
          // qtyselectRef.current.value = "input.Cart_Input23";
          setselectqty(!selectqty);
          const cat = filteredData[selectedIndex];
          console.log(cat, "kashyaar", e.key);
          if (cat?.type === "Product" && Number(cat?.itemsCount) === 0) {
            customerId === 0 ? customerWarningMessage() : handelMainFilter(cat);
          } else if (cat?.type !== "Product" || Number(cat?.itemsCount) > 0) {
            customerId > 0 ? handelMainFilter(cat) : customerWarningMessage();
            setSelectedIndex(0);
          }
        }
      }
      setIsPriceChange(0);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    filteredData,
    selectedIndex,
    customerId,
    handelMainFilter,
    customerWarningMessage,
    setSelectedIndex,
  ]); // Added missing dependency

  console.log(qtyselectRef, "759846");

  useEffect(() => {
    if (isPriceChange == 0) {
      setTimeout(() => {
        if (qtyselectRef?.current) {
          qtyselectRef.current.focus();
          qtyselectRef.current.select();
        }
      }, 0);
    }
  }, [selectedIndex, data]);

  function validateNumber(input) {
    const match = input.match(/(\d+(\.\d*)?|\.\d+)/); // Improved regex
    return match ? match[0] : "";
  }

  const handelCartDiscountValue = (value, index, field) => {
    let updateData = [...cartData];
    updateData[index][field] = value;
    setCartData(updateData);
  };

  const handelCartDiscountCalculate = (
    value,
    index,
    field,
    cartDiscountType
  ) => {
    let updateData = [...cartData];
    updateData[index][field] = value;
    updateData[index].cartDiscountType = cartDiscountType;

    // Calculate discount amount based on cartDiscountType
    let discountAmount = 0;
    if (cartDiscountType === "percent") {
      discountAmount = (updateData[index].cartSubTotal * value) / 100;
    } else if (cartDiscountType === "amount") {
      discountAmount = Number(value);
    } else {
      discountAmount = Number(value); // fallback
    }

    updateData[index].cartTotalDiscount = discountAmount;
    updateData[index].cartTotal = (
      updateData[index].cartSubTotal - discountAmount
    ).toFixed(2);
    setCartData(updateData);
  };

  const handleFetchCustAOCAVG = (CustomerID) => {
    if (CustomerID > 0) {
      axios
        .get(
          `${config.salesconfigBaseUrl}/sales/customerAvgAocByCustomer?CustomerID=${CustomerID}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const responseItem = res.data.ResponseData?.[0]?.TotalAvg;
          console.log(responseItem, "selmooonnnnnnn84787878");
          setSelectedCustomerAvgAOS(responseItem);
        })
        .catch((err) => {
          console.error("Error fetching Avg AOC:", err);
        });
    }
  };

  const checkAOS = () => {
    setShowCustomerAOS(true);
    handleFetchCustAOCAVG(customerId);
  };

  // useEffect(() => {
  //   handleFetchCustAOCAVG(customerId);
  // }, [customerId > 0]);

  return (
    <div>
      <Loader loading={loading} />
      {saleId > 0 || cloneSaleId > 0 ? <Loader loading={saleByIdLoader} /> : ""}
      <div className="page-wrapper pos-pg-wrapper ms-0 pt-0 slim-scrollbar">
        <div className="content pos-design p-0">
          <div className="nav-style">
            <nav className="d-flex flex-wrap justify-content-between">
              <div className="d-flex gap-2">
                <div className="me-2 ml-3">
                  <Link
                    to={"/"}
                    className="nav-link-height btn btn-primary btn-sm pull-right"
                    style={{
                      width: "34px",
                    }}
                    // target="_blank"
                  >
                    <i className="fa fa-home"></i>
                  </Link>
                </div>
                <div
                  className="nav-link-height btn btn-secondary"
                  ref={timeRef}
                ></div>
              </div>
              {/* <div>abc</div>
              <div>abc</div>
              <div>abc</div>
              <div>abc</div> */}
              <div>
                <ul
                  className={searchBar ? "nav user-menu  " : "nav user-menu  "}
                >
                  {changeImagename == true ? (
                    <div
                      style={{
                        display: "flex",
                        padding: "5px",
                        marginTop: "5px",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        style={{ height: "26x", width: "26px" }}
                        src="https://sonarposdev1.s3.amazonaws.com/sync+loader.svg"
                      />{" "}
                      <span style={{ marginTop: "14px", marginLeft: "4px" }}>
                        {" "}
                        Quickbook
                      </span>
                    </div>
                  ) : (
                    <div className="me-2">
                      <div
                        style={{
                          padding: "5px",
                          marginTop: "5px",
                          cursor: "pointer",
                        }}
                        onClick={() => navigate("/quickbooksync")}
                      >
                        {Label === true ? (
                          <div className="d-flex" title="QuickBook Connected">
                            <i
                              className="fa fa-circle mr-2"
                              style={{ fontSize: "16px", color: "green" }}
                            ></i>{" "}
                            <span className="pos-titile-ellipsis">
                              QB {companyname}
                            </span>
                          </div>
                        ) : (
                          <div
                            className="d-flex"
                            title="QuickBook Disconnected"
                          >
                            <i
                              className="fa fa-circle mr-2"
                              style={{ fontSize: "16px", color: "red" }}
                            ></i>{" "}
                            <span className="pos-titile-ellipsis">
                              QB {companyname}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  <div
                    className="nav user-menu "
                    style={{ position: "relative", paddingRight: "0px" }}
                  >
                    <input
                      className="Global_Search form-control"
                      type="text"
                      placeholder="Search Here...."
                      value={inputValue}
                      onChange={handleInputChangeGlobalSearch}
                    />

                    {/* {suggestions.length === 0 && inputValue !== "" && (
                      <div
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "10px",
                        }}
                      >
                        <img
                          src={loadingimage}
                          alt="Loading..."
                          style={{ width: "20px", height: "20px" }}
                        />
                      </div>
                    )}
                    {suggestions.length > 0 && (
                      <div
                        className="dropdown"
                        ref={searchResultRef}
                        style={{
                          position: "absolute",
                          top: "-60px",
                          left: "0",
                          width: "100%",
                          zIndex: "1000",
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        }}
                      >
                        <ul
                          className="dropdown-menu show"
                          style={{
                            maxHeight: "400px",
                            overflowY: "auto",
                            padding: "2px 10px",
                            listStyle: "none",
                            marginTop: "100px",
                            width: "auto",
                          }}
                        >
                          {suggestions.map((item, index) => (
                            <li
                              style={{ padding: "0px 10px" }}
                              key={item.ID}
                              className={
                                cursor === index
                                  ? "dropdown-item active"
                                  : "dropdown-item"
                              }
                            >
                              <a
                                href={`${item?.Result_Route}${
                                  item?.TableName == "ReportDropdownList"
                                    ? ""
                                    : `/${item?.ID}`
                                }`}
                                className={
                                  cursor === index
                                    ? "dropdown-item active"
                                    : "dropdown-item"
                                }
                                target="_blank"
                                data-name={item.MatchedValue.toUpperCase()}
                              >
                                <div className="customer-info ml-2">
                                  <h6 className="name">
                                    <ul>
                                      <li
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontSize: "14px",
                                            fontWeight: "500",
                                          }}
                                        >
                                          {item.TableName}
                                        </span>
                                        <span
                                          style={{
                                            marginLeft: "36px",
                                            fontSize: "12px",
                                            fontWeight: "400",
                                          }}
                                        >
                                          {item.MatchedColumnName}
                                          {" | "}
                                          {item.ProcessedMatchedValue}{" "}
                                        </span>
                                      </li>
                                    </ul>
                                  </h6>
                                </div>
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )} */}

                    {suggestions.length === 0 && inputValue !== "" && (
                      <div
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "10px",
                        }}
                      >
                        <img
                          src={loadingimage}
                          alt="Loading..."
                          style={{ width: "20px", height: "20px" }}
                        />
                      </div>
                    )}
                    {suggestions.length > 0 && (
                      <div
                        className="dropdown"
                        ref={searchResultRef}
                        style={{
                          position: "absolute",
                          top: "-60px",
                          left: "0",
                          width: "100%",
                          zIndex: "1000",
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        }}
                      >
                        <ul
                          className="dropdown-menu show"
                          style={{
                            maxHeight: "400px",
                            overflowY: "auto",
                            padding: "2px 10px",
                            listStyle: "none",
                            margin: "0px 0px 0px -650px",
                            width: "auto",
                            // minWidth:"820px"
                          }}
                        >
                          {/* {suggestions.map((item, index) => (
                                        <li
                                          style={{ padding: "0px 10px" }}
                                          key={item.ID}
                                          className={
                                            cursor === index
                                              ? "dropdown-item active"
                                              : "dropdown-item"
                                          }
                                        >
                                          <a
                                            href={`${item?.Result_Route}${
                                              item?.TableName == "ReportDropdownList"
                                                ? ""
                                                : `/${item?.ID}`
                                            }`}
                                            className={
                                              cursor === index
                                                ? "dropdown-item active"
                                                : "dropdown-item"
                                            }
                                            target="_blank"
                                            data-name={item.MatchedValue.toUpperCase()}
                                          >
                                            <div className="customer-info ml-2">
                                              <h6 className="name">
                                                <ul>
                                                  <li
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "space-between",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        fontSize: "14px",
                                                        fontWeight: "500",
                                                      }}
                                                    >
                                                      {item.TableName}
                                                    </span>
                                                    <span
                                                      style={{
                                                        marginLeft: "36px",
                                                        fontSize: "12px",
                                                        fontWeight: "400",
                                                      }}
                                                    >
                                                      {item.MatchedColumnName}
                                                      {" | "}
                                                      {item.ProcessedMatchedValue}{" "}
                                                    </span>
                                                  </li>
                                                </ul>
                                              </h6>
                                            </div>
                                          </a>
                                        </li>
                                      ))} */}
                          {suggestions.map((item, index) => (
                            <li
                              key={item.ID}
                              className={
                                cursor === index
                                  ? "dropdown-item"
                                  : "dropdown-item"
                              }
                              style={{
                                // padding: "14px 20px",
                                fontSize: "13px",
                                fontWeight: 400,
                                color: "#000",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                borderBottom:
                                  "1px solid var(--input-border-color-p-50)",
                              }}
                            >
                              {
                                <a
                                  href={`${item?.Result_Route}${
                                    item?.TableName === "ReportDropdownList"
                                      ? ""
                                      : `/${item?.ID}`
                                  }`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#000",
                                    textDecoration: "none",
                                    display: "flex",
                                    gap: "6px",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: "10px",
                                      height: "10px",
                                      borderRadius: "50%",
                                      backgroundColor:
                                        item.QuickbookID > 0 ? "green" : "red",
                                      marginRight: "8px",
                                    }}
                                  ></span>
                                  {item.TableName && (
                                    <>
                                      <strong
                                        style={{
                                          fontSize: "14px",
                                          color: "var(--primary-main-color)",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {item.TableName?.toUpperCase()}
                                      </strong>
                                      <span> | </span>
                                    </>
                                  )}

                                  {item.MatchedColumnName && (
                                    <>
                                      <span>
                                        {item?.Result_Route ==
                                          "/manage-customers" ||
                                        item?.Result_Route ==
                                          "/manage-suppliers" ||
                                        item?.Result_Route == "/manage-employee"
                                          ? // || item?.Result_Route == "/sales-receipt"
                                            ""
                                          : item?.MatchedColumnName}{" "}
                                        <strong> {item.MatchedValue}</strong>
                                      </span>
                                      <span> | </span>
                                    </>
                                  )}

                                  {item.CustomerName && (
                                    <>
                                      <span>{item.CustomerName}</span>
                                      <span> | </span>
                                    </>
                                  )}
                                  {item.CreatedDate && (
                                    <>
                                      <span>
                                        {moment(item.CreatedDate).format(
                                          "MM/DD/YYYY h:mm A"
                                        )}
                                      </span>
                                      {/* <span>{item.CreatedDate}</span> */}
                                      <span> | </span>
                                    </>
                                  )}
                                  {item.SaleTotal && (
                                    <>
                                      <span>
                                        <strong>
                                          {CurrencySymbols(
                                            Number(item.SaleTotal),
                                            { CurrencySymbol },
                                            FractionDigits
                                          )}
                                        </strong>
                                        {/* <strong>${parseFloat(item.SaleTotal || 0).toFixed(2)}</strong> */}
                                      </span>
                                      <span> | </span>
                                    </>
                                  )}
                                  {item.ID && (
                                    <>
                                      <span>
                                        ID : <strong> {item.ID}</strong>
                                      </span>
                                      <span> | </span>
                                    </>
                                  )}

                                  {item.QuickbookID && (
                                    <>
                                      <span>
                                        QB ID :{" "}
                                        <strong> {item.QuickbookID}</strong>
                                      </span>
                                      {/* <span> | </span> */}
                                    </>
                                  )}
                                </a>
                              }
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>

                  {/* Search */}
                  <div
                    style={{ padding: "10px 6px -1px 5px" }}
                    className="me-2"
                  >
                    <Link
                      to={config.ecommWebsiteUrl}
                      className="nav-link-height btn btn-primary btn-sm pull-right"
                      style={{
                        width: "max-content",
                        marginLeft: "15px",
                        // marginTop: "10px",
                      }}
                      target="_blank"
                    >
                      Visit Site
                    </Link>
                  </div>
                  <li className="nav mr-3">
                    <Select
                      value={locationDropdownOption?.find(
                        (option) => option?.value == selectedlocation
                      )}
                      options={locationDropdownOption}
                      placeholder="Warehouse"
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      styles={selectStyles}
                      onChange={(event) => handleWarehouse(event)}
                    />
                  </li>

                  {/* /Notifications */}
                  <li
                    style={{
                      height: "0px",
                      display: "flex",
                      alignItems: "center",
                    }}
                    className="mt-4 nav-item dropdown has-arrow main-drop"
                  >
                    <Link
                      to="#"
                      className="dropdown-toggle nav-link userset"
                      data-bs-toggle="dropdown"
                    >
                      <span className="user-img">
                        <i class="ml-4 fa fa-user-circle-o"></i>
                      </span>
                    </Link>
                    <div className="dropdown-menu menu-drop-user">
                      <div className="profilename">
                        <div className="profileset">
                          <span className="user-img mt-2">
                            <img
                              src="data:image/png;base64,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"
                              onError={(e) => {
                                e.target.onError = null;
                                e.target.src = Noimage;
                              }}
                              alt=""
                            />
                            {/* <span className="status online" /> */}
                          </span>
                          <div className="profilesets">
                            <h6>{Name}</h6>
                            <p className="email">{EmailId}</p>
                          </div>
                        </div>
                        <hr className="m-0" />
                        {checkUserPermission("/edit-profile") && (
                          <Link className="dropdown-item" to={`/edit-profile`}>
                            <i className="me-2" data-feather="user" /> My
                            Profile
                          </Link>
                        )}
                        {checkUserPermission("settings") && (
                          <Link className="dropdown-item" to="/storeconfig">
                            <i className="me-2" data-feather="settings" />
                            Settings
                          </Link>
                        )}
                        <hr className="m-0" />
                        <Link
                          className="dropdown-item logout pb-0"
                          onClick={signOut}
                        >
                          <img src={Logout} className="me-2" alt="img" />
                          Logout
                        </Link>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div className="row align-items-start pos-wrapper">
            <div className="col-12 col-md-8 col-xl-8 col-md-8">
              {/* <span className="dropdown-category-label">{showMenu}</span> */}
              <div className="d-flex flex-wrap align-items-center gap-2">
                <div className="display-none-phone-size-desktop col-12 ">
                  <div className="customer-dropdown-phone customer-info block-section col-auto d-flex align-items-center col-auto">
                    {customerId > 0 ? (
                      <div className="head d-flex align-items-center justify-content-between w-100 col-12">
                        <div className="d-flex gap-3">
                          <ImageWithBasePath
                            src={customerDetail.Image}
                            alt={customerDetail.label}
                            height={50}
                            width={50}
                            id={customerDetail.Id}
                            mode="circle"
                          />
                          <div
                            className="gap-2 align-items-center mt-2"
                            //  style={{display:"flex" , gap : "28px" , alignItems : "center"}}
                          >
                            <span
                              className="cursor-pointer"
                              // data-bs-target="#CustomerSupplierDetailModel"
                              // data-bs-toggle="modal"
                              onClick={() =>
                                HandelCustomerSupplierDetailModel()
                              }
                            >{`${customerDetail.FirstName} ${customerDetail.LastName} (${customerDetail.CompanyName})`}</span>
                            <p>
                              Balance:{" "}
                              {showCustomerBalance ? (
                                CurrencySymbols(
                                  Number(customerBalance),
                                  { CurrencySymbol },
                                  FractionDigits
                                )
                              ) : (
                                <>
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => checkBalance()}
                                  >
                                    Click Here
                                  </span>
                                </>
                              )}
                              {/* {changePriceFormat(customerDetail.Balance)} */}
                            </p>
                            {/* <Link
                              to="#"
                              className="customer-link"
                              data-bs-toggle={customerId > 0 ? "modal" : null}
                              data-bs-target={customerId > 0 ? "#create" : null}
                              onClick={() => {
                                if (customerId <= 0) {
                                  customerWarningMessage();
                                }
                              }}
                            >
                              {`${customerDetail.Address1}, ${customerDetail.City}, ${customerDetail.StateProvince}, ${customerDetail.Zip}, ${customerDetail.Country}`}
                            </Link> */}
                          </div>
                        </div>
                        <div className="d-flex">
                          <Link
                            className="btn-icon edit-icon me-2"
                            to={`/manage-customers/${customerId}`}
                          >
                            <Edit className="feather-16 text-danger me-1" />
                          </Link>
                          <span> {customerId} </span>
                          <Link
                            className="confirm-text"
                            to="#"
                            onClick={() => {
                              console.log(customerId, "Delete Customer");

                              setCustomerId(0);
                              setCustomerDetail({});
                              setShippingAddressId(0);
                              // setCartData([]);
                              setExtraPaymentAmount(0);
                            }}
                          >
                            <Trash2 className="feather-16 text-danger me-1" />
                          </Link>
                        </div>
                      </div>
                    ) : (
                      <div className="input-block d-flex align-items-center col-12 mb-0">
                        <div className="input-group flex-nowrap">
                          <span
                            className="input-group-text border-size-input"
                            id="addon-wrapping"
                          >
                            <Link to="/manage-customers">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-person-plus"
                                viewBox="0 0 16 16"
                              >
                                <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                                <path
                                  fillRule="evenodd"
                                  d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                                />
                              </svg>
                            </Link>
                          </span>
                          <Select
                            className="w-100"
                            options={custOptions}
                            classNamePrefix="react-select"
                            placeholder="Select Customer"
                            onChange={(e) => {
                              handelCustomerSelect(e);
                            }}
                            value={custOptions?.find(
                              (el) => el.value === customerId
                            )}
                            hideSelectedOptions={true}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE_POS}
                            filterOption={(candidate, input) => {
                              const searchText = input.toLowerCase();
                              const {
                                label,
                                address,
                                PhoneNumber,
                                address2,
                                City,
                                StateProvince,
                                Country,
                                FirstName,
                                LastName,
                              } = candidate.data; // Access additional fields
                              return (
                                label.toLowerCase().includes(searchText) || // Search by name
                                address?.toLowerCase().includes(searchText) || // Search by address
                                PhoneNumber?.toLowerCase().includes(
                                  searchText
                                ) || // Search by email
                                address2?.toLowerCase().includes(searchText) || // Search by email
                                City?.toLowerCase().includes(searchText) || // Search by email
                                StateProvince?.toLowerCase().includes(
                                  searchText
                                ) || // Search by email
                                Country?.toLowerCase().includes(searchText) || // Search by email
                                FirstName?.toLowerCase().includes(searchText) || // Search by email
                                LastName?.toLowerCase().includes(searchText) // Search by email
                              );
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="row flex-wrap">
                  {!SaleQuickPermision && AllowQBSync && (
                    <QuickbookSyncMessageComponent type="Sales" />
                  )}
                  {paramObject?.saleId > 0 && saleIsVoid == 1 && (
                    <div className="row align-center">
                      <div
                        style={{
                          border: "1px solid",
                          padding: "5px 10px",
                          borderRadius: "5px",
                          width: "fit-content",
                          margin: "15px",
                        }}
                      >
                        You marked this sale as void. Making changes that affect
                        the sale total will reopen this sale.
                      </div>
                    </div>
                  )}
                  <div className="d-flex flex-wrap col-auto gap-2">
                    <div className="display-none-phone-size mt-2">
                      {dropDownData}
                    </div>
                    <div
                      className="position-relative pl-3 col-auto"
                      // className="position-relative pl-3 col-auto"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <div className="input-group flex-nowrap">
                        <span className="input-group-text" id="addon-wrapping">
                          <Link
                            to="/manage-items"
                            //  target="_blank"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-pencil-square"
                              viewBox="0 0 16 16"
                            >
                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                              <path
                                fillRule="evenodd"
                                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                              />
                            </svg>
                          </Link>
                        </span>
                        <input
                          ref={globalSearchItemInputRef}
                          className={`Global_Search_Input_Width Global_Search_Input pos-form-control ${
                            selectedIndex == -1 ? "pos-border-highlight" : ""
                          }`}
                          onChange={(e) =>
                            handelGlobalSearchApi(e.target.value)
                          }
                          value={globalFilterInput}
                          placeholder="Global Search"
                          onClick={() => {
                            setSelectedIndex(-1);
                            customerId === 0 && customerWarningMessage();
                          }}
                        />
                        <div className="d-flex">
                          {/* <div 
                          // data-bs-toggle={customerId > 0 ? "modal" : null}
                          // data-bs-target={
                          //   customerId > 0 ? "#ScannerModel" : null
                          // }
                          >*/}
                          <div
                            className="ml-3 pos-barcode cursor-pointer"
                            onClick={() => {
                              if (customerId > 0) {
                                // setStartScannerCamera(!startScannerCamera);
                                window.open(
                                  `${
                                    config.scannerWebsiteUrl
                                  }?i=${handelEncryptObject()}`,
                                  "_self"
                                );
                              } else {
                                customerWarningMessage();
                              }
                            }}
                          >
                            <img
                              style={{ paddingBottom: "10px" }}
                              width={"25px"}
                              src={scannericon}
                            />
                          </div>
                          {/* </div> */}
                          {globalFilterInput?.length > 0 && (
                            <div
                              type="button"
                              className="pos-cross row Global_Search_Input_Clear_BTN 
                  "
                              // btn btn-primary btn-sm
                              onClick={() => handelclearGlobalFilter()}
                            >
                              <i className="fa fa-times mr-5 mt-3"></i>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="dropdown">
                        <button
                          style={{ height: "37.7px", marginTop: "0px" }}
                          type="button"
                          className="btn btn-sm btn-primary dropdown-toggle border-size mr-5"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="fas fa-shopping-cart me-1"></i>
                          {selectedSaleOption}
                        </button>
                        <ul className="dropdown-menu">
                          {saleOptions.map((option) => (
                            <li key={option.ID}>
                              <button
                                className="dropdown-item"
                                onClick={() =>
                                  handleSaleTypeChange(
                                    option.ID,
                                    option.SalesType
                                  )
                                }
                              >
                                {option.SalesType}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <div className="d-flex align-items-center col-auto">
                      {/* First Div: Buttons aligned to the left */}
                      <div className="d-flex">
                        <div
                          className="item col-auto custome-margin-left"
                          title="Item Grid"
                        >
                          <Link
                            className="btn btn-secondary p-3 w-100"
                            onClick={() => {
                              if (customerId == 0) {
                                customerWarningMessage();
                              } else {
                                setRunApi(true);
                              }
                            }}
                          >
                            <i className="fa fa-list-ul me-1 fs-4"></i>
                          </Link>
                        </div>
                        <div
                          className="item col-auto ms-3"
                          title="Advance Filter"
                        >
                          <Link
                            className="btn btn-secondary w-100"
                            onClick={() => {
                              setShowAdvanceFilter(!showAdvanceFilter);
                            }}
                          >
                            {showAdvanceFilter ? (
                              <i className="fa fa-arrow-up me-1"></i>
                            ) : (
                              <i className="fa fa-arrow-down me-1"></i>
                            )}
                          </Link>
                        </div>
                        <div
                          className="item col-auto ms-3"
                          title={
                            filterAllStockData ? "All Stock" : "In Stock Only"
                          }
                        >
                          <Link
                            to="#"
                            className="btn btn-secondary pr-2 pl-2 pt-2 w-100"
                            onClick={() => handleFilterChange()}
                          >
                            {filterAllStockData ? (
                              <img width={"25px"} src={outofstock} />
                            ) : (
                              <img width={"25px"} src={instock} />
                            )}
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center col-auto ">
                      <div className="d-flex justify-content-between ms-auto">
                        <button
                          style={{ width: "max-content" }}
                          className={`ml-3 btn btn-primary btn-sm ${
                            skeletonLoading ? "ml-3 btn btn-primary btn-sm" : ""
                          }`}
                          // className="ml-3 btn btn-primary btn-sm"
                          onClick={() => !skeletonLoading && handelBackToMenu()}
                          disabled={skeletonLoading}
                        >
                          <i className="fa fa-backward"></i> Back
                        </button>
                      </div>
                    </div>
                    <div className="d-flex align-items-center col-auto ">
                      <div className="display-none-phone-size-desktop mt-2">
                        {dropDownData}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="btn-row">
                <div className="d-sm-flex align-items-center"></div>

                {showAdvanceFilter && (
                  <>
                    <div className="d-sm-flex align-items-center pl-3 mt-3">
                      <div className=" d-flex gap-2 col-md-10">
                        {/* Default Selling Price */}
                        <div className="col-xxl-2 col-lg-3 col-md-4 col-sm-6">
                          Price Rule
                          <Select
                            options={defaultSellingPriceType}
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            onChange={(e) =>
                              handelItemFilterChange(e.value, "priceRule")
                            }
                            value={defaultSellingPriceType?.find(
                              (el) => el.value === itemPriceRuleSelect
                            )}
                            className="custom-select-search"
                          />
                        </div>

                        {/* Role Tier (Conditional Rendering) */}
                        {itemPriceRuleSelect == 2 && (
                          <div className="col-xxl-2 col-lg-3 col-md-4 col-sm-6">
                            Role Tier
                            <Select
                              options={cartTierPriceList}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              onChange={(e) =>
                                handelItemFilterChange(e.id, "roleTier")
                              }
                              value={cartTierPriceList?.find(
                                (el) => el.ID == itemTierPriceSelect
                              )}
                              className="custom-select-search"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="d-sm-flex align-items-center pl-3 mt-3">
                      <div className=" d-flex col-md-10">
                        <div className="d-flex col-md-4 gap-1">
                          <div className="">
                            New Price:
                            <input
                              name="newPriceToAll"
                              type="number"
                              value={advanceItemFilterInput?.ItemPrice}
                              onChange={(e) => {
                                setAdvanceItemFilterInput((prev) => {
                                  return { ...prev, ItemPrice: e.target.value };
                                });
                              }}
                              onFocus={handleFocus}
                              className="pos-form-control"
                            ></input>
                          </div>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary mt-4"
                            onClick={() => {
                              if (advanceItemFilterInput?.ItemPrice > 0) {
                                handleAdvanceFilterInput(
                                  advanceItemFilterInput?.ItemPrice,
                                  "cartPrice"
                                );
                              } else {
                                toastWarn("please Add Price for Apply");
                              }
                            }}
                          >
                            Apply
                          </button>
                        </div>

                        <div
                          className="d-flex col-md-4 gap-1"
                          style={{ borderRight: "black" }}
                        >
                          <div className="">
                            New Qty:
                            <input
                              name="ItemQty"
                              type="number"
                              value={advanceItemFilterInput?.ItemQty}
                              onChange={(e) => {
                                setAdvanceItemFilterInput((prev) => {
                                  return { ...prev, ItemQty: e.target.value };
                                });
                              }}
                              onFocus={handleFocus}
                              className="pos-form-control"
                            ></input>
                          </div>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary mt-4"
                            onClick={() => {
                              if (advanceItemFilterInput?.ItemQty > 0) {
                                handleAdvanceFilterInput(
                                  advanceItemFilterInput?.ItemQty,
                                  "cartQty"
                                );
                              } else {
                                toastWarn("please Add Qty for Apply");
                              }
                            }}
                          >
                            Apply
                          </button>
                        </div>

                        <button
                          style={{ width: "fit-content" }}
                          type="button"
                          className="btn btn-sm btn-primary mt-4 col-md-2 col-sm-6"
                          onClick={() => {
                            if (customerId === 0) {
                              customerWarningMessage();
                            } else {
                              // handleAdvanceFilterBulkToCart();
                              handleSelectAdvanceFilterSelectAll(
                                !itemSelectAllButton
                              );
                              setItemSelectAllButton(!itemSelectAllButton);
                            }
                          }}
                        >
                          {itemSelectAllButton ? "Deselect All" : "Select All"}
                        </button>
                        <button
                          style={{ width: "fit-content" }}
                          type="button"
                          className="btn btn-sm btn-primary mt-4 col-md-2 col-sm-6"
                          onClick={() => {
                            if (customerId === 0) {
                              customerWarningMessage();
                            } else {
                              handelSelectedItemAddTocart();
                            }
                          }}
                        >
                          Add Selected
                          {/* Selected Item Bulk to Cart */}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div
                className="pos-categories tabs_wrapper slim-scrollbar"
                // style={{
                //   height: "74vh",
                //   overflowY: "scroll",
                // }}
              >
                <div className="pos-products">
                  <div className="tabs_container">
                    <div className="tab_content active" data-tab="all">
                      <div className="row">
                        {/* skeletonLoading */}
                        {skeletonLoading
                          ? Array.from({ length: 6 }).map((_, index) => (
                              <div
                                key={index}
                                className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4"
                              >
                                <div
                                  style={{
                                    border: "2px solid #dbdbdb",
                                    minHeight: "112px",
                                    display: "block",
                                    justifyContent: "center",
                                    position: "relative",
                                  }}
                                  className="product-info default-cover card"
                                >
                                  <div className="d-flex align-items-center">
                                    {/* Placeholder for image */}
                                    <Placeholder
                                      as="div"
                                      animation="wave"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                        margin: "10px auto",
                                      }}
                                      className="responsiveimage"
                                    >
                                      <Placeholder
                                        xs={12}
                                        style={{
                                          height: "100%",
                                          color: "var(--primary-color-50)",
                                        }}
                                      />
                                    </Placeholder>
                                    <div
                                      className="category-content"
                                      style={{
                                        width: "85%",
                                        borderLeft: "1px solid #dbdbdb",
                                        margin: "0 0 0 8px",
                                        padding: "0 0 0 8px",
                                        minHeight: "98px",
                                      }}
                                    >
                                      {/* Placeholder for title */}
                                      <Placeholder
                                        as="p"
                                        animation="wave"
                                        style={
                                          {
                                            // width: "100%",
                                            // margin: "10px auto",
                                          }
                                        }
                                      >
                                        <Placeholder
                                          xs={11}
                                          style={{
                                            color: "var(--primary-color-50)",
                                          }}
                                        />
                                      </Placeholder>

                                      {/* Placeholder for details */}
                                      <Placeholder
                                        as="div"
                                        animation="wave"
                                        style={
                                          {
                                            // width: "100%",
                                            // margin: "10px auto",
                                          }
                                        }
                                      >
                                        <Placeholder
                                          xs={6}
                                          style={{
                                            color: "var(--primary-color-50)",
                                          }}
                                        />
                                      </Placeholder>

                                      <Placeholder
                                        as="div"
                                        animation="wave"
                                        style={
                                          {
                                            // width: "100%",
                                            // margin: "10px auto",
                                          }
                                        }
                                      >
                                        <Placeholder
                                          xs={4}
                                          style={{
                                            color: "var(--primary-color-50)",
                                          }}
                                        />{" "}
                                        <Placeholder
                                          xs={5}
                                          style={{
                                            color: "var(--primary-color-50)",
                                          }}
                                        />
                                      </Placeholder>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          : //  mainFilterData
                            //     ?.filter((el) =>
                            //       el?.type === "Product"
                            //         ? filterAllStockData
                            //           ? Number(el.CurrantQTY) > 0
                            //           : true
                            //         : true
                            //     )
                            filteredData.map(
                              (cat, index) => (
                                console.log(cat, "check cat value"),
                                (
                                  <div
                                    key={index}
                                    className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4"
                                  >
                                    <div
                                      style={{
                                        border:
                                          selectedIndex === index
                                            ? "2px solid #007bff"
                                            : "2px solid #dbdbdb", // Highlight Selected
                                        // border: "2px solid #dbdbdb",
                                        minHeight: "112px",
                                        display: "block",
                                        justifyContent: "center",
                                        position: "relative", // Added for absolute positioning of child elements
                                      }}
                                      className="product-info default-cover card"
                                      onClick={() => {
                                        if (customerId === 0) {
                                          customerWarningMessage();
                                        } else {
                                          if (
                                            cat?.type !== "Product" ||
                                            Number(cat?.itemsCount) > 0
                                          ) {
                                            customerId > 0
                                              ? handelMainFilter(cat)
                                              : customerWarningMessage();
                                            setSelectedIndex(0);
                                          }
                                        }
                                      }}
                                    >
                                      {/* Top-left checkbox */}
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "8px",
                                          left: "8px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          if (customerId === 0) {
                                            customerWarningMessage();
                                          } else {
                                            handelItemIsCheck(cat);
                                          }
                                        }}
                                      >
                                        {/* <input type="checkbox" /> */}
                                        {cat.type === "Product" &&
                                          cat.itemsCount === 0 && (
                                            <img
                                              width={"20px"}
                                              src={
                                                cat.isInCart
                                                  ? itemcheck
                                                  : itemuncheck
                                              }
                                            />
                                          )}
                                      </div>

                                      {/* Top-right icons */}
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "8px",
                                          right: "8px",
                                          display: "flex",
                                          gap: "8px", // Space between the icons
                                        }}
                                      >
                                        {/* <i
                                        className="fas fa-eye"
                                        style={{ cursor: "pointer" }}
                                      ></i> */}
                                        {/* <img width={'25px'} src={eyeIcon}  />
                                      <img width={'25px'} src={Heart}  />
                                      <img width={'25px'} src={EMPTYheart}  /> */}
                                        {/* <i
                                        className="fas fa-heart"
                                        style={{ cursor: "pointer" }}
                                      ></i> */}
                                      </div>
                                      <div className="d-flex align-items-center">
                                        {/* Image Section (30%) */}
                                        <div
                                          className="image-section"
                                          style={{
                                            width: "15%",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                          }}
                                        >
                                          {/* Main Image */}
                                          <ImageWithBasePath
                                            src={cat.src}
                                            alt={cat.title}
                                            height={50}
                                            width={50}
                                            id={cat.id}
                                            mode="circle" // or 'square'
                                            onClick={() => {
                                              if (customerId === 0) {
                                                customerWarningMessage();
                                              } else {
                                                handelMainFilter(cat);
                                              }
                                            }}
                                            className="responsiveimage cursor-pointer"
                                            title={
                                              cat.type === "Product" &&
                                              cat.itemsCount === 0
                                                ? "Add to Cart"
                                                : ""
                                            }
                                          />

                                          {/* Secondary Images */}
                                          {cat.type === "Product" &&
                                            cat.itemsCount === 0 && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  gap: "4px",
                                                  // padding:"0px",
                                                  // justifyContent: "space-between",
                                                  alignItems: "end",
                                                  // marginTop: "10px"
                                                }}
                                              >
                                                {/* Favourite Icon */}
                                                <span>
                                                  <img
                                                    style={{
                                                      cursor: "pointer",
                                                      width: "30px", // Ensure uniform size
                                                      height: "30px",
                                                    }}
                                                    src={
                                                      cat?.isFavourite
                                                        ? favourite
                                                        : makeFavourit
                                                    }
                                                    onClick={() => {
                                                      if (customerId > 0) {
                                                        handelFavourite(cat);
                                                      } else {
                                                        customerWarningMessage();
                                                      }
                                                    }}
                                                  />
                                                </span>

                                                {/* Eye Icon */}
                                                <span
                                                  data-bs-target="#ItemsDetailsModal"
                                                  data-bs-toggle="modal"
                                                  onClick={() =>
                                                    setItemDetailModelId(
                                                      cat?.id
                                                    )
                                                  }
                                                >
                                                  <img
                                                    style={{
                                                      cursor: "pointer",
                                                      width: "30px", // Ensure uniform size
                                                      height: "30px",
                                                    }}
                                                    src={eyeIcon}
                                                  />
                                                </span>
                                              </div>
                                            )}
                                        </div>

                                        {/* <div className="vertical-line"></div> */}

                                        {/* Content Section (70%) */}
                                        {/* <div > */}
                                        <div
                                          className="category-content"
                                          style={{
                                            width: "85%",
                                            borderLeft: "1px solid #dbdbdb",
                                            margin: "0 0 0 8px",
                                            padding:
                                              cat?.type === "Product" &&
                                              Number(cat.itemsCount) == 0
                                                ? "0 0 0 8px"
                                                : "18px 0 0 8px", // Corrected padding values
                                            minHeight: "98px", // This can stay constant, or you can conditionally change it if needed
                                          }}
                                        >
                                          {/* {cat.isInCart && (
                                          <span className="check-icon">
                                            <i
                                              className="fa fa-check"
                                              style={{ color: "white" }}
                                            ></i>
                                          </span>
                                        )} */}
                                          {/* cart-title */}
                                          {cat?.type === "Product" ? (
                                            <p
                                              // data-bs-target="#ItemsDetailsModal"
                                              // data-bs-toggle="modal"
                                              // onClick={() =>
                                              //   setItemDetailModelId(cat?.id)
                                              // }
                                              // style={{height:"30px"}}
                                              className={`${
                                                cat?.type === "Product"
                                                  ? "pos-cart-list-title-product cursor-pointer"
                                                  : "pos-cart-list-title cursor-pointer"
                                              }`}
                                              onClick={() => {
                                                if (
                                                  cat?.type === "Product" &&
                                                  Number(cat?.itemsCount) === 0
                                                ) {
                                                  customerId === 0
                                                    ? customerWarningMessage()
                                                    : handelMainFilter(cat);
                                                }
                                              }}

                                              // className="pos-cart-list-title cursor-pointer"
                                            >
                                              {cat.title}
                                            </p>
                                          ) : (
                                            <p
                                              // data-bs-target="#ItemsDetailsModal"
                                              // data-bs-toggle="modal"
                                              // onClick={() =>
                                              //   setItemDetailModelId(cat?.id)
                                              // }
                                              // style={{height:"30px"}}
                                              className={`${
                                                cat?.type === "Product"
                                                  ? "pos-cart-list-title-product cursor-pointer"
                                                  : "pos-cart-list-title cursor-pointer"
                                              }`}
                                            >
                                              {cat.title}
                                            </p>
                                          )}
                                          <div
                                            style={{ padding: "3px 0px" }}
                                            className="d-flex justify-content-between"
                                          >
                                            <div className="d-flex align-items-center">
                                              {cat?.type === "Product" &&
                                                Number(cat?.itemsCount) ===
                                                  0 && (
                                                  <div
                                                    style={{
                                                      borderRadius: "50%",
                                                      backgroundColor:
                                                        Number(
                                                          cat.QuickBookId
                                                        ) >
                                                        // Number(cat.QuickBookId) >
                                                        0
                                                          ? "green"
                                                          : "red",
                                                      padding: "4px",
                                                      marginRight: "4px",
                                                    }}
                                                  ></div>
                                                )}
                                              <p className="cart-title-Variation">
                                                {/* {cat.type} |{" "} */}
                                                {`${cat.type}${
                                                  cat.parentName
                                                    ? " : " + cat.parentName
                                                    : ""
                                                } |`}
                                              </p>
                                              <p className="ml-1 cart-title-Variation">
                                                {cat?.type === "Product" &&
                                                Number(cat?.itemsCount) === 0
                                                  ? Number(
                                                      cat.CurrantQTY
                                                    ).toFixed(2)
                                                  : cat.itemsCount}{" "}
                                                {cat?.type === "Product" &&
                                                Number(cat?.itemsCount) === 0
                                                  ? "QTY"
                                                  : cat.type !== "Product"
                                                  ? "Items"
                                                  : "Variations"}
                                              </p>
                                            </div>
                                            {/* <div className="row"> */}
                                            {/* <div>
                                            {cat.type === "Product" &&
                                              cat.itemsCount === 0 && (
                                                <>
                                                  <img
                                                    style={{
                                                      marginLeft: "10px",
                                                      marginTop: "0px",
                                                      cursor: "pointer",
                                                    }}
                                                    width={"25px"}
                                                    src={
                                                      // findAndSetFavourite(cat)
                                                      cat?.isFavourite
                                                        ? favourite
                                                        : makeFavourit
                                                    }
                                                    onClick={() => {
                                                      if (customerId > 0) {
                                                        handelFavourite(cat);
                                                      } else {
                                                        customerWarningMessage();
                                                      }
                                                    }}
                                                  />
                                                  <span
                                                    data-bs-target="#ItemsDetailsModal"
                                                    data-bs-toggle="modal"
                                                    onClick={() =>
                                                      setItemDetailModelId(
                                                        cat?.id
                                                      )
                                                    }
                                                  >
                                                    <img
                                                      style={{
                                                        marginLeft: "10px",
                                                        marginTop: "0px",
                                                        cursor: "pointer",
                                                      }}
                                                      width={"25px"}
                                                      src={eyeIcon}
                                                    />
                                                  </span>

                                                  {/* <img style={{marginLeft:"10px" , marginTop:"-10px"}} width={'25px'} src={EMPTYheart}  /> */}
                                            {/* </>
                                              )}
                                          </div> */}
                                            {/* </div> */}
                                          </div>
                                          <div className="d-flex gap-4 gap-sm-2 justify-content-between cart-specified-padding">
                                            {cat.type === "Product" &&
                                              cat.itemsCount === 0 && (
                                                <>
                                                  {/* <input
                                            className="Cart_Iput col-xxl-2 col-xl-2 col-md-4 col-sm-4"
                                            placeholder="price"
                                            value={cat.cartPrice}
                                            onChange={(e) =>
                                              productHandleChange(
                                                e.target.value,
                                                index,
                                                "cartPrice",
                                                "item",
                                                cat
                                              )
                                            }
                                          /> */}

                                                  {/* <div className="Cart_InputWrapper col-xxl-2 col-xl-2 col-md-4 col-sm-4">
                                              <i
                                                className="fa fa-minus"
                                                onMouseDown={() =>
                                                  handleMouseDown(
                                                    index,
                                                    "cartPrice",
                                                    "item",
                                                    "decrease",
                                                    cat,
                                                    "fromgrid"
                                                  )
                                                }
                                                onMouseUp={handleMouseUp}
                                                onMouseLeave={handleMouseUp}
                                              ></i>
                                              <input
                                                className="Cart_Input"
                                                placeholder="price"
                                                value={`$${
                                                  cat.cartPrice || ""
                                                }`} // Add $ sign to the displayed value
                                                onChange={(e) => {
                                                  const rawValue =
                                                    e.target.value.replace(
                                                      /^\$/,
                                                      ""
                                                    ); // Remove $ sign from the input
                                                  productHandleChange(
                                                    rawValue,
                                                    index,
                                                    "cartPrice",
                                                    "item",
                                                    cat
                                                  );
                                                }}
                                              />
                                              <i
                                                className="fa fa-plus"
                                                onMouseDown={() =>
                                                  handleMouseDown(
                                                    index,
                                                    "cartPrice",
                                                    "item",
                                                    "increase",
                                                    cat,
                                                    "fromgrid"
                                                  )
                                                }
                                                onMouseUp={handleMouseUp}
                                                onMouseLeave={handleMouseUp}
                                              ></i>
                                            </div> */}
                                                  <div>
                                                    <p className="label-font-cart">
                                                      Price
                                                    </p>
                                                    <div className="Cart_InputWrapper col-xxl-2 col-xl-2 col-md-4 col-sm-4">
                                                      <i
                                                        className="fa fa-minus"
                                                        onMouseDown={() =>
                                                          handleMouseDown(
                                                            index,
                                                            "cartPrice",
                                                            "item",
                                                            "decrease",
                                                            cat,
                                                            "fromgrid"
                                                          )
                                                        }
                                                        onMouseUp={
                                                          handleMouseUp
                                                        }
                                                        onMouseLeave={
                                                          handleMouseUp
                                                        }
                                                      ></i>
                                                      <input
                                                        className="Cart_Input"
                                                        placeholder="price"
                                                        value={`$${
                                                          cat.cartPrice || 0
                                                          // .toFixed(2)
                                                        }`}
                                                        onChange={(e) => {
                                                          // const rawValue =
                                                          //   e.target.value.replace(
                                                          //     /^\$/,
                                                          //     ""
                                                          //   ); // Remove $ sign

                                                          const rawValue =
                                                            validateNumber(
                                                              e.target.value
                                                            );
                                                          console.log(
                                                            rawValue,
                                                            "rawValue"
                                                          );
                                                          productHandleChange(
                                                            rawValue, // Ensure input value is formatted
                                                            // .toFixed(2)
                                                            index,
                                                            "cartPrice",
                                                            "item",
                                                            cat
                                                          );
                                                        }}
                                                      />
                                                      <i
                                                        className="fa fa-plus"
                                                        onMouseDown={() =>
                                                          handleMouseDown(
                                                            index,
                                                            "cartPrice",
                                                            "item",
                                                            "increase",
                                                            cat,
                                                            "fromgrid"
                                                          )
                                                        }
                                                        onMouseUp={
                                                          handleMouseUp
                                                        }
                                                        onMouseLeave={
                                                          handleMouseUp
                                                        }
                                                      ></i>
                                                    </div>
                                                  </div>

                                                  <div>
                                                    <p className="label-font-cart">
                                                      Qty
                                                    </p>
                                                    <div className="Cart_InputWrapper col-xxl-2 col-xl-2 col-md-5 col-sm-5">
                                                      <i
                                                        className="fa fa-minus"
                                                        onMouseDown={() =>
                                                          handleMouseDown(
                                                            index,
                                                            "cartQty",
                                                            "item",
                                                            "decrease",
                                                            cat,
                                                            "fromgrid"
                                                          )
                                                        }
                                                        onMouseUp={
                                                          handleMouseUp
                                                        }
                                                        onMouseLeave={
                                                          handleMouseUp
                                                        }
                                                      ></i>
                                                      <input
                                                        className="Cart_Input"
                                                        placeholder="QTY"
                                                        type="text"
                                                        ref={
                                                          selectedIndex ===
                                                          index
                                                            ? qtyselectRef
                                                            : null
                                                        }
                                                        value={cat.cartQty}
                                                        onChange={(e) => {
                                                          const rawValue =
                                                            validateNumber(
                                                              e.target.value
                                                            );
                                                          productHandleChange(
                                                            rawValue,
                                                            index,
                                                            "cartQty",
                                                            "item",
                                                            cat
                                                          );
                                                        }}
                                                      />
                                                      <i
                                                        className="fa fa-plus"
                                                        onMouseDown={() =>
                                                          handleMouseDown(
                                                            index,
                                                            "cartQty",
                                                            "item",
                                                            "increase",
                                                            cat,
                                                            "fromgrid"
                                                          )
                                                        }
                                                        onMouseUp={
                                                          handleMouseUp
                                                        }
                                                        onMouseLeave={
                                                          handleMouseUp
                                                        }
                                                      ></i>
                                                    </div>
                                                  </div>
                                                </>
                                              )}
                                            {cat.type === "Product" &&
                                              cat.itemsCount === 0 && (
                                                <div>
                                                  <p className="label-font-cart">
                                                    Cart
                                                  </p>
                                                  <button
                                                    style={{
                                                      border:
                                                        "1px solid #dbdbdb",
                                                      backgroundColor:
                                                        cartData.some(
                                                          (el) =>
                                                            el.id === cat.id &&
                                                            el.variationId ===
                                                              cat.variationId
                                                        )
                                                          ? "#1a2649"
                                                          : "initial",
                                                    }}
                                                    className="primary-button-height col-xxl-2 col-xl-2 col-md-4 col-sm-4 p-0"
                                                    onClick={() => {
                                                      if (customerId === 0) {
                                                        customerWarningMessage();
                                                      } else {
                                                        handelMainFilter(cat);
                                                        setSelectedIndex(index);
                                                        // handleFetchCustAOCCard(
                                                        //   customerId,
                                                        //   cat?.id,
                                                        //   cat?.variationId
                                                        // );
                                                        // if(cartData.some(
                                                        //   (el) =>
                                                        //     el.id === cat.id &&
                                                        //     el.variationId ===
                                                        //       cat.variationId
                                                        // )){
                                                        //   // add this for the double added and qty updated
                                                        //   setOpenTooltipIndex(0);
                                                        //   handleInputChange(cat.cartQty, 0);
                                                        //   setOpenTooltipIndexPrice(null);
                                                        //   setopenTooltipIndexSum(null);
                                                        //   setModuleopen(true);
                                                        // }
                                                      }
                                                    }}
                                                  >
                                                    <i
                                                      className={`fas ${
                                                        cartData.some(
                                                          (el) =>
                                                            el.id === cat.id &&
                                                            el.variationId ===
                                                              cat.variationId
                                                        )
                                                          ? "fa-cart-plus text-white"
                                                          : "fa-cart-plus"
                                                      } me-1`}
                                                    ></i>
                                                    {/* <i className="fa fa-clock"></i> */}
                                                  </button>
                                                </div>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )
                            )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-xl-4 col-md-4 ps-0">
              <aside
                className="product-order-list"
                // style={{
                //   height: "88vh",
                //   overflowY: "scroll",
                // }}
              >
                {/* <div className="head d-flex align-items-center justify-content-between w-100">
                  <div className="">
                    <h5>Order List</h5>
                    <span>Transaction ID : #65565</span>
                  </div>
                  <div className="">
                    <Link className="confirm-text" to="#">
                      <Trash2 className="feather-16 text-danger me-1" />
                    </Link>
                    <Link to="#" className="text-default">
                      <MoreVertical className="feather-16" />
                    </Link>
                  </div>
                </div> */}

                <div className="product-added block-section">
                  <div className="customer-dropdown-desktop customer-info block-section col-auto d-flex align-items-center col-auto">
                    {customerId > 0 ? (
                      <div className="head d-flex align-items-center justify-content-between w-100 col-12">
                        <div className="d-flex gap-3">
                          <ImageWithBasePath
                            src={customerDetail.Image}
                            alt={customerDetail.label}
                            height={50}
                            width={50}
                            id={customerDetail.Id}
                            mode="circle"
                          />
                          <div
                            className="gap-2 align-items-center mt-2"
                            //  style={{display:"flex" , gap : "28px" , alignItems : "center"}}
                          >
                            <span
                              className="cursor-pointer"
                              onClick={() =>
                                HandelCustomerSupplierDetailModel()
                              }
                              // data-bs-target="#CustomerSupplierDetailModel"
                              // data-bs-toggle="modal"
                            >{`${customerDetail.FirstName} ${customerDetail.LastName} (${customerDetail.CompanyName})`}</span>
                            {/* <div className="d-flex align-items-center gap-2">
                              <p>
                                Balance:2{" "}
                                {balanceLading == true ? (
                                  <img
                                    src={loadingimage}
                                    className="ml-1"
                                    alt="Loading..."
                                    style={{ width: "20px" }}
                                  />
                                ) : (
                                  CurrencySymbols(
                                    Number(customerBalance),
                                    { CurrencySymbol },
                                    FractionDigits
                                  )
                                )}
                              </p>
                              <span style={{ lineHeight: "18px" }}> | </span>
                              <p className="custom-text-green fw-bold">
                                AOS:{" "}
                                {CurrencySymbols(
                                  Number(selectedCustomerAvgAOS),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                              </p>
                            </div> */}

                            <div className="d-flex align-items-center gap-2">
                              <div className="d-flex align-items-center mb-0">
                                Balance:{" "}
                                <span
                                  style={{ fontSize: "12px" }}
                                  className="me-1"
                                ></span>
                                {balanceLading ? (
                                  <img
                                    src={loadingimage}
                                    alt="Loading..."
                                    width={20}
                                    className="ms-1"
                                    style={{
                                      display: "inline-block",
                                      verticalAlign: "middle",
                                    }}
                                  />
                                ) : (
                                  <span
                                    style={{ fontSize: "12px", color: "black" }}
                                    className="ms-1"
                                  >
                                    {showCustomerBalance ? (
                                      CurrencySymbols(
                                        Number(customerBalance),
                                        { CurrencySymbol },
                                        FractionDigits
                                      )
                                    ) : (
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          cursor: "pointer",
                                          textDecoration: "underline",
                                        }}
                                        onClick={() => checkBalance()}
                                      >
                                        Click Here
                                      </span>
                                    )}
                                  </span>
                                )}
                              </div>

                              {/* separator */}
                              <div
                                style={{
                                  width: "1px",
                                  backgroundColor: "#d1d5db", // light gray, adjust to match your theme
                                  height: "18px",
                                  margin: "0 8px",
                                }}
                              />

                              <div className="d-flex align-items-center mb-0">
                                <span
                                  style={{ fontSize: "12px" }}
                                  className="me-1 custom-text-green fw-bold"
                                >
                                  AOS:
                                </span>
                                <span
                                  style={{ fontSize: "12px" }}
                                  className="custom-text-green fw-bold"
                                >
                                  {showCustomerAOS ? (
                                    CurrencySymbols(
                                      Number(selectedCustomerAvgAOS),
                                      { CurrencySymbol },
                                      FractionDigits
                                    )
                                  ) : (
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                      }}
                                      onClick={() => checkAOS()}
                                    >
                                      Click Here
                                    </span>
                                  )}
                                </span>
                              </div>
                            </div>

                            {/* <Link
                              to="#"
                              className="customer-link"
                              data-bs-toggle={customerId > 0 ? "modal" : null}
                              data-bs-target={customerId > 0 ? "#create" : null}
                              onClick={() => {
                                if (customerId <= 0) {
                                  customerWarningMessage();
                                }
                              }}
                            >
                              {`${customerDetail.Address1}, ${customerDetail.City}, ${customerDetail.StateProvince}, ${customerDetail.Zip}, ${customerDetail.Country}`}
                            </Link> */}
                          </div>
                        </div>
                        <div className="d-flex">
                          <Link
                            className="btn-icon edit-icon me-2"
                            to={`/manage-customers/${customerId}`}
                          >
                            <Edit className="feather-16 text-danger me-1" />
                          </Link>
                          <Link
                            className="confirm-text"
                            to="#"
                            onClick={() => {
                              if (paramObject.saleId > 0) {
                                setCustomerPopup(true);
                                setmodule("Customer");
                              } else {
                                setCustomerId(0);
                                setCustomerDetail({});
                                setShippingAddressId(0);
                              }

                              // setCartData([]);
                            }}
                          >
                            <Trash2 className="feather-16 text-danger me-1" />
                          </Link>
                        </div>
                      </div>
                    ) : (
                      <div className="input-block d-flex align-items-center col-12 mb-0">
                        <div className="input-group flex-nowrap">
                          <span
                            className="input-group-text border-size-input"
                            id="addon-wrapping"
                          >
                            <Link to="/manage-customers">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-person-plus"
                                viewBox="0 0 16 16"
                              >
                                <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                                <path
                                  fillRule="evenodd"
                                  d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                                />
                              </svg>
                            </Link>
                          </span>
                          <Select
                            className="w-100"
                            options={custOptions}
                            classNamePrefix="react-select"
                            placeholder="Select Customer"
                            onChange={(e) => {
                              handelCustomerSelect(e);
                            }}
                            value={custOptions?.find(
                              (el) => el.value === customerId
                            )}
                            hideSelectedOptions={true}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE_POS}
                            filterOption={(candidate, input) => {
                              const searchText = input.toLowerCase();
                              const {
                                label,
                                address,
                                PhoneNumber,
                                address2,
                                City,
                                StateProvince,
                                Country,
                                FirstName,
                                LastName,
                              } = candidate.data; // Access additional fields
                              return (
                                label.toLowerCase().includes(searchText) || // Search by name
                                address?.toLowerCase().includes(searchText) || // Search by address
                                PhoneNumber?.toLowerCase().includes(
                                  searchText
                                ) || // Search by email
                                address2?.toLowerCase().includes(searchText) || // Search by email
                                City?.toLowerCase().includes(searchText) || // Search by email
                                StateProvince?.toLowerCase().includes(
                                  searchText
                                ) || // Search by email
                                Country?.toLowerCase().includes(searchText) || // Search by email
                                FirstName?.toLowerCase().includes(searchText) || // Search by email
                                LastName?.toLowerCase().includes(searchText) // Search by email
                              );
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="pos-content-padding head-text d-flex align-items-center justify-content-between pos-seprator">
                    <h6 className="d-flex align-items-center mb-0">
                      <div
                        onClick={() =>
                          setShowItemMoreDetails(!showItemMoreDetails)
                        }
                      >
                        {showItemMoreDetails ? (
                          <i class="fa fa-minus"></i>
                        ) : (
                          <i class="fa fa-plus"></i>
                        )}
                      </div>
                      <span style={{ padding: "16px" }} className="count">
                        {cartData?.length}
                      </span>
                      Products
                      <Link
                        to="#"
                        className="btn btn-sm btn-clear-Data ml-2"
                        data-bs-toggle={customerId === 0 ? null : "modal"}
                        data-bs-target={customerId === 0 ? null : "#viewCart"}
                        onClick={() => {
                          if (customerId === 0) {
                            customerWarningMessage();
                          } else {
                            setModuleopen(true);
                          }
                        }}
                      >
                        View Cart
                      </Link>
                    </h6>
                    {paramObject.saleId ? <p> Edit Mode </p> : <> </>}
                    <div>
                      <spna onClick={() => handelErrorCartData(checkErrorData)}>
                        {checkErrorData ? (
                          <i
                            className="fa fa-circle mr-2"
                            style={{ fontSize: "16px", color: "orange" }}
                          ></i>
                        ) : (
                          <i
                            className="fa fa-circle mr-2"
                            style={{ fontSize: "16px", color: "grey" }}
                          ></i>
                        )}
                      </spna>
                      <Link
                        to="#"
                        className="btn btn-sm btn-clear-Data mr-2" //d-flex align-items-center text-danger
                        onClick={() => {
                          setCustomerPopup(true);
                          setmodule("CartClear");
                        }}
                      >
                        <span className="me-1">
                          <i data-feather="x" className="feather-16" />
                        </span>
                        Clear Cart
                      </Link>
                      {/* <Link
                        to="#"
                        className="btn btn-sm btn-clear-Data mr-2" //d-flex align-items-center text-danger
                        onClick={() => cancleEdit()}
                      >
                        <span className="me-1">
                          <i data-feather="x" className="feather-16" />
                        </span>
                        Clear Data
                      </Link> */}

                      <div className="btn-group btn-group-sm pull-right">
                        {checkUserPermission(PERMISSION_LOOKUPRECEIPT) ||
                        checkUserPermission(PERMISSION_ALLRECEIPT) ? (
                          <button
                            type="button"
                            className="btn me-1 btn-clear-Data"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <i
                              class="fa fa-circle"
                              style={{
                                color: "var(--primary-color-800) !important",
                                fontSize: "6px",
                              }}
                            ></i>{" "}
                            <i
                              class="fa fa-circle"
                              style={{
                                color: "var(--primary-color-800) !important",
                                fontSize: "6px",
                              }}
                            ></i>{" "}
                            <i
                              class="fa fa-circle"
                              style={{
                                color: "var(--primary-color-800) !important",
                                fontSize: "6px",
                              }}
                            ></i>
                          </button>
                        ) : (
                          " "
                        )}
                        <ul className="dropdown-menu">
                          {checkUserPermission(PERMISSION_LOOKUPRECEIPT) ? (
                            <li>
                              <Link
                                className="dropdown-item"
                                data-bs-target="#LookupReceiptSaleModal"
                                data-bs-toggle="modal"
                              >
                                <i className="far fa-file-alt fs-6 me-1 mt-1"></i>{" "}
                                Lookup Receipt
                              </Link>
                            </li>
                          ) : (
                            ""
                          )}

                          {checkUserPermission(PERMISSION_LOOKUPRECEIPT) ? (
                            <li>
                              <Link
                                to={`/sales-receipt/${
                                  accountSaleData?.InvoiceNumber - 1
                                }`}
                                title="Show last sale receipt"
                                className="dropdown-item"
                              >
                                <i className="fas fa-receipt fs-6 me-1 mt-1"></i>
                                Show last sale receipt
                              </Link>
                            </li>
                          ) : null}

                          {checkUserPermission(PERMISSION_ALLRECEIPT) ? (
                            <li>
                              <Link
                                to="/sales-all-receipt"
                                title="Show all receipts for today"
                                className="dropdown-item"
                              >
                                <i className="far fa-file-alt fs-6 me-1 mt-1"></i>{" "}
                                Show all receipts for today
                              </Link>
                            </li>
                          ) : (
                            ""
                          )}

                          {checkUserPermission(PERMISSION_SALE_CUSTOMREPORT) ? (
                            <li>
                              <Link
                                to="/custom_search_report"
                                title="Sales Custom Report"
                                className="dropdown-item"
                              >
                                <i className="far fa-file-alt fs-6 me-1 mt-1"></i>{" "}
                                Sales Custom Report
                              </Link>
                            </li>
                          ) : (
                            ""
                          )}
                          {showEmployeeRegister == "true" &&
                            userRegisterId != 0 && (
                              <>
                                <li>
                                  <Link
                                    to="/register_add_subtract?type=add&method=Cash"
                                    title="Add cash to register"
                                    className="dropdown-item"
                                  >
                                    <i className="fa fa-plus-circle fs-6 me-1 mt-1"></i>{" "}
                                    Add cash to register
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="/register_add_subtract?type=remove&method=Cash"
                                    title="Remove cash from register"
                                    className="dropdown-item"
                                  >
                                    <i className="fa fa-sign-out fs-6 me-1 mt-1"></i>{" "}
                                    Remove cash from register
                                  </Link>
                                </li>
                              </>
                            )}
                          {userRegisterId != 0 && (
                            <li>
                              <Link
                                to={`/posregister?type=close&Id=${userRegisterId}`}
                                title="Close register"
                                className="dropdown-item"
                              >
                                <i className="far fa-times-circle fs-6 me-1 mt-1"></i>{" "}
                                Close register
                              </Link>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      borderBottom: "1px solid rgb(179, 179, 179)",
                      display: "flex",
                    }}
                    className="row align-items-center text-center"
                  >
                    <div
                      style={{ paddingLeft: "14%" }}
                      className="col-lg-4 col-md-5 col-sm-4 col-3"
                    >
                      Price
                    </div>
                    <div
                      // style={{ paddingRight: "12%" }}
                      className={
                        !SaleQuickPermision
                          ? "col-lg-2 col-md-2 col-sm-2 col-3 pl-5"
                          : "col-lg-4 col-md-3 col-sm-4 col-3 pl-5"
                      }
                    >
                      <span className="ml-3">QTY</span>
                    </div>
                    {!SaleQuickPermision && (
                      <div
                        style={{ paddingLeft: "8%" }}
                        className="col-lg-2 col-md-2 col-sm-2 col-3"
                      >
                        DISC.
                      </div>
                    )}
                    <div
                      style={{ paddingLeft: "14%" }}
                      className="col-lg-4 col-md-3 col-sm-4 col-3 d-flex align-item-start"
                    >
                      Total
                    </div>
                  </div>

                  <div className="product-wrap slim-scrollbar">
                    {cartData?.map((cat, index) => (
                      <div
                        className="pos-content-padding product-list d-flex align-items-center justify-content-between flex-wrap"
                        key={index}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "nowrap",
                            gap: "10px",
                          }}
                          className="d-flex align-items-center product-info w-100"
                        >
                          <p>{index + 1}</p>
                          <Link
                            to="#"
                            className="img-bg"
                            style={{ flexShrink: "0" }}
                          >
                            {cat.src === undefined ? (
                              <img src={Noimage} alt="No image available" />
                            ) : (
                              <ImageWithBasePath
                                src={cat.src}
                                alt={cat.title}
                                height={50}
                                width={50}
                                id={cat.id}
                                mode="circle"
                              />
                            )}
                          </Link>

                          <div className="cart-pos-flex-grow info flex-grow-1">
                            <div className="product-col cart-pos-flex-grow info flex-grow-1 d-flex align-items-center justify-content-between">
                              <p
                                className="pos-cart-title cursor-pointer"
                                data-bs-target="#ItemsDetailsModal"
                                data-bs-toggle="modal"
                                onClick={() => setItemDetailModelId(cat?.id)}
                              >
                                <div className="d-flex align-items-center gap-1">
                                  {cat.title}
                                  {/* {cat?.AvgUnitPrice &&
                                    cat?.AvgQuantity &&
                                    enableAOSForItemAndVariation && (
                                      <div className="custom-text-green d-flex ml-2 mr-2">
                                        [ AOS: {cat.AvgQuantity} |{" "}
                                        {CurrencySymbols(
                                          Number(cat.AvgUnitPrice),
                                          { CurrencySymbol },
                                          FractionDigits
                                        )}{" "}
                                        ]
                                      </div>
                                    )} */}
                                </div>
                              </p>

                              {/* <p className="pos-cart-title cursor-pointer">

</p> */}
                            </div>
                            <div className="row info flex-grow-1 cart-align gap-4 ml-0">
                              <p
                                // key={index}
                                style={{
                                  backgroundColor: "white",
                                  color: "black",
                                }}
                                className={`INput_Wraper input-width col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6  ${
                                  openTooltipIndexPrice === index
                                    ? "tooltip-visible"
                                    : ""
                                }`}
                                onClick={() => {
                                  setOpenTooltipIndexPrice(
                                    openTooltipIndexPrice === index
                                      ? null
                                      : index
                                  );
                                  handleInputPriceChange(
                                    cat.cartPrice,
                                    index,
                                    cat
                                  );
                                  setOpenTooltipIndex(null);
                                  setopenTooltipIndexSum(null);
                                  setModuleopen(true);

                                  // Programmatically focus and select the input
                                }} // Toggle tooltip visibility for the clicked item
                              >
                                {`$${Number(cat.cartPrice).toFixed(2)}`}
                                {openTooltipIndexPrice === index && (
                                  <div
                                    style={{ position: "sticky" }}
                                    ref={tooltipRefPrice}
                                    className="tooltip"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      // setModuleopen(false);
                                    }} // Prevent closing on tooltip interactions
                                  >
                                    <div
                                      style={{
                                        padding: "5px 5px",
                                        margin: "5px 0px",
                                        backgroundColor: "#ececec",
                                      }}
                                    >
                                      <p>Price</p>
                                    </div>
                                    <div className="Cart_InputWrapper_cart col-lg-4 col-md-5 col-sm-4 col-6 p-0">
                                      <i
                                        className="fa fa-minus"
                                        onMouseDown={(e) => {
                                          e.stopPropagation();
                                          let findIndex =
                                            cat?.variationId > 0
                                              ? cat?.variationId
                                              : cat?.id;

                                          handlePriceChange(
                                            findIndex,
                                            "decrease"
                                          ); // Decrease the tempQty when minus is clicked
                                        }}
                                        onMouseUp={handleMouseUp}
                                        onMouseLeave={handleMouseUp}
                                      ></i>
                                      <input
                                        ref={inputRef} // Add the ref here
                                        className="Cart_Input"
                                        placeholder="Price"
                                        onFocus={handleFocus}
                                        value={`$${
                                          tempPrice[
                                            cat?.variationId > 0
                                              ? cat?.variationId
                                              : cat?.id
                                          ] !== undefined
                                            ? tempPrice[
                                                cat?.variationId > 0
                                                  ? cat?.variationId
                                                  : cat?.id
                                              ]
                                            : cat.cartPrice
                                        }`} // Use tempQty for the specific item
                                        onClick={(e) => {
                                          e.stopPropagation();
                                        }} // Prevent outside click detection
                                        onChange={(e) => {
                                          const rawValue =
                                            e.target.value.replace(/^\$/, "");
                                          handleInputPriceChange(
                                            rawValue,
                                            index,
                                            cat
                                          );
                                        }} // Handle input change per index
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            e.preventDefault(); // Prevent default form submission behavior if applicable
                                            let findIndex =
                                              cat?.variationId > 0
                                                ? cat?.variationId
                                                : cat?.id;

                                            const findIndexs =
                                              cartData.findIndex(
                                                (el) =>
                                                  el.id == cat.id &&
                                                  el.variationId ==
                                                    cat.variationId
                                              );

                                            handleConfirmPrice(
                                              findIndex,
                                              false,
                                              findIndexs
                                            );
                                            // Call the confirm function when Enter key is pressed
                                          }
                                        }}
                                      />
                                      <i
                                        className="fa fa-plus"
                                        onMouseDown={(e) => {
                                          e.stopPropagation();

                                          let findIndex =
                                            cat?.variationId > 0
                                              ? cat?.variationId
                                              : cat?.id;

                                          handlePriceChange(
                                            findIndex,
                                            "increase"
                                          ); // Increase the tempQty when plus is clicked
                                        }}
                                        onMouseUp={handleMouseUp}
                                        onMouseLeave={handleMouseUp}
                                      ></i>
                                      <button
                                        className="btn confirm-btn ml-2 mr-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          let findIndex =
                                            cat?.variationId > 0
                                              ? cat?.variationId
                                              : cat?.id;

                                          const findIndexs = cartData.findIndex(
                                            (el) =>
                                              el.id == cat.id &&
                                              el.variationId == cat.variationId
                                          );

                                          handleConfirmPrice(
                                            findIndex,
                                            false,
                                            findIndexs
                                          ); // Confirm and update cartQty for the specific item
                                        }}
                                      >
                                        ✔
                                      </button>
                                      <button
                                        className="btn cancel-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setModuleopen(false);
                                          setOpenTooltipIndexPrice(null); // Close tooltip on cancel
                                        }}
                                      >
                                        ✖
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </p>

                              <p
                                // key={index}
                                style={{
                                  backgroundColor: "white",
                                  color: "black",
                                }}
                                className={`INput_Wraper input-width col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6  ${
                                  openTooltipIndex === index
                                    ? "tooltip-visible"
                                    : ""
                                }`}
                                onClick={() => {
                                  setOpenTooltipIndex(
                                    openTooltipIndex === index ? null : index
                                  );
                                  handleInputChange(cat.cartQty, index, cat);
                                  setOpenTooltipIndexPrice(null);
                                  setopenTooltipIndexSum(null);
                                  setModuleopen(true);
                                }} // Toggle tooltip visibility for the clicked item
                              >
                                {Number(cat.cartQty).toFixed(2)}
                                {openTooltipIndex === index && (
                                  <div
                                    style={{ position: "sticky" }}
                                    ref={tooltipRef}
                                    className="tooltip"
                                    onClick={(e) => e.stopPropagation()} // Prevent closing on tooltip interactions
                                  >
                                    <div
                                      style={{
                                        padding: "5px 5px",
                                        margin: "5px 0px",
                                        backgroundColor: "#ececec",
                                      }}
                                    >
                                      <p>QTY</p>
                                    </div>
                                    <div className="Cart_InputWrapper_cart col-lg-4 col-md-5 col-sm-4 col-6 p-0">
                                      <i
                                        className="fa fa-minus"
                                        onMouseDown={(e) => {
                                          e.stopPropagation();
                                          // handleMouseDown(index, "cartQty", "item", "decrease", cat, "fromcart");
                                          let findIndex =
                                            cat?.id > 0
                                              ? cat?.id
                                              : cat?.variationId;

                                          handleQuantityChange(
                                            findIndex,
                                            "decrease"
                                          ); // Decrease the tempQty when minus is clicked
                                        }}
                                        onMouseUp={handleMouseUp}
                                        onMouseLeave={handleMouseUp}
                                      ></i>
                                      <input
                                        ref={inputRef}
                                        className="Cart_Input"
                                        placeholder="QTY"
                                        onFocus={handleFocus}
                                        value={
                                          tempQty[
                                            cat?.variationId > 0
                                              ? cat?.variationId
                                              : cat?.id
                                          ] !== undefined
                                            ? tempQty[
                                                cat?.variationId > 0
                                                  ? cat?.variationId
                                                  : cat?.id
                                              ]
                                            : cat.cartQty
                                        } // Use tempQty for the specific item
                                        onClick={(e) => e.stopPropagation()} // Prevent outside click detection
                                        onChange={(e) =>
                                          handleInputChange(
                                            e.target.value,
                                            index,
                                            cat
                                          )
                                        } // Handle input change per index
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            e.preventDefault(); // Prevent default behavior if applicable
                                            let findIndex =
                                              cat?.variationId > 0
                                                ? cat?.variationId
                                                : cat?.id;
                                            const findIndexs =
                                              cartData.findIndex(
                                                (el) =>
                                                  el.id == cat.id &&
                                                  el.variationId ==
                                                    cat.variationId
                                              );
                                            handleConfirm(
                                              findIndex,
                                              false,
                                              findIndexs
                                            ); // Call the confirm function when Enter key is pressed
                                          }
                                        }}
                                      />
                                      <i
                                        className="fa fa-plus"
                                        onMouseDown={(e) => {
                                          e.stopPropagation();
                                          // handleMouseDown(index, "cartQty", "item", "increase", cat, "fromcart");
                                          let findIndex =
                                            cat?.id > 0
                                              ? cat?.id
                                              : cat?.variationId;
                                          handleQuantityChange(
                                            findIndex,
                                            "increase"
                                          ); // Increase the tempQty when plus is clicked
                                        }}
                                        onMouseUp={handleMouseUp}
                                        onMouseLeave={handleMouseUp}
                                      ></i>
                                      <button
                                        className="btn confirm-btn ml-2 mr-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          let findIndex =
                                            cat?.variationId > 0
                                              ? cat?.variationId
                                              : cat?.id;
                                          const findIndexs = cartData.findIndex(
                                            (el) =>
                                              el.id == cat.id &&
                                              el.variationId == cat.variationId
                                          );
                                          handleConfirm(
                                            findIndex,
                                            false,
                                            findIndexs
                                          ); // Confirm and update cartQty for the specific item
                                        }}
                                      >
                                        ✔
                                      </button>
                                      <button
                                        className="btn cancel-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setOpenTooltipIndex(null); // Close tooltip on cancel
                                          setModuleopen(false);
                                        }}
                                      >
                                        ✖
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </p>
                              {!SaleQuickPermision && (
                                <p
                                  style={{
                                    backgroundColor: "white",
                                    color: "black",
                                    cursor: "default",
                                  }}
                                  className={`INput_Wraper input-width col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 `}
                                >
                                  {`${CurrencySymbol}${cat.cartTotalDiscount}`}
                                </p>
                              )}
                              <div className="ml-2 col-lg-3 col-md-2 col-sm-2 col-3 text-md-start text-center d-flex justify-content-between align-items-center gap-2">
                                <p
                                  // key={index}
                                  style={{
                                    backgroundColor: "white",
                                    color: "black",
                                    marginBottom: "20px",
                                    width: "50px",
                                  }}
                                  className={`INput_Wraper  col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6  ${
                                    openTooltipIndexSum === index
                                      ? "tooltip-visible"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    setopenTooltipIndexSum(
                                      openTooltipIndexSum === index
                                        ? null
                                        : index
                                    );
                                    setOpenTooltipIndexPrice(null);
                                    setOpenTooltipIndex(null);
                                    setModuleopen(true);
                                  }}
                                >
                                  {/* Display Total Sum */}
                                  <p className="total-col mb-0 text-start">
                                    <strong
                                      className={`fs-6 ${
                                        !(
                                          (
                                            Number(cat.cartPrice || 0) *
                                              Number(cat.cartQty || 0) -
                                            Number(cat.cartTotalDiscount || 0)
                                          ).toFixed(2) ==
                                          Number(cat.cartTotal || 0).toFixed(2)
                                        )
                                          ? "text-danger"
                                          : ""
                                      }`}
                                    >
                                      $
                                      {tempSum[
                                        cat?.variationId > 0
                                          ? cat?.variationId
                                          : cat?.id
                                      ] !== undefined
                                        ? tempSum[
                                            cat?.variationId > 0
                                              ? cat?.variationId
                                              : cat?.id
                                          ]
                                        : Number(
                                            Number(cat.cartPrice || 0) *
                                              Number(cat.cartQty || 0) -
                                              Number(cat.cartTotalDiscount || 0)
                                          ).toFixed(2)}
                                    </strong>
                                  </p>

                                  {openTooltipIndexSum === index && (
                                    <div
                                      style={{
                                        position: "relative",
                                        transform:
                                          "translateX(-56%) translateY(0)",
                                      }}
                                      ref={tooltipRefSum}
                                      className="tooltip"
                                      onClick={(e) => e.stopPropagation()} // Prevent closing on tooltip interactions
                                    >
                                      <div
                                        style={{
                                          padding: "5px 5px",
                                          margin: "5px 0px",
                                          backgroundColor: "#ececec",
                                        }}
                                      >
                                        <p>Adjust Total Sum</p>
                                      </div>
                                      <div className="Cart_InputWrapper_cart">
                                        <i
                                          className="fa fa-minus"
                                          onClick={() => {
                                            // Only update temp sum value for the price change, not directly update
                                            const currentValue =
                                              tempSum[
                                                cat?.variationId > 0
                                                  ? cat?.variationId
                                                  : cat?.id
                                              ] ||
                                              cat.cartPrice * cat.cartQty -
                                                Number(
                                                  cat.cartTotalDiscount || 0
                                                );
                                            settempSum((prevTempSum) => ({
                                              ...prevTempSum,
                                              [cat?.variationId > 0
                                                ? cat?.variationId
                                                : cat?.id]: currentValue - 1,
                                            }));
                                          }}
                                        ></i>
                                        <input
                                          ref={inputRef}
                                          className="Cart_Input"
                                          placeholder="Total Sum"
                                          value={`$${
                                            tempSum[
                                              cat?.variationId > 0
                                                ? cat?.variationId
                                                : cat?.id
                                            ] != undefined
                                              ? tempSum[
                                                  cat?.variationId > 0
                                                    ? cat?.variationId
                                                    : cat?.id
                                                ]
                                              : cat.cartPrice * cat.cartQty
                                          }`}
                                          onFocus={handleFocus}
                                          onClick={(e) => e.stopPropagation()}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              e.preventDefault();

                                              let findIndex =
                                                cat?.variationId > 0
                                                  ? cat?.variationId
                                                  : cat?.id;

                                              const findIndexs =
                                                cartData.findIndex(
                                                  (el) =>
                                                    el.id == cat.id &&
                                                    el.variationId ==
                                                      cat.variationId
                                                );

                                              handleConfirmSum(
                                                findIndex,
                                                false,
                                                findIndexs
                                              );
                                            }
                                          }}
                                          onChange={(e) => {
                                            const rawValue =
                                              e.target.value.replace(/^\$/, "");
                                            settempSum((prevTempSum) => ({
                                              ...prevTempSum,
                                              [cat?.variationId > 0
                                                ? cat?.variationId
                                                : cat?.id]: rawValue,
                                            }));
                                          }}
                                        />
                                        <i
                                          className="fa fa-plus"
                                          onClick={() => {
                                            // Only update temp sum value for the price change, not directly update
                                            const currentValue =
                                              tempSum[
                                                cat?.variationId > 0
                                                  ? cat?.variationId
                                                  : cat?.id
                                              ] ||
                                              cat.cartPrice * cat.cartQty -
                                                Number(
                                                  cat.cartTotalDiscount || 0
                                                );
                                            settempSum((prevTempSum) => ({
                                              ...prevTempSum,
                                              [cat?.variationId > 0
                                                ? cat?.variationId
                                                : cat?.id]:
                                                Number(currentValue) + 1,
                                            }));
                                          }}
                                        ></i>
                                        <button
                                          className="btn confirm-btn ml-2 mr-2"
                                          onClick={(e) => {
                                            e.stopPropagation();

                                            let findIndex =
                                              cat?.variationId > 0
                                                ? cat?.variationId
                                                : cat?.id;

                                            const findIndexs =
                                              cartData.findIndex(
                                                (el) =>
                                                  el.id == cat.id &&
                                                  el.variationId ==
                                                    cat.variationId
                                              );

                                            handleConfirmSum(
                                              findIndex,
                                              false,
                                              findIndexs
                                            );
                                          }}
                                        >
                                          ✔
                                        </button>
                                        <button
                                          className="btn cancel-btn"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            // Reset the temp sum or leave the state as is
                                            settempSum((prevTempSum) => ({
                                              ...prevTempSum,
                                              [cat?.variationId > 0
                                                ? cat?.variationId
                                                : cat?.id]:
                                                cat.cartPrice * cat.cartQty,
                                            }));
                                            setopenTooltipIndexSum(null); // Close the tooltip
                                            setModuleopen(false);
                                          }}
                                        >
                                          ✖
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </p>
                                <div className="trash-col">
                                  {/* <p className="mb-0 text-start">
                                      <strong className="fs-6">
                                        $
                                        {Number(
                                          Number(cat.cartPrice || 0) *
                                            Number(cat.cartQty || 0)
                                        ).toFixed(2)}
                                      </strong>
                                    </p> */}
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handelRemoveFromCart(
                                        cat.variationId,
                                        cat.id
                                      )
                                    }
                                    className="btn delete-btn ms-auto"
                                  >
                                    <i className="fa fa-trash-o fs-5"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {showItemMoreDetails && (
                          <div
                            className={
                              "gridrow-" + (index % 2)
                                ? "even"
                                : "odd" + " bottom-table"
                            }
                          >
                            <table className="custom-table-pos ">
                              <tbody className="d-flex flex-wrap gap-xxl-3 gap-xl-3 gap-lg-3 gap-md-3 gap-sm-2">
                                <tr className="custom-row-pos">
                                  <td className="custom-cell-pos nowrap">
                                    Category: {cat?.CategoryName || "-"} |
                                  </td>
                                  <td className="custom-cell-pos nowrap">
                                    Stock:{" "}
                                    {Number(cat.CurrantQTY).toFixed(2) ?? 0} |
                                    {/* Stock: {(cat.CurrantQTY) ?? 0} | */}
                                  </td>
                                  <td className="custom-cell-pos nowrap">
                                    UPC/EAN/ISBN: {cat.ItemNumber ?? "-"} |
                                  </td>
                                  <td className="custom-cell-pos nowrap">
                                    Selling Price: {cat.UnitPrice | "-"} |
                                  </td>
                                  <td className="custom-cell-pos nowrap">
                                    Recall Price: {cat.RecallPrice}
                                    {cat.isReCallPrice
                                      ? ` (${moment(cat.isReCallPrice).format(
                                          "MM/DD/YYYY"
                                        )})`
                                      : ""}{" "}
                                    |
                                  </td>

                                  {/* <td className="custom-cell-pos nowrap">
                                    {!allowToShowAOS && (
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          cursor: "pointer",
                                          textDecoration: "underline",
                                        }}
                                        onClick={() => {
                                          handleFetchCustAOCCard(
                                            customerId,
                                            cat?.id,
                                            cat?.variationId
                                          );
                                          setAllowToShowAOS(true);
                                        }}
                                      >
                                        Click Here
                                      </span>
                                    )}
                                   {allowToShowAOSMap[cat.id] && (
  <>
    <span className="custom-text-green ml-1">
      AOS QTY: {cat.AvgQuantity}
    </span>
    <span
      style={{ cursor: "pointer" }}
      onClick={() => {
        setShowAosPriceButton(!showAosPriceButton);
        setShowAosPrice(!showAosPrice);
      }}
    >
      {showAosPriceButton === true && " | + "}
    </span>
  </>
)}

                                    {showAosPrice && (
                                      <span
                                        className="custom-text-green"
                                        style={{ display: "inline-flex" }}
                                      >
                                        <span className="ml-1 mr-1"> | </span>
                                        AOS Price:{" "}
                                        {cat.AvgUnitPrice
                                          ? CurrencySymbols(
                                              Number(cat.AvgUnitPrice),
                                              { CurrencySymbol },
                                              FractionDigits
                                            )
                                          : ""}
                                        <span
                                          className="ml-1 mr-1"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            setShowAosPrice(!showAosPrice);
                                            setShowAosPriceButton(
                                              !showAosPriceButton
                                            );
                                          }}
                                        >
                                          {" - "}
                                        </span>
                                      </span>
                                    )}
                                  </td> */}
                                  <td className="custom-cell-pos nowrap">
                                    {/* Click Here (only when this item isn't opened yet) */}
                                    {!aosOpenByItem[itemKey(cat)] && (
                                      <div className="d-flex align-items-center gap-2">
                                        <span>AOS: </span>
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                          }}
                                          onClick={() => openAosFor(cat)}
                                        >
                                          Click Here
                                        </span>
                                      </div>
                                    )}

                                    {/* AOS summary (only for this item) */}
                                    {aosOpenByItem[itemKey(cat)] && (
                                      <>
                                        <span className="custom-text-green ml-1">
                                          AOS QTY: {cat?.AvgQuantity ?? "-"}
                                        </span>

                                        {/* Show a small + when price panel is collapsed */}
                                        {!priceOpenByItem[itemKey(cat)] && (
                                          <span
                                            style={{ cursor: "pointer" }}
                                            onClick={() => togglePriceFor(cat)}
                                          >
                                            {" | + "}
                                          </span>
                                        )}
                                      </>
                                    )}

                                    {/* AOS Price panel (only for this item) */}
                                    {priceOpenByItem[itemKey(cat)] && (
                                      <span
                                        className="custom-text-green"
                                        style={{ display: "inline-flex" }}
                                      >
                                        <span className="ml-1 mr-1"> | </span>
                                        AOS Price:{" "}
                                        {cat?.AvgUnitPrice
                                          ? CurrencySymbols(
                                              Number(cat.AvgUnitPrice),
                                              { CurrencySymbol },
                                              FractionDigits
                                            )
                                          : ""}
                                        <span
                                          className="ml-1 mr-1"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => togglePriceFor(cat)}
                                        >
                                          {" - "}
                                        </span>
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </aside>
            </div>
          </div>

          <div className="pos-sticky-footer">
            <div className="row d-flex align-items-center">
              <div className="pos-detail-flex col-md-12 footer-gap">
                <div className="pos-sale-detail-bold">
                  Total QTY:{" "}
                  <span className="pos-sale-detail-bold">
                    {/* {cartData?.reduce(
                      (total, item) => total + (Number(item.cartQty) || 0),
                      0
                    )} */}
                    {Number(cartTotalQty).toFixed(2)}
                  </span>
                </div>
                <div className="pos-sale-detail-bold">
                  Sub Total:{" "}
                  <span className="pos-sale-detail-bold">
                    ${changePriceFormat(finalAmountData.subtotal)}
                  </span>
                </div>
                {!SaleQuickPermision && (
                  <div className="pos-sale-detail-bold">
                    Discount:{" "}
                    <span className="red-color pos-sale-detail-bold">
                      ${changePriceFormat(finalAmountData.totalDiscount)}
                    </span>
                  </div>
                )}
                <div className="pos-sale-detail-bold">
                  Tax:{" "}
                  <span
                    className="green-color pos-sale-detail-bold-link cursor-pointer"
                    data-bs-toggle={customerId === 0 ? null : "modal"}
                    data-bs-target={
                      customerId === 0 ? null : "#AdditionalTaxModel"
                    }
                    onClick={() => {
                      if (customerId === 0) {
                        customerWarningMessage();
                      }
                    }}
                  >
                    ${changePriceFormat(finalAmountData.totalTax)}
                  </span>
                </div>
                <div
                  // onClick={()=> setIsModalOpen(!isModalOpen)}

                  className="pos-sale-detail-bold cursor-pointer"
                  // style={{ cursor: "pointer" }}
                >
                  Additional Discount:{" "}
                  <span
                    className="red-color pos-sale-detail-bold-link cursor-pointer"
                    data-bs-toggle={customerId === 0 ? null : "modal"}
                    data-bs-target={
                      customerId === 0 ? null : "#AdditionalDiscountModel"
                    }
                    onClick={() => {
                      if (customerId === 0) {
                        customerWarningMessage();
                      }
                    }}
                  >
                    {/* data-bs-target="#AdditionalModel"> */}$
                    {changePriceFormat(finalAmountData.extraDiscountAmount)}
                  </span>
                </div>

                <div className="pos-sale-detail-bold">
                  Shipping:{" "}
                  <span
                    className="green-color pos-sale-detail-bold-link cursor-pointer"
                    data-bs-toggle={customerId === 0 ? null : "modal"}
                    data-bs-target={
                      customerId === 0 ? null : "#AdditionalShippingModel"
                    }
                    onClick={() => {
                      if (customerId === 0) {
                        customerWarningMessage();
                      }
                    }}
                  >
                    ${changePriceFormat(finalAmountData.shipping)}
                  </span>
                </div>

                <div className="d-flex gap-4">
                  <p
                    // data-bs-toggle="modal"
                    // data-bs-target="#TermDateModel"
                    className="pos-sale-detail-bold-link cursor-pointer"
                    data-bs-toggle={customerId === 0 ? null : "modal"}
                    data-bs-target={customerId === 0 ? null : "#TermDateModel"}
                    onClick={() => {
                      if (customerId === 0) {
                        customerWarningMessage();
                      }
                    }}
                  >
                    {selectedTerm == 1
                      ? "Due On Receipt"
                      : selectedTerm == 2
                      ? "Term 15"
                      : selectedTerm == 3
                      ? "Term 30"
                      : selectedTerm == 4
                      ? "Term 60"
                      : "Select Term"}
                  </p>

                  {/* Delivery Method */}
                  <p
                    className="pos-sale-detail-bold-link cursor-pointer"
                    data-bs-toggle={customerId === 0 ? null : "modal"}
                    data-bs-target={
                      customerId === 0 ? null : "#DeliveriesModal"
                    }
                    onClick={() => {
                      if (customerId === 0) {
                        customerWarningMessage();
                      } else {
                        setShow(true);
                      }
                    }}
                  >
                    {"Delivery" || "No delivery method available"}
                  </p>
                </div>
                <div
                  className="pos-sale-detail-bold-link cursor-pointer"
                  data-bs-toggle={customerId === 0 ? null : "modal"}
                  data-bs-target={customerId === 0 ? null : "#CommentMemo"}
                  onClick={() => {
                    if (customerId === 0) {
                      customerWarningMessage();
                    }
                  }}
                >
                  Note to customer
                </div>
                <div
                  className="pos-sale-detail-bold-link cursor-pointer"
                  data-bs-toggle={customerId === 0 ? null : "modal"}
                  data-bs-target={customerId === 0 ? null : "#InternalNotes"}
                  onClick={() => {
                    if (customerId === 0) {
                      customerWarningMessage();
                    }
                  }}
                >
                  Internal customer notes
                </div>
                <div
                  className="pos-sale-detail-bold-link cursor-pointer"
                  data-bs-toggle={customerId === 0 ? null : "modal"}
                  data-bs-target={
                    customerId === 0 ? null : "#MessageonStatement"
                  }
                  onClick={() => {
                    if (customerId === 0) {
                      customerWarningMessage();
                    }
                  }}
                >
                  Memo on statement
                </div>
                <div
                  className="pos-sale-detail-bold-link cursor-pointer"
                  data-bs-toggle={customerId === 0 ? null : "modal"}
                  data-bs-target={customerId === 0 ? null : "#Tags"}
                  onClick={() => {
                    if (customerId === 0) {
                      customerWarningMessage();
                    }
                  }}
                >
                  Tags
                </div>
                <div
                  className="pos-sale-detail-bold-link cursor-pointer"
                  data-bs-toggle={customerId === 0 ? null : "modal"}
                  data-bs-target={customerId === 0 ? null : "#Attachments"}
                  onClick={() => {
                    if (customerId === 0) {
                      customerWarningMessage();
                    }
                  }}
                >
                  Attachments
                </div>
                {AmountPaid > 0 && (
                  <div
                    className="pos-sale-detail-bold-link cursor-pointer"
                    data-bs-toggle={customerId === 0 ? null : "modal"}
                    data-bs-target={customerId === 0 ? null : "#PaymentDetail"}
                    onClick={() => {
                      if (customerId === 0) {
                        customerWarningMessage();
                      }
                    }}
                  >
                    Payment Detail
                  </div>
                )}
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-end p-2">
              {/* Button Row */}
              <div className="col-xxl-4 col-lg-1 col-md-1 col-sm-12 d-flex justify-content-end margin-bottom-phone">
                {customerId > 0 && (
                  // <div className="col-auto"></div>
                  // <Link
                  //   to="#"
                  //   className="btn btn-secondary col-auto"
                  //   data-bs-toggle={customerId > 0 ? "modal" : null}
                  //   data-bs-target={customerId > 0 ? "#create" : null}
                  //   onClick={() => {
                  //     if (customerId <= 0) {
                  //       customerWarningMessage();
                  //     }
                  //   }}
                  // >
                  //   Address
                  // </Link>
                  // <div className="delivery-btn-phone">
                  //   <Link
                  //     // className="btn btn-secondary"
                  //     className="default-cover item payment-method-btn d-flex justify-content-center align-items-center w-100 active pl-4 pr-4"
                  //     data-bs-target="#DeliveriesModal"
                  //     data-bs-toggle="modal"
                  //   >
                  //     Delivery
                  //   </Link>
                  // </div>
                  <></>
                )}
              </div>
              <div className="col-xxl-4 col-lg-5 col-md-5 col-sm-12 d-flex justify-content-end margin-bottom-phone">
                <div className="btn-row d-flex align-items-center justify-content-between flex-wrap gap-2 w-100">
                  {saleTypeId == 1 && (
                    <span className="text-danger">
                      * Delivery Method is Required
                    </span>
                  )}
                  <Select
                    options={saleTypeMethod}
                    className="custom-search-select"
                    onChange={(event) => handelDeliveryMethod(event?.value)}
                    menuPlacement="top"
                    value={saleTypeMethod?.find(
                      (el) => el.value === deliveryMethodId
                    )}
                  />
                  {paramObject?.saleId > 0 &&
                    saleTypeId == 1 &&
                    saleIsVoid == 0 && (
                      <Link
                        className="btn btn-info btn-icon fw-bold flex-grow-1"
                        onClick={() =>
                          handleVoid(
                            saleTypeId,
                            paramObject?.saleId,
                            salesQuickbookId
                          )
                        }
                      >
                        <span className="me-1 d-flex align-items-center">
                          <i data-feather="pause" className="feather-16" />
                        </span>
                        Void
                      </Link>
                    )}
                  <Link
                    to="#"
                    className="btn btn-info btn-icon fw-bold flex-grow-1"
                    data-bs-toggle="modal"
                    data-bs-target="#holdSale"
                  >
                    <span className="me-1 d-flex align-items-center">
                      <i data-feather="pause" className="feather-16" />
                    </span>
                    Hold
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-success btn-icon fw-bold flex-grow-1"
                    data-bs-target="#HistoryModel"
                    data-bs-toggle="modal"
                    onClick={() => setShowHistoryList(true)}
                  >
                    <span className="me-1 d-flex align-items-center">
                      <i data-feather="trash-2" className="feather-16" />
                    </span>
                    History
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-danger btn-icon fw-bold flex-grow-1"
                    onClick={() => cancleEdit()}
                    // data-bs-toggle="modal"
                    // data-bs-target="#payment-completed"
                  >
                    <span className="me-1 d-flex align-items-center">
                      <i data-feather="credit-card" className="feather-16" />
                    </span>
                    Cancel Edit
                  </Link>
                </div>
              </div>

              {/* Payment Methods */}
              {/* <div className="col-xxl-3 col-lg-3 col-md-4 col-sm-12 d-flex justify-content-center gap-2">
                <div
                  className={`default-cover item payment-method-btn d-flex justify-content-center align-items-center w-100 ${
                    paymentMethod === 1 ? "active" : ""
                  }`}
                  onClick={() => setPaymentMethod(1)}
                >
                  <Link to="#">
                    <span className="fs-6 font-bold">Cash</span>
                  </Link>
                </div>
                <div
                  className={`default-cover item payment-method-btn d-flex justify-content-center align-items-center w-100 ${
                    paymentMethod === 2 ? "active" : ""
                  }`}
                  onClick={() => setPaymentMethod(2)}
                >
                  <Link to="#">
                    <span className="fs-6 font-bold">Card</span>
                  </Link>
                </div>
                <div
                  className={`default-cover item payment-method-btn d-flex justify-content-center align-items-center w-100 ${
                    paymentMethod === 3 ? "active" : ""
                  }`}
                  onClick={() => setPaymentMethod(3)}
                >
                  <Link to="#">
                    <span className="fs-6 font-bold">Check</span>
                  </Link>
                </div>
              </div> */}
              {checkUserPermission("pos-take-payment") &&
                showPosTakePayment == "true" && (
                  <div className="col-xxl-1 col-lg-2 col-md-3 col-sm-12 d-flex justify-content-end">
                    <button
                      className="btn btn-primary btn-sm w-100"
                      data-bs-toggle={customerId === 0 ? null : "modal"}
                      data-bs-target={customerId === 0 ? null : "#PaymentType"}
                      // disabled={salesPreviousAmount != finalAmountData.total ? false : true}
                      onClick={() => {
                        if (customerId === 0) {
                          customerWarningMessage();
                        }
                      }}
                    >
                      Take Payment{" "}
                    </button>
                  </div>
                )}

              {/* Grand Total */}
              <div className="col-xxl-3 col-lg-4 col-md-3 col-sm-12 d-flex justify-content-end">
                <button
                  className="btn btn-primary btn-sm w-100"
                  onClick={() => {
                    if (customerId === 0) {
                      customerWarningMessage();
                    } else {
                      handelSubmitInvoice("Sale");
                    }
                  }}
                >
                  Save As Order | Grand Total: $
                  {changePriceFormat(finalAmountData?.total)}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* -----------------Model Using Start Here------------------ */}
      {/* create Customer */}
      <div
        className="modal fade"
        id="create"
        tabIndex={-1}
        aria-labelledby="create"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Customer Shipping Address</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <Tabs
                defaultActiveKey="DeliveryDropdown"
                id="form-tabs"
                className="mb-4"
              >
                <Tab
                  eventKey="DeliveryDropdown"
                  title="Select Delivery Address"
                >
                  <div className="customer-info block-section m-0 pb-1 col-md-6">
                    {/* <h6 className="mb-0">Shipping Address</h6> */}
                    <div className="input-block d-flex align-items-center">
                      <div className="flex-grow-1">
                        <Select
                          options={shippingAddressOption}
                          classNamePrefix="react-select"
                          placeholder={
                            customerId > 0
                              ? "Select Shipping Address"
                              : "Select Customer First"
                          }
                          onChange={(e) => {
                            setShippingAddressId(e.value);
                          }}
                          value={
                            customerId > 0
                              ? shippingAddressOption?.find(
                                  (el) => el.value === shippingAddressId
                                )
                              : null
                          }
                          styles={{}}
                          // hideSelectedOptions={true}
                          // styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        />
                      </div>
                      {/* <Link
                      to="#"
                      className="btn btn-primary btn-icon"
                      data-bs-toggle={customerId > 0 ? "modal" : null}
                      data-bs-target={customerId > 0 ? "#create" : null}
                      onClick={() => {
                        if (customerId <= 0) {
                          customerWarningMessage();
                        }
                      }}
                    >
                      <Plus className="feather-16" />
                    </Link> */}
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="shippingAddress" title="Delivery Address">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div className="col-md-4">
                      <Select
                        options={shippingAddressOption}
                        classNamePrefix="react-select"
                        placeholder="Shipping Address for Update"
                        onChange={(e) =>
                          handelCustomerShippingAddressUpdateSelect(e)
                        }
                        value={
                          shippingUpdateOptionId > 0
                            ? shippingAddressOption?.find(
                                (el) => el.value === shippingUpdateOptionId
                              )
                            : null
                        }
                        hideSelectedOptions={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      />
                    </div>

                    <div>
                      <button
                        type="button"
                        onClick={() => clearShippingAddressSelected()}
                        className="btn btn-primary"
                      >
                        Clear
                      </button>
                    </div>
                  </div>

                  <div className="row" style={{ textAlign: "left" }}>
                    <div className="col-6">
                      <div className="form-group row">
                        <label className="col-form-label col-md-4">
                          Address1
                        </label>
                        <div className="col-md-8">
                          <input
                            type="text"
                            className="pos-form-control "
                            onChange={(event) =>
                              handelCustomerShippingAddressInputUpdate(
                                event.target.value,
                                "Address1"
                              )
                            }
                            id="Address1"
                            name="Address1"
                            value={customerShippingUpdateData?.Address1}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-form-label col-md-4">
                          Address2
                        </label>
                        <div className="col-md-8">
                          <input
                            type="text"
                            className="pos-form-control "
                            onChange={(event) =>
                              handelCustomerShippingAddressInputUpdate(
                                event.target.value,
                                "Address2"
                              )
                            }
                            id="Address2"
                            name="Address2"
                            value={customerShippingUpdateData?.Address2}
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-form-label col-md-4">
                          {" "}
                          Country{" "}
                        </label>
                        <div className="col-md-8">
                          <input
                            type="text"
                            className="pos-form-control "
                            onChange={(event) =>
                              handelCustomerShippingAddressInputUpdate(
                                event.target.value,
                                "Country"
                              )
                            }
                            id="Country"
                            name="Country"
                            value={customerShippingUpdateData?.Country}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group row">
                        <label className="col-form-label col-md-4">
                          {" "}
                          City{" "}
                        </label>
                        <div className="col-md-8">
                          <input
                            type="text"
                            className="pos-form-control "
                            onChange={(event) =>
                              handelCustomerShippingAddressInputUpdate(
                                event.target.value,
                                "City"
                              )
                            }
                            id="City"
                            name="City"
                            value={customerShippingUpdateData?.City}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-form-label col-md-4">
                          State/Province{" "}
                        </label>
                        <div className="col-md-8">
                          <input
                            type="text"
                            className="pos-form-control "
                            onChange={(event) =>
                              handelCustomerShippingAddressInputUpdate(
                                event.target.value,
                                "StateProvince"
                              )
                            }
                            id="StateProvince"
                            name="StateProvince"
                            value={customerShippingUpdateData?.StateProvince}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-form-label col-md-4">Zip</label>
                        <div className="col-md-8">
                          <input
                            type="number"
                            className="pos-form-control "
                            onChange={(event) =>
                              handelCustomerShippingAddressInputUpdate(
                                event.target.value,
                                "Zip"
                              )
                            }
                            id="Zip"
                            name="Zip"
                            value={customerShippingUpdateData?.Zip}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer d-sm-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-cancel"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        setCustomerShippingUpdateData({});
                        setShippingUpdateOptionId(0);
                      }}
                    >
                      Cancel
                    </button>
                    <Link
                      to="#"
                      className="btn btn-submit me-2"
                      onClick={() => handelUpdateShippingAddressSubmit()}
                      data-bs-dismiss="modal"
                    >
                      Submit
                    </Link>
                  </div>
                </Tab>
              </Tabs>
              {/* <form>
                <div className="row">
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks">
                      <label>Customer Name</label>
                      <input type="text" className="pos-form-control " />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks">
                      <label>Email</label>
                      <input type="email" className="pos-form-control " />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks">
                      <label>Phone</label>
                      <input type="text" className="pos-form-control " />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks">
                      <label>Country</label>
                      <input type="text" className="pos-form-control " />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks">
                      <label>City</label>
                      <input type="text" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks">
                      <label>Address</label>
                      <input type="text" />
                    </div>
                  </div>
                </div>
                <div className="modal-footer d-sm-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-cancel"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <Link to="#" className="btn btn-submit me-2">
                    Submit
                  </Link>
                </div>
              </form> */}
            </div>
          </div>
        </div>
      </div>
      {/* -----------------Model Using End Here------------------ */}

      {/* Recent Transactions */}
      <div
        className="modal fade pos-modal"
        id="viewCart"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-fullscreen modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div style={{ padding: "0px 10px" }} className="modal-header">
              <h5 className="modal-title">Product Cart</h5>
              {customerId > 0 && (
                <div className="d-flex gap-3">
                  <ImageWithBasePath
                    src={customerDetail.Image}
                    alt={customerDetail.label}
                    height={50}
                    width={50}
                    id={customerDetail.Id}
                    mode="circle"
                  />
                  <div className="gap-2 align-items-start ms-md-3 ms-sm-2 mt-2">
                    <span>
                      {`${customerDetail.FirstName} ${customerDetail.LastName} (${customerDetail.CompanyName})`}
                    </span>
                    <p>
                      Balance:{" "}
                      {balanceLading ? (
                        <img
                          src={loadingimage}
                          alt="Loading..."
                          width={20}
                          className="ms-1"
                          style={{
                            display: "inline-block",
                            verticalAlign: "middle",
                          }}
                        />
                      ) : showCustomerBalance ? (
                        CurrencySymbols(
                          Number(customerBalance),
                          { CurrencySymbol },
                          FractionDigits
                        )
                      ) : (
                        <span
                          style={{
                            fontSize: "12px",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                          onClick={() => checkBalance()}
                        >
                          Click Here
                        </span>
                      )}
                    </p>
                  </div>
                </div>
              )}

              <div className="row g-3 flex-wrap col-7">
                {/* Item Search Component */}
                <div className="col-xxl-8 col-lg-8 col-md-6 col-sm-6">
                  {/* <label>Item Search Add</label> */}
                  <CommonItemSearch
                    customerID={customerId}
                    callback={callbackItemSearch}
                    searchItemInputRef={searchItemInputRef}
                    value={1}
                    callbackaccount={() => {}}
                  />
                </div>
                <div className="col-xxl-2 col-lg-2 col-md-5 col-sm-6">
                  <label></label>
                  <Link
                    type="button"
                    className="btn btn-secondary w-20"
                    onClick={() =>
                      setToggleItemsFilterSection(!toggleItemsFilterSection)
                    }
                  >
                    {!toggleItemsFilterSection ? (
                      <>
                        <i className="fa fa-arrow-up me-1"></i>
                        Filter{" "}
                      </>
                    ) : (
                      <>
                        <i className="fa fa-arrow-down me-1"></i>
                        Filter{" "}
                      </>
                    )}
                  </Link>
                  <spna
                    onClick={() => handelErrorCartData(checkErrorData)}
                    className="ms-2"
                  >
                    {checkErrorData ? (
                      <i
                        className="fa fa-circle mr-2"
                        style={{ fontSize: "16px", color: "orange" }}
                      ></i>
                    ) : (
                      <i
                        className="fa fa-circle mr-2"
                        style={{ fontSize: "16px", color: "grey" }}
                      ></i>
                    )}
                  </spna>
                </div>
              </div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ marginRight: "4px", padding: "20px" }}
                onClick={() => setModuleopen(false)}
              >
                <span style={{ fontSize: "38px" }} aria-hidden="true">
                  ×
                </span>
              </button>
            </div>

            <div
              // style={{ marginBottom: "60px" }}
              className="modal-body p-4 pos-view-cart"
            >
              <div className="">
                <div className="tab-pane fade show active">
                  <div className="mb-4">
                    {/* <div className="row g-3 flex-wrap mb-2">
                      {/* Item Search Component */}
                    {/* <div className="col-xxl-4 col-lg-6 col-md-4 col-sm-6">
                      <label>Item Search Add</label>
                      <CommonItemSearch
                        customerID={customerId}
                        callback={callbackItemSearch}
                        searchItemInputRef={searchItemInputRef}
                        value={1}
                        callbackaccount={() => {}}
                      />
                    </div> */}
                    {/* <div className="col-xxl-2 col-lg-2 col-md-5 col-sm-6">
                      <label></label>
                      <Link
                        type="button"
                        className="btn btn-secondary w-20 mt-4"
                        onClick={() =>
                          setToggleItemsFilterSection(!toggleItemsFilterSection)
                        }
                      >
                        {!toggleItemsFilterSection ? (
                          <>
                            <i className="fa fa-arrow-up me-1"></i>
                            Filter{" "}
                          </>
                        ) : (
                          <>
                            <i className="fa fa-arrow-down me-1"></i>
                            Filter{" "}
                          </>
                        )}
                      </Link>
                    </div> */}
                    {/* </div> */}
                    {toggleItemsFilterSection && (
                      <div className="row g-3 flex-wrap">
                        {/* Filter Category */}
                        <div className="col-xxl-2 col-lg-3 col-md-4 col-sm-6">
                          <label>Filter Category</label>
                          <Select
                            onChange={(event) => {
                              setCartCategoryFilterSelect(
                                event ? event.value : 0
                              );
                            }}
                            options={cartCategoryFilterData}
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            isClearable={true}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          />
                        </div>

                        {/* Default Selling Price */}
                        <div className="col-xxl-2 col-lg-3 col-md-4 col-sm-6">
                          <label>Price Rule</label>
                          <Select
                            options={defaultSellingPriceType}
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            onChange={(e) =>
                              handelCartFilterChange(e.value, "priceRule")
                            }
                            value={defaultSellingPriceType?.find(
                              (el) => el.value === cartPriceRuleSelect
                            )}
                            className="custom-select-search"
                          />
                        </div>

                        {/* Role Tier (Conditional Rendering) */}
                        {cartPriceRuleSelect == 2 && (
                          <div className="col-xxl-2 col-lg-3 col-md-4 col-sm-6">
                            <label>Role Tier</label>
                            <Select
                              options={cartTierPriceList}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              onChange={(e) =>
                                handelCartFilterChange(e.id, "roleTier")
                              }
                              value={cartTierPriceList?.find(
                                (el) => el.ID == cartTierPriceSelect
                              )}
                              className="custom-select-search"
                            />
                          </div>
                        )}
                        {/* Search Items Below */}
                        <div className="col-xxl-2 col-lg-3 col-md-6 col-sm-12">
                          <label>Search Items Below</label>
                          <input
                            type="text"
                            id="SearchInvoice"
                            name="SearchInvoice"
                            placeholder="Search Items"
                            className="pos-form-control"
                            value={cartItemFilterInput}
                            onChange={(e) =>
                              setcartItemFilterInput(e.target.value)
                            }
                            onFocus={handleFocus}
                          />
                        </div>

                        {/* Bulk Price */}
                        <div className="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-12 d-flex align-items-end">
                          <div className="me-2 w-100">
                            <label>New Price:</label>
                            <input
                              name="newPriceToAll"
                              type="number"
                              value={newCartBulkPrice}
                              onChange={(e) =>
                                setNewCartBulkPrice(e.target.value)
                              }
                              style={{ minWidth: "100px" }}
                              className="pos-form-control"
                            />
                          </div>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={() => {
                              if (newCartBulkPrice > 0) {
                                handelCartFilterChange(
                                  newCartBulkPrice,
                                  "cartPrice"
                                );
                                setNewCartBulkPrice("");
                              } else {
                                toastWarn("Please Add Price for Apply");
                              }
                            }}
                          >
                            Apply
                          </button>
                        </div>

                        {/* Bulk Quantity */}
                        <div className="col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-12 d-flex align-items-end">
                          <div className="me-2 w-100">
                            <label>New Qty:</label>
                            <input
                              name="newQtyToAll"
                              type="number"
                              value={newCartBulkQty}
                              onChange={(e) =>
                                setNewCartBulkQty(e.target.value)
                              }
                              style={{ minWidth: "100px" }}
                              className="pos-form-control"
                            />
                          </div>
                          <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={() => {
                              if (newCartBulkQty > 0) {
                                handelCartFilterChange(
                                  newCartBulkQty,
                                  "cartQty"
                                );
                                setNewCartBulkQty("");
                              } else {
                                toastWarn("Please Add Qty for Apply");
                              }
                            }}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="table-responsive">
                    <table className="table datanew">
                      <thead>
                        <tr>
                          <td
                            onClick={() =>
                              setShowItemMoreDetails(!showItemMoreDetails)
                            }
                          >
                            {showItemMoreDetails ? (
                              <i class="fa fa-minus"></i>
                            ) : (
                              <i class="fa fa-plus"></i>
                            )}
                          </td>
                          <th>No.</th>
                          <th>Image</th>
                          <th>Name</th>
                          <th>Price</th>
                          <th>Qty</th>
                          <th>Sub Total</th>
                          {!SaleQuickPermision && <th>Discount</th>}
                          {/* <th>Discount</th>
                          <th>TAX</th> */}
                          <th>Total</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cartData
                          ?.filter(
                            (el) =>
                              el.title
                                ?.toLowerCase()
                                .includes(
                                  cartItemFilterInput?.toLocaleLowerCase()
                                ) &&
                              (cartCategoryFilterSelect > 0
                                ? el?.CategoryID === cartCategoryFilterSelect
                                : true)
                          )
                          ?.map((cat, index) => (
                            <>
                              <tr key={`main-row-${index}`}>
                                <td></td>
                                <td>{cat.rowIndex}</td>
                                <td>
                                  <ImageWithBasePath
                                    src={cat.src}
                                    alt={cat.title}
                                    height={50}
                                    width={50}
                                    id={cat.id}
                                    mode="circle" // or 'square'
                                  />
                                </td>
                                <td
                                  className="view-cart-title"
                                  style={{
                                    whiteSpace: "inherit",
                                    marginTop: "12px",
                                  }}
                                >
                                  {cat.title}
                                </td>
                                <td>
                                  <input
                                    style={{
                                      border: "1px solid rgb(191 191 191)",
                                    }}
                                    className="pos-form-control mr-2"
                                    type="text"
                                    onFocus={handleFocus}
                                    placeholder="Price"
                                    // onChange={(e) => {
                                    //   const rawValue = validateNumber(
                                    //     e.target.value
                                    //   );
                                    //   // const valueWithoutDollar =
                                    //   //   e.target.value.replace(/^\$/, "");
                                    //   handelcartList(
                                    //     rawValue,
                                    //     index,
                                    //     "cartPrice",
                                    //     cat
                                    //   );
                                    // }}
                                    // value={`$${cat.cartPrice}`}
                                    // onBlur={(e) => {
                                    //   // let rawValue = e.target.value
                                    //   //   .replace(CurrencySymbol, "")
                                    //   //   .trim();
                                    //   const rawValue = validateNumber(
                                    //     e.target.value
                                    //   );
                                    //   let numericValue =
                                    //     parseFloat(rawValue) || 0;
                                    //   numericValue = numericValue.toFixed(2); // Format to 2 decimal places
                                    //   handelcartList(
                                    //     numericValue,
                                    //     index,
                                    //     "cartPrice",
                                    //     cat
                                    //   );
                                    // }}

                                    onChange={(e) => {
                                      const rawValue = e.target.value.replace(
                                        /^\$/,
                                        ""
                                      );
                                      handleInputPriceChange(
                                        rawValue,
                                        index,
                                        cat
                                      );
                                    }}
                                    value={`$${
                                      tempPrice[
                                        cat?.variationId > 0
                                          ? cat?.variationId
                                          : cat?.id
                                      ] !== undefined
                                        ? tempPrice[
                                            cat?.variationId > 0
                                              ? cat?.variationId
                                              : cat?.id
                                          ]
                                        : cat.cartPrice
                                    }`}
                                    onBlur={(e) => {
                                      const rawValue = e.target.value.replace(
                                        /^\$/,
                                        ""
                                      );
                                      if (rawValue != cat.cartPrice) {
                                        toastSuccess(
                                          e.target.value +
                                            " " +
                                            cat.cartPrice +
                                            " " +
                                            e.target.value !=
                                            cat.cartPrice
                                        );

                                        let findIndex =
                                          cat?.variationId > 0
                                            ? cat?.variationId
                                            : cat?.id;

                                        const findIndexs = cartData.findIndex(
                                          (el) =>
                                            el.id == cat.id &&
                                            el.variationId == cat.variationId
                                        );

                                        handleConfirmPrice(
                                          findIndex,
                                          false,
                                          findIndexs
                                        );
                                      }
                                    }}
                                  />
                                </td>
                                <td>
                                  <input
                                    ref={
                                      index === 0 ? searchCartQtyInputRef : null
                                    }
                                    style={{
                                      border: "1px solid rgb(191 191 191)",
                                    }}
                                    className="pos-form-control mr-2"
                                    type="number"
                                    // onChange={(e) =>
                                    //   handelcartList(
                                    //     e.target.value,
                                    //     index,
                                    //     "cartQty",
                                    //     cat
                                    //   )
                                    // }
                                    // value={cat.cartQty}
                                    onFocus={handleFocus}
                                    placeholder="Qty"
                                    onKeyDown={handleQtyKeyDown}
                                    onChange={(e) =>
                                      handleInputChange(
                                        e.target.value,
                                        index,
                                        cat
                                      )
                                    }
                                    value={
                                      tempQty[
                                        cat?.variationId > 0
                                          ? cat?.variationId
                                          : cat?.id
                                      ] !== undefined
                                        ? tempQty[
                                            cat?.variationId > 0
                                              ? cat?.variationId
                                              : cat?.id
                                          ]
                                        : cat.cartQty
                                    }
                                    onBlur={(e) => {
                                      if (e.target.value != cat.cartQty) {
                                        let findIndex =
                                          cat?.variationId > 0
                                            ? cat?.variationId
                                            : cat?.id;

                                        const findIndexs = cartData.findIndex(
                                          (el) =>
                                            el.id == cat.id &&
                                            el.variationId == cat.variationId
                                        );

                                        handleConfirm(
                                          findIndex,
                                          false,
                                          findIndexs
                                        );
                                      }
                                    }}
                                  />
                                </td>
                                <td>
                                  <input
                                    style={{
                                      border: "1px solid rgb(191 191 191)",
                                    }}
                                    className="pos-form-control mr-2"
                                    type="text"
                                    onFocus={handleFocus}
                                    placeholder="subTotal"
                                    // onChange={(e) => {
                                    //   const rawValue = validateNumber(
                                    //     e.target.value
                                    //   );

                                    //   let numericValue =
                                    //     parseFloat(rawValue) || 0;
                                    //   numericValue = numericValue.toFixed(2);

                                    //   const finalPrice =
                                    //     Number(numericValue) /
                                    //     Number(cat.cartQty);
                                    //   handelcartList(
                                    //     finalPrice.toFixed(2),
                                    //     index,
                                    //     "cartPrice",
                                    //     cat
                                    //   );
                                    // }}

                                    // value={`$${cat.cartSubTotal}`}
                                    // onBlur={(e) => {
                                    //   const rawValue = validateNumber(
                                    //     e.target.value
                                    //   );

                                    //   // let rawValue = e.target.value
                                    //   //   .replace(CurrencySymbol, "")
                                    //   //   .trim();

                                    //   let numericValue =
                                    //     parseFloat(rawValue) || 0;

                                    //   numericValue = numericValue.toFixed(2); // Format to 2 decimal places

                                    //   const finalPrice =
                                    //     Number(numericValue) /
                                    //     Number(cat.cartQty);
                                    //   handelcartList(
                                    //     finalPrice,
                                    //     index,
                                    //     "cartPrice",
                                    //     cat
                                    //   );
                                    // }}

                                    onChange={(e) => {
                                      const rawValue = e.target.value.replace(
                                        /^\$/,
                                        ""
                                      );
                                      let findIndex =
                                        cat?.variationId > 0
                                          ? cat?.variationId
                                          : cat?.id;

                                      settempSum((prevTempSum) => ({
                                        ...prevTempSum,
                                        [findIndex]: rawValue,
                                      }));
                                    }}
                                    value={`$${
                                      tempSum[
                                        cat?.variationId > 0
                                          ? cat?.variationId
                                          : cat?.id
                                      ] != undefined
                                        ? tempSum[
                                            cat?.variationId > 0
                                              ? cat?.variationId
                                              : cat?.id
                                          ]
                                        : cat.cartSubTotal //cat.cartPrice * cat.cartQty
                                    }`}
                                    onBlur={() => {
                                      let findIndex =
                                        cat?.variationId > 0
                                          ? cat?.variationId
                                          : cat?.id;

                                      const findIndexs = cartData.findIndex(
                                        (el) =>
                                          el.id == cat.id &&
                                          el.variationId == cat.variationId
                                      );

                                      handleConfirmSum(
                                        findIndex,
                                        false,
                                        findIndexs
                                      );
                                    }}
                                  />
                                </td>
                                {!SaleQuickPermision && (
                                  <td>
                                    <div
                                      style={{
                                        position: "relative",
                                        display: "inline-block",
                                        width: "100%",
                                      }}
                                    >
                                      <input
                                        style={{
                                          border: "1px solid rgb(191 191 191)",
                                        }}
                                        className="pos-form-control mr-2"
                                        type="text"
                                        onChange={(e) => {
                                          // const finalPrice = Number(e.target.value)
                                          // handelcartList(
                                          //   e.target.value,
                                          //   index,
                                          //   "cartDiscount",
                                          //   cat
                                          // );

                                          const findIndexs = cartData.findIndex(
                                            (el) =>
                                              el.id == cat.id &&
                                              el.variationId == cat.variationId
                                          );

                                          handelCartDiscountValue(
                                            e.target.value,
                                            findIndexs,
                                            "cartDiscount"
                                          );
                                        }}
                                        onFocus={handleFocus}
                                        value={`${cat.cartDiscount}`}
                                        placeholder="cartDiscount"
                                        onBlur={(e) => {
                                          const findIndexs = cartData.findIndex(
                                            (el) =>
                                              el.id == cat.id &&
                                              el.variationId == cat.variationId
                                          );

                                          handelCartDiscountCalculate(
                                            e.target.value,
                                            findIndexs,
                                            "cartDiscount",
                                            cat.cartDiscountType
                                          );

                                          // toastSuccess(e.target.value)
                                          // toastSuccess(typeof e.target.value)
                                          // toastSuccess(cat.cartDiscount)
                                          // toastSuccess(typeof cat.cartDiscount)
                                          // toastSuccess(e.target.value != cat.cartDiscount? "true":"false")
                                          // // if(e.target.value != cat.cartDiscount){
                                          //   toastSuccess(cat.cartDiscount)
                                          //     handelcartList(
                                          //    e.target.value,
                                          //    index,
                                          //    "cartDiscount",
                                          //    cat
                                          //  );
                                          // }
                                        }}
                                      />
                                      <button
                                        type="button"
                                        onClick={() => {
                                          handelCartDiscountCalculate(
                                            cat.cartDiscount,
                                            index,
                                            "cartDiscount",
                                            cat.cartDiscountType === "percent"
                                              ? "amount"
                                              : "percent"
                                          );
                                          // handelcartList(
                                          //   cat.cartDiscountType === "percent"
                                          //     ? "amount"
                                          //     : "percent",
                                          //   index,
                                          //   "cartDiscountType",
                                          //   cat
                                          // );
                                        }}
                                        style={{
                                          position: "absolute",
                                          right: "5px",
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                          height: "70%",
                                          padding: "0 10px",
                                          border: "1px solid #ccc",
                                          borderRadius: "4px",
                                          background: "#f9f9f9",
                                          fontSize: "0.85rem",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {cat.cartDiscountType === "percent"
                                          ? "%"
                                          : CurrencySymbol}
                                      </button>
                                    </div>
                                  </td>
                                )}
                                <td
                                  className={`font-bold ${
                                    !(
                                      Number(cat.cartPrice || 0) *
                                        Number(cat.cartQty || 0) -
                                        Number(cat.cartTotalDiscount || 0) ===
                                      Number(cat.cartTotal || 0)
                                    )
                                      ? "text-danger"
                                      : ""
                                  }`}
                                >
                                  ${cat.cartTotal}
                                </td>
                                <td>
                                  <Link
                                    onClick={() =>
                                      handelRemoveFromCart(
                                        cat.variationId,
                                        cat.id
                                      )
                                    }
                                    className="btn-icon delete-icon confirm-text text-danger"
                                    to="#"
                                  >
                                    <Trash2 className="feather-14" />
                                  </Link>
                                </td>
                              </tr>
                              {showItemMoreDetails && (
                                // <div
                                //   className={
                                //     "gridrow-" + (index % 2)
                                //       ? "even"
                                //       : "odd" + " bottom-table"
                                //   }
                                // >
                                <tr
                                  key={`details-row-${index}`}
                                  className="pl-5 details-row"
                                >
                                  <td colSpan="8" className="details-cell pl-5">
                                    <div className="details-content pl-3">
                                      <span>
                                        Category: {cat?.CategoryName || "-"} |
                                      </span>
                                      <span>
                                        Stock:{" "}
                                        {Number(cat.CurrantQTY).toFixed(2) ?? 0}{" "}
                                        |
                                      </span>
                                      <span>
                                        UPC/EAN/ISBN: {cat.ItemNumber ?? "-"} |
                                      </span>
                                      <span>
                                        Selling Price: {cat.UnitPrice || "-"} |
                                      </span>
                                      <span>
                                        Recall Price: {cat.RecallPrice}
                                        {cat.isReCallPrice
                                          ? ` (${moment(
                                              cat.isReCallPrice
                                            ).format("MM/DD/YYYY")})`
                                          : ""}{" "}
                                        |
                                      </span>
                                      {/* <span className="custom-text-green ml-1">
                                        AOS QTY: {cat.AvgQuantity}
                                      </span>
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          setShowAosPriceButton(
                                            !showAosPriceButton
                                          );
                                          setShowAosPrice(!showAosPrice);
                                        }}
                                      >
                                        {showAosPriceButton == true && " | + "}
                                      </span>

                                      {showAosPrice && (
                                        <span
                                          className="custom-text-green"
                                          style={{ display: "inline-flex" }}
                                        >
                                          <span className="ml-1 mr-1"> | </span>
                                          AOS Price:{" "}
                                          {cat.AvgUnitPrice
                                            ? CurrencySymbols(
                                                Number(cat.AvgUnitPrice),
                                                { CurrencySymbol },
                                                FractionDigits
                                              )
                                            : ""}
                                          <span
                                            className="ml-1 mr-1"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              setShowAosPrice(!showAosPrice);
                                              setShowAosPriceButton(
                                                !showAosPriceButton
                                              );
                                            }}
                                          >
                                            {" - "}
                                          </span>
                                        </span>
                                      )} */}
                                      {!aosOpenByItem[itemKey(cat)] && (
                                        <span className="">
                                          <span>AOS: </span>
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              cursor: "pointer",
                                              textDecoration: "underline",
                                            }}
                                            onClick={() => openAosFor(cat)}
                                          >
                                            Click Here
                                          </span>
                                        </span>
                                      )}

                                      {/* AOS summary (only for this item) */}
                                      {aosOpenByItem[itemKey(cat)] && (
                                        <>
                                          <span className="custom-text-green ml-1">
                                            AOS QTY: {cat?.AvgQuantity ?? "-"}
                                          </span>

                                          {/* Show a small + when price panel is collapsed */}
                                          {!priceOpenByItem[itemKey(cat)] && (
                                            <span
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                togglePriceFor(cat)
                                              }
                                            >
                                              {" | + "}
                                            </span>
                                          )}
                                        </>
                                      )}

                                      {/* AOS Price panel (only for this item) */}
                                      {priceOpenByItem[itemKey(cat)] && (
                                        <span
                                          className="custom-text-green"
                                          style={{ display: "inline-flex" }}
                                        >
                                          <span className="ml-1 mr-1"> | </span>
                                          AOS Price:{" "}
                                          {cat?.AvgUnitPrice
                                            ? CurrencySymbols(
                                                Number(cat.AvgUnitPrice),
                                                { CurrencySymbol },
                                                FractionDigits
                                              )
                                            : ""}
                                          <span
                                            className="ml-1 mr-1"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => togglePriceFor(cat)}
                                          >
                                            {" - "}
                                          </span>
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                                // </div>
                              )}
                            </>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Recent Transactions */}

      {/* Invoice Confirmation */}
      <div
        className="modal fade pos-modal"
        id="invoice-confirmation" // payment-completed
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <form>
                <div className="icon-head">
                  <Link to="#">
                    <CheckCircle className="feather-40" />
                  </Link>
                </div>
                <h4>Confirmation</h4>
                <p className="mb-0">
                  Are You Sure, You want to Generate this Invoice
                </p>
                <div className="modal-footer d-sm-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-primary flex-fill me-1"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => handelSubmitInvoice()}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary flex-fill"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancle
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Invoice Confirmation */}

      {/* Payment Completed */}
      <div
        className="modal fade modal-default"
        id="payment-completed"
        aria-labelledby="payment-completed"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <form>
                <div className="icon-head">
                  <Link to="#">
                    <CheckCircle className="feather-40" />
                  </Link>
                </div>
                <h4>Payment Completed</h4>
                <p className="mb-0">
                  Do you want to Print Receipt for the Completed Order
                </p>
                <div className="modal-footer d-sm-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-primary flex-fill me-1"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    data-bs-toggle="modal"
                    data-bs-target="#print-receipt"
                  >
                    Print Receipt
                  </button>
                  <Link to="#" className="btn btn-secondary flex-fill">
                    Next Order
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Payment Completed */}
      {/* Print Receipt */}
      <Modal
        size="sm"
        show={reciptModel}
        onHide={() => setReciptModel(false)}
        centered
      >
        <Modal.Header>
          <Modal.Title>Receipt</Modal.Title>
          {/* Close Icon */}
          <button
            type="button"
            className="btn-close"
            onClick={() => setReciptModel(false)}
            aria-label="Close"
            style={{
              position: "absolute",
              right: "1rem",
              top: "1rem",
              fontSize: "1.5rem",
              border: "none",
              background: "none",
            }}
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="icon-head text-center">
            <Link to="#">
              <ImageWithBasePath
                src={CompanyData.CompanyLogo}
                width={150}
                height={30}
                alt="Receipt Logo"
              />
            </Link>
          </div>
          <div className="text-center info">
            <h6>{CompanyData.CompanyName}</h6>
            <p className="mb-0">Phone Number: +516-596-8688</p>
            <p className="mb-0">
              Email:{" "}
              <Link
              // to="sales@reliabledistributor.com"
              >
                sales@reliabledistributor.com
              </Link>
            </p>
          </div>
          <div className="tax-invoice">
            <h6 className="text-center">Invoice</h6>
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <div className="invoice-user-name">
                  <span>
                    Name: {customerDetail.FirstName + customerDetail.LastName}
                  </span>
                </div>
                <div className="invoice-user-name">
                  <span>Invoice No: </span>
                </div>
              </div>
              <div className="col-sm-12 col-md-8">
                <div className="invoice-user-name">
                  <span>Date: {moment().format("MM-DD-YYYY")}</span>
                </div>
                <div className="invoice-user-name">
                  <span>Company Name: {customerDetail.CompanyName} </span>
                </div>
              </div>
            </div>
          </div>
          <table className="table-borderless w-100 table-fit">
            <thead>
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Price</th>
                <th>Qty</th>
                <th>Tax</th>
                <th>Discount</th>
                <th className="text-end">Total</th>
              </tr>
            </thead>
            <tbody>
              {cartData.map((item, index) => (
                <tr key={item.id || index}>
                  <td>{index + 1} -</td> {/* Sequential number */}
                  <td>{item.title}</td>
                  <td>${parseInt(item.cartPrice)}</td>
                  <td>{item.cartQty}</td>
                  <td>{item.cartTax}</td>
                  <td>{item.cartDiscount}</td>
                  <td className="text-end">${item.cartTotal}</td>
                </tr>
              ))}
              <br></br>
              <tr>
                <td colSpan={7}>
                  <table className="table-borderless w-100 table-fit">
                    <tbody>
                      <tr>
                        <td>Sub Total :</td>
                        <td className="text-end">
                          ${changePriceFormat(finalAmountData.subtotal)}
                        </td>
                      </tr>
                      <tr>
                        <td>Discount :</td>
                        <td className="text-end">
                          {" "}
                          - ${changePriceFormat(finalAmountData?.totalDiscount)}
                        </td>
                      </tr>
                      <tr>
                        <td>Additional Discount</td>
                        <td className="text-end">
                          {" "}
                          - $
                          {changePriceFormat(
                            finalAmountData.extraDiscountAmount
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax</td>
                        <td className="text-end">
                          + ${changePriceFormat(finalAmountData.totalTax)}
                        </td>
                      </tr>
                      <tr>
                        <td>Shipping</td>
                        <td className="text-end">
                          + ${changePriceFormat(finalAmountData.shipping)}
                        </td>
                      </tr>
                      <tr>
                        <td>Total</td>
                        <td className="text-end">
                          ${changePriceFormat(finalAmountData?.total)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="text-center invoice-bar">
            <p>
              **VAT against this challan is payable through central
              registration. Thank you for your business!
            </p>
            <Link to="#">
              <ImageWithBasePath
                src="assets/img/barcode/barcode-03.jpg"
                alt="Barcode"
                width={50}
              />
            </Link>
            <p>Sale - {salePOSId}</p>
            <p>Thank You For Shopping With Us. Please Come Again</p>
            <Link to="#" className="btn btn-primary">
              Print Receipt
            </Link>
          </div>
        </Modal.Body>
      </Modal>

      {/* /Print Receipt */}
      {/* Products */}
      <div
        className="modal fade modal-default pos-modal"
        id="products"
        aria-labelledby="products"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header p-4 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <h5 className="me-4">Products</h5>
                <span className="badge bg-info d-inline-block mb-0">
                  Order ID : #666614
                </span>
              </div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body p-4">
              <form>
                <div className="product-wrap">
                  <div className="product-list d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center flex-fill">
                      <Link to="#" className="img-bg me-2">
                        <ImageWithBasePath
                          src="assets/img/products/pos-product-16.png"
                          alt="Products"
                        />
                      </Link>
                      <div className="info d-flex align-items-center justify-content-between flex-fill">
                        <div>
                          <span>PT0005</span>
                          <h6>
                            <Link to="#">Red Nike Laser</Link>
                          </h6>
                        </div>
                        <p>$2000</p>
                      </div>
                    </div>
                  </div>
                  <div className="product-list d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center flex-fill">
                      <Link to="#" className="img-bg me-2">
                        <ImageWithBasePath
                          src="assets/img/products/pos-product-17.png"
                          alt="Products"
                        />
                      </Link>
                      <div className="info d-flex align-items-center justify-content-between flex-fill">
                        <div>
                          <span>PT0235</span>
                          <h6>
                            <Link to="#">Iphone 14</Link>
                          </h6>
                        </div>
                        <p>$3000</p>
                      </div>
                    </div>
                  </div>
                  <div className="product-list d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center flex-fill">
                      <Link to="#" className="img-bg me-2">
                        <ImageWithBasePath
                          src="assets/img/products/pos-product-16.png"
                          alt="Products"
                        />
                      </Link>
                      <div className="info d-flex align-items-center justify-content-between flex-fill">
                        <div>
                          <span>PT0005</span>
                          <h6>
                            <Link to="#">Red Nike Laser</Link>
                          </h6>
                        </div>
                        <p>$2000</p>
                      </div>
                    </div>
                  </div>
                  <div className="product-list d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center flex-fill">
                      <Link to="#" className="img-bg me-2">
                        <ImageWithBasePath
                          src="assets/img/products/pos-product-17.png"
                          alt="Products"
                        />
                      </Link>
                      <div className="info d-flex align-items-center justify-content-between flex-fill">
                        <div>
                          <span>PT0005</span>
                          <h6>
                            <Link to="#">Red Nike Laser</Link>
                          </h6>
                        </div>
                        <p>$2000</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer d-sm-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <Link to="#" className="btn btn-primary">
                    Submit
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Hold */}
      <div
        className="modal fade modal-default pos-modal"
        id="hold-order"
        aria-labelledby="hold-order"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5>Hold order</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body p-4">
              <form>
                <h2 className="text-center p-4">4500.00</h2>
                <div className="input-block">
                  <label>Order Reference</label>
                  <input
                    className="pos-form-control "
                    type="text"
                    defaultValue=""
                    placeholder=""
                  />
                </div>
                <p>
                  The current order will be set on hold. You can retreive this
                  order from the pending order button. Providing a reference to
                  it might help you to identify the order more quickly.
                </p>
                <div className="modal-footer d-sm-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <Link to="#" className="btn btn-primary">
                    Confirm
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Hold */}

      {/* Edit Product */}
      <div
        className="modal fade modal-default pos-modal"
        id="edit-product"
        aria-labelledby="edit-product"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5>Red Nike Laser</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body p-4">
              <form>
                <div className="row">
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks add-product">
                      <label>
                        Product Name <span>*</span>
                      </label>
                      <input type="text" placeholder={45} />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks add-product">
                      <label>
                        Tax Type <span>*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        options={tax}
                        placeholder="Select Option"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks add-product">
                      <label>
                        Tax <span>*</span>
                      </label>
                      <input type="text" placeholder="% 15" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks add-product">
                      <label>
                        Discount Type <span>*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        options={discounttype}
                        placeholder="Select Option"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks add-product">
                      <label>
                        Discount <span>*</span>
                      </label>
                      <input type="text" placeholder={15} />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 col-12">
                    <div className="input-blocks add-product">
                      <label>
                        Sale Unit <span>*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        options={unitType}
                        placeholder="Select Option"
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer d-sm-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <Link to="#" className="btn btn-primary">
                    Submit
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Product */}

      {/* Item Variation List */}
      <div
        className="modal fade pos-modal"
        id="ItemVariation"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          // style={{margin :"50px"}}
          className="modal-dialog modal-xl modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Item Variation List</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="">
              {/* modal-body */}
              <div className="tabs-sets">
                <div className="pos-categories">
                  <div className="table-top">
                    <div className="search-set">
                      <div className="search-input">
                        <input
                          type="text"
                          placeholder="Search Variation"
                          className="pos-form-control   formsearch"
                          onChange={(e) =>
                            setVariationFilterValue(e.target.value)
                          }
                        />
                      </div>
                      <div>
                        <button
                          className="btn btn-primary btn-sm ml-2"
                          onClick={() => handelAddItemBulkVariation()}
                        >
                          {variationFilterValue.length > 0
                            ? "Add All Filtered Variation"
                            : "Add All Variation"}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    {variationlistData
                      ?.filter((el) =>
                        el?.title
                          ?.toLowerCase()
                          .includes(variationFilterValue?.toLowerCase())
                      )
                      ?.map((cat, index) => (
                        <div
                          // className="col-sm-2 col-md-6 col-lg-3 col-xl-3 cursor-pointer"
                          className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 cursor-pointer"
                        >
                          <div
                            style={{ border: "2px solid #dbdbdb" }}
                            className="product-info default-cover card p-2"
                          >
                            <div className="d-flex align-items-center image-width">
                              <ImageWithBasePath
                                src={cat.src}
                                alt={cat.title}
                                height={50}
                                width={50}
                                id={cat.id}
                                mode="circle" // or 'square'
                              />
                              <div className="vertical-line"></div>
                              <div className="category-content">
                                {cat.isInCart && (
                                  <span className="check-icon">
                                    <i
                                      class="fa fa-check"
                                      style={{ color: "white" }}
                                    ></i>
                                  </span>
                                )}
                                <p>{cat.title}</p>
                                <p>
                                  {/* {cat.itemsCount}{" "} */}
                                  {/* {cat.type !== "Product"
                                      ? "Items"
                                      : "Variations"} */}
                                </p>
                                <p>Type: {cat.type}</p>
                                <div className="d-flex gap-2">
                                  {cat.type === "Product" && (
                                    <>
                                      <input
                                        className="Cart_Iput"
                                        placeholder="QTY"
                                        value={cat.cartQty}
                                        onChange={(e) =>
                                          productHandleChange(
                                            e.target.value,
                                            index,
                                            "cartQty",
                                            "variation",
                                            cat
                                          )
                                        }
                                      />
                                      <input
                                        className="Cart_Iput"
                                        placeholder="price"
                                        value={cat.cartPrice}
                                        onChange={(e) =>
                                          productHandleChange(
                                            e.target.value,
                                            index,
                                            "cartPrice",
                                            "variation",
                                            cat
                                          )
                                        }
                                      />
                                    </>
                                  )}
                                  {cat.type === "Product" && (
                                    // <i
                                    //   class="fa fa-plus"
                                    //   onClick={() => handelMainFilter(cat)}
                                    // ></i>

                                    <PlusCircle
                                      className="feather-16"
                                      style={{ color: "green" }}
                                      onClick={() => handelMainFilter(cat)}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Recent Transactions */}

      {/* Recent Transactions */}
      <div
        className="modal fade pos-modal"
        id="orders"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Orders</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body p-4">
              <div className="tabs-sets">
                <ul className="nav nav-tabs" id="myTabs" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="onhold-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#onhold"
                      type="button"
                      aria-controls="onhold"
                      aria-selected="true"
                      role="tab"
                    >
                      Onhold
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="unpaid-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#unpaid"
                      type="button"
                      aria-controls="unpaid"
                      aria-selected="false"
                      role="tab"
                    >
                      Unpaid
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="paid-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#paid"
                      type="button"
                      aria-controls="paid"
                      aria-selected="false"
                      role="tab"
                    >
                      Paid
                    </button>
                  </li>
                </ul>
                <div className="tab-content">
                  <div
                    className="tab-pane fade show active"
                    id="onhold"
                    role="tabpanel"
                    aria-labelledby="onhold-tab"
                  >
                    <div className="table-top">
                      <div className="search-set w-100 search-order">
                        <div className="search-input w-100">
                          <input
                            type="text"
                            placeholder="Search"
                            className="pos-form-control   formsearch w-100"
                          />
                          <Link to className="btn btn-searchset">
                            <i
                              data-feather="search"
                              className="feather-search"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="order-body">
                      <div className="default-cover p-4 mb-4">
                        <span className="badge bg-secondary d-inline-block mb-4">
                          Order ID : #666659
                        </span>
                        <div className="row">
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr className="mb-3">
                                  <td>Cashier</td>
                                  <td className="colon">:</td>
                                  <td className="text">admin</td>
                                </tr>
                                <tr>
                                  <td>Customer</td>
                                  <td className="colon">:</td>
                                  <td className="text">Botsford</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr>
                                  <td>Total</td>
                                  <td className="colon">:</td>
                                  <td className="text">$900</td>
                                </tr>
                                <tr>
                                  <td>Date</td>
                                  <td className="colon">:</td>
                                  <td className="text">29-08-2023 13:39:11</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <p className="p-4">
                          Customer need to recheck the product once
                        </p>
                        <div className="btn-row d-sm-flex align-items-center justify-content-between">
                          <Link
                            to="#"
                            className="btn btn-info btn-icon flex-fill"
                          >
                            Open
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-danger btn-icon flex-fill"
                          >
                            Products
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-success btn-icon flex-fill"
                          >
                            Print
                          </Link>
                        </div>
                      </div>
                      <div className="default-cover p-4 mb-4">
                        <span className="badge bg-secondary d-inline-block mb-4">
                          Order ID : #666660
                        </span>
                        <div className="row">
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr className="mb-3">
                                  <td>Cashier</td>
                                  <td className="colon">:</td>
                                  <td className="text">admin</td>
                                </tr>
                                <tr>
                                  <td>Customer</td>
                                  <td className="colon">:</td>
                                  <td className="text">Smith</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr>
                                  <td>Total</td>
                                  <td className="colon">:</td>
                                  <td className="text">$15000</td>
                                </tr>
                                <tr>
                                  <td>Date</td>
                                  <td className="colon">:</td>
                                  <td className="text">30-08-2023 15:59:11</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <p className="p-4">
                          Customer need to recheck the product once
                        </p>
                        <div className="btn-row d-flex align-items-center justify-content-between">
                          <Link
                            to="#"
                            className="btn btn-info btn-icon flex-fill"
                          >
                            Open
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-danger btn-icon flex-fill"
                          >
                            Products
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-success btn-icon flex-fill"
                          >
                            Print
                          </Link>
                        </div>
                      </div>
                      <div className="default-cover p-4">
                        <span className="badge bg-secondary d-inline-block mb-4">
                          Order ID : #666661
                        </span>
                        <div className="row">
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr className="mb-3">
                                  <td>Cashier</td>
                                  <td className="colon">:</td>
                                  <td className="text">admin</td>
                                </tr>
                                <tr>
                                  <td>Customer</td>
                                  <td className="colon">:</td>
                                  <td className="text">John David</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr>
                                  <td>Total</td>
                                  <td className="colon">:</td>
                                  <td className="text">$2000</td>
                                </tr>
                                <tr>
                                  <td>Date</td>
                                  <td className="colon">:</td>
                                  <td className="text">01-09-2023 13:15:00</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <p className="p-4 mb-4">
                          Customer need to recheck the product once
                        </p>
                        <div className="btn-row d-flex align-items-center justify-content-between">
                          <Link
                            to="#"
                            className="btn btn-info btn-icon flex-fill"
                          >
                            Open
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-danger btn-icon flex-fill"
                          >
                            Products
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-success btn-icon flex-fill"
                          >
                            Print
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="unpaid" role="tabpanel">
                    <div className="table-top">
                      <div className="search-set w-100 search-order">
                        <div className="search-input w-100">
                          <input
                            type="text"
                            placeholder="Search"
                            className="pos-form-control   formsearch w-100"
                          />
                          <Link to className="btn btn-searchset">
                            <i
                              data-feather="search"
                              className="feather-search"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="order-body">
                      <div className="default-cover p-4 mb-4">
                        <span className="badge bg-info d-inline-block mb-4">
                          Order ID : #666662
                        </span>
                        <div className="row">
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr className="mb-3">
                                  <td>Cashier</td>
                                  <td className="colon">:</td>
                                  <td className="text">admin</td>
                                </tr>
                                <tr>
                                  <td>Customer</td>
                                  <td className="colon">:</td>
                                  <td className="text">Anastasia</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr>
                                  <td>Total</td>
                                  <td className="colon">:</td>
                                  <td className="text">$2500</td>
                                </tr>
                                <tr>
                                  <td>Date</td>
                                  <td className="colon">:</td>
                                  <td className="text">10-09-2023 17:15:11</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <p className="p-4">
                          Customer need to recheck the product once
                        </p>
                        <div className="btn-row d-flex align-items-center justify-content-between">
                          <Link
                            to="#"
                            className="btn btn-info btn-icon flex-fill"
                          >
                            Open
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-danger btn-icon flex-fill"
                          >
                            Products
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-success btn-icon flex-fill"
                          >
                            Print
                          </Link>
                        </div>
                      </div>
                      <div className="default-cover p-4 mb-4">
                        <span className="badge bg-info d-inline-block mb-4">
                          Order ID : #666663
                        </span>
                        <div className="row">
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr className="mb-3">
                                  <td>Cashier</td>
                                  <td className="colon">:</td>
                                  <td className="text">admin</td>
                                </tr>
                                <tr>
                                  <td>Customer</td>
                                  <td className="colon">:</td>
                                  <td className="text">Lucia</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr>
                                  <td>Total</td>
                                  <td className="colon">:</td>
                                  <td className="text">$1500</td>
                                </tr>
                                <tr>
                                  <td>Date</td>
                                  <td className="colon">:</td>
                                  <td className="text">11-09-2023 14:50:11</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <p className="p-4">
                          Customer need to recheck the product once
                        </p>
                        <div className="btn-row d-flex align-items-center justify-content-between">
                          <Link
                            to="#"
                            className="btn btn-info btn-icon flex-fill"
                          >
                            Open
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-danger btn-icon flex-fill"
                          >
                            Products
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-success btn-icon flex-fill"
                          >
                            Print
                          </Link>
                        </div>
                      </div>
                      <div className="default-cover p-4 mb-4">
                        <span className="badge bg-info d-inline-block mb-4">
                          Order ID : #666664
                        </span>
                        <div className="row">
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr className="mb-3">
                                  <td>Cashier</td>
                                  <td className="colon">:</td>
                                  <td className="text">admin</td>
                                </tr>
                                <tr>
                                  <td>Customer</td>
                                  <td className="colon">:</td>
                                  <td className="text">Diego</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr>
                                  <td>Total</td>
                                  <td className="colon">:</td>
                                  <td className="text">$30000</td>
                                </tr>
                                <tr>
                                  <td>Date</td>
                                  <td className="colon">:</td>
                                  <td className="text">12-09-2023 17:22:11</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <p className="p-4 mb-4">
                          Customer need to recheck the product once
                        </p>
                        <div className="btn-row d-flex align-items-center justify-content-between">
                          <Link
                            to="#"
                            className="btn btn-info btn-icon flex-fill"
                          >
                            Open
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-danger btn-icon flex-fill"
                          >
                            Products
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-success btn-icon flex-fill"
                          >
                            Print
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="paid" role="tabpanel">
                    <div className="table-top">
                      <div className="search-set w-100 search-order">
                        <div className="search-input w-100">
                          <input
                            type="text"
                            placeholder="Search"
                            className="pos-form-control   formsearch w-100"
                          />
                          <Link to className="btn btn-searchset">
                            <i
                              data-feather="search"
                              className="feather-search"
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="order-body">
                      <div className="default-cover p-4 mb-4">
                        <span className="badge bg-primary d-inline-block mb-4">
                          Order ID : #666665
                        </span>
                        <div className="row">
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr className="mb-3">
                                  <td>Cashier</td>
                                  <td className="colon">:</td>
                                  <td className="text">admin</td>
                                </tr>
                                <tr>
                                  <td>Customer</td>
                                  <td className="colon">:</td>
                                  <td className="text">Hugo</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr>
                                  <td>Total</td>
                                  <td className="colon">:</td>
                                  <td className="text">$5000</td>
                                </tr>
                                <tr>
                                  <td>Date</td>
                                  <td className="colon">:</td>
                                  <td className="text">13-09-2023 19:39:11</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <p className="p-4">
                          Customer need to recheck the product once
                        </p>
                        <div className="btn-row d-flex align-items-center justify-content-between">
                          <Link
                            to="#"
                            className="btn btn-info btn-icon flex-fill"
                          >
                            Open
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-danger btn-icon flex-fill"
                          >
                            Products
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-success btn-icon flex-fill"
                          >
                            Print
                          </Link>
                        </div>
                      </div>
                      <div className="default-cover p-4 mb-4">
                        <span className="badge bg-primary d-inline-block mb-4">
                          Order ID : #666666
                        </span>
                        <div className="row">
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr className="mb-3">
                                  <td>Cashier</td>
                                  <td className="colon">:</td>
                                  <td className="text">admin</td>
                                </tr>
                                <tr>
                                  <td>Customer</td>
                                  <td className="colon">:</td>
                                  <td className="text">Antonio</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr>
                                  <td>Total</td>
                                  <td className="colon">:</td>
                                  <td className="text">$7000</td>
                                </tr>
                                <tr>
                                  <td>Date</td>
                                  <td className="colon">:</td>
                                  <td className="text">15-09-2023 18:39:11</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <p className="p-4">
                          Customer need to recheck the product once
                        </p>
                        <div className="btn-row d-flex align-items-center justify-content-between">
                          <Link
                            to="#"
                            className="btn btn-info btn-icon flex-fill"
                          >
                            Open
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-danger btn-icon flex-fill"
                          >
                            Products
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-success btn-icon flex-fill"
                          >
                            Print
                          </Link>
                        </div>
                      </div>
                      <div className="default-cover p-4 mb-4">
                        <span className="badge bg-primary d-inline-block mb-4">
                          Order ID : #666667
                        </span>
                        <div className="row">
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr className="mb-3">
                                  <td>Cashier</td>
                                  <td className="colon">:</td>
                                  <td className="text">admin</td>
                                </tr>
                                <tr>
                                  <td>Customer</td>
                                  <td className="colon">:</td>
                                  <td className="text">MacQuoid</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-sm-12 col-md-6 record mb-3">
                            <table>
                              <tbody>
                                <tr>
                                  <td>Total</td>
                                  <td className="colon">:</td>
                                  <td className="text">$7050</td>
                                </tr>
                                <tr>
                                  <td>Date</td>
                                  <td className="colon">:</td>
                                  <td className="text">17-09-2023 19:39:11</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <p className="p-4 mb-4">
                          Customer need to recheck the product once
                        </p>
                        <div className="btn-row d-flex align-items-center justify-content-between">
                          <Link
                            to="#"
                            className="btn btn-info btn-icon flex-fill"
                          >
                            Open
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-danger btn-icon flex-fill"
                          >
                            Products
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-success btn-icon flex-fill"
                          >
                            Print
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Additional Model */}
      <div
        className="modal fade pos-modal"
        id="AdditionalModel"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Additional Discount</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="row p-2">
              <div className="col-12">
                <div className="input-block">
                  <div className="d-flex">
                    <h4 className="pos-lable-font">Additional Discount1</h4>
                    <h4 className="pos-lable-font">Additional Discount2</h4>
                  </div>
                  <div className="d-flex align-items-center border-radious">
                    {/* Input field */}
                    <input
                      className="pos-form-control "
                      type="number"
                      onChange={(e) =>
                        handelFinalAmount(
                          e.target.value ? e.target.value : 0,
                          "FinalDisValue"
                        )
                      }
                      onFocus={handleFocus}
                      value={finalData.FinalDisValue}
                      // placeholder="Additional Discount"
                      placeholder="Additional Discount"
                      style={{ border: "none" }}
                    />

                    {/* Toggle Button */}
                    <span
                      className="btn btn-sm btn-outline-secondary input-percent-fixed"
                      role="button"
                      onClick={() => {
                        handelFinalAmount(
                          finalData.FinalDisType === "Percentage"
                            ? "Fixed"
                            : "Percentage",
                          "FinalDisType"
                        );
                      }}
                    >
                      {finalData.FinalDisType === "Percentage" ? "%" : "$"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="input-block">
                  <label className="pos-lable-font">Order Tax</label>
                  <div className="d-flex align-items-center border-radious">
                    {/* Input field */}
                    <input
                      className="pos-form-control "
                      type="number"
                      onChange={(e) =>
                        handelFinalAmount(
                          e.target.value ? e.target.value : 0,
                          "FinalGstValue"
                        )
                      }
                      onFocus={handleFocus}
                      value={finalData.FinalGstValue}
                      placeholder="Tax"
                      style={{ border: "none" }}
                    />

                    {/* Toggle Button */}
                    <span
                      className="btn btn-sm btn-outline-secondary input-percent-fixed"
                      role="button"
                      onClick={() => {
                        handelFinalAmount(
                          finalData.FinalGstType === "Percentage"
                            ? "Fixed"
                            : "Percentage",
                          "FinalGstType"
                        );
                      }}
                    >
                      {finalData.FinalGstType === "Percentage" ? "%" : "$"}
                    </span>
                  </div>
                  <div className="text-end mt-3">
                    <button
                      className="btn btn-primary btn-sm"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="input-block">
                  <label className="pos-lable-font">Shipping</label>
                  <input
                    className="pos-form-control   mr-2"
                    type="number"
                    onChange={(e) =>
                      handelFinalAmount(
                        e.target.value ? e.target.value : 0,
                        "FinalShipValue"
                      )
                    }
                    onFocus={handleFocus}
                    value={finalData.FinalShipValue}
                    placeholder="Shipping Fee"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PaymentType Model */}
      <div
        className="modal fade pos-modal"
        id="PaymentType"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered"
          role="document"
          style={{ maxHeight: "90vh" }}
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Receive Payment</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <h5 aria-hidden="true">×</h5>
              </button>
            </div>
            <div
              className="modal-body d-flex"
              style={{ overflowY: "auto", paddingBottom: "100px" }}
            >
              <div className="col-xxl-9 col-lg-9 col-md-9 col-sm-9">
                <div className="col-xxl-12 col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center gap-2 p-3">
                  <div className="d-flex align-items-center gap-3 col-md-6">
                    <ImageWithBasePath
                      src={customerDetail.Image}
                      alt={customerDetail.label}
                      height={50}
                      width={50}
                      id={customerDetail.Id}
                      mode="circle"
                    />
                    <div>
                      <span
                        className="cursor-pointer d-block"
                        onClick={() => HandelCustomerSupplierDetailModel()}
                        // data-bs-target="#CustomerSupplierDetailModel"
                        // data-bs-toggle="modal"
                      >
                        {`${customerDetail.FirstName} ${customerDetail.LastName} (${customerDetail.CompanyName})`}
                      </span>
                      <p className="mb-0">
                        {/* Balance: ${changePriceFormat(customerDetail.Balance)} */}
                        Balance:{" "}
                        {balanceLading ? (
                          <img
                            src={loadingimage}
                            alt="Loading..."
                            width={20}
                            className="ms-1"
                            style={{
                              display: "inline-block",
                              verticalAlign: "middle",
                            }}
                          />
                        ) : showCustomerBalance ? (
                          CurrencySymbols(
                            isNaN(Number(customerBalance))
                              ? 0
                              : Number(customerBalance),
                            { CurrencySymbol },
                            FractionDigits
                          )
                        ) : (
                          <span
                            style={{
                              fontSize: "12px",
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                            onClick={() => checkBalance()}
                          >
                            Click Here
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 d-flex align-items-center justify-content-end">
                    <div className="col-md-6 d-flex align-items-center justify-content-end">
                      {/* <h6>${finalAmountData.total}</h6> */}
                      {/* <div className="me-3">
                        <p className="fw-bold fs-5">
                        {CurrencySymbols(
                          Number(finalAmountData.total),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                        </p>
                        <p>Sale Amount</p>
                      </div> */}
                      {/* {saleId > 0 && (
                        <div className="border-start ps-3">
                          <p className="fw-bold fs-5">
                            {CurrencySymbols(
                              Number(salesOpenBalance),
                              { CurrencySymbol },
                              FractionDigits
                            )}
                          </p>
                          <p>Sale Balance</p>
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>
                {/* <div className="container mt-4">
                  <div className="position-relative">
                    <button className="btn position-absolute start-0 top-50 translate-middle-y" onClick={scrollLeft}>
                      &#10094;
                    </button>

                    <div
                      className="d-flex overflow-auto px-5 py-3 border rounded"
                      ref={sliderRef}
                      style={{ scrollBehavior: "smooth", whiteSpace: "nowrap" }}
                    >
                      {paymentMethod.map((method) => (
                        <div key={method.value} className="px-2">
                          <button
                            className={`btn ${selectedPaymentMethod.value === method.value ? "active btn btn-primary" : ""} px-4 py-2`}
                            onClick={() => setSelectedPaymentMethod(method)}
                          >
                            {method.label}
                          </button>
                        </div>
                      ))}
                    </div> */}

                {/* <button className="btn position-absolute end-0 top-50 translate-middle-y" onClick={scrollRight}>
                      &#10095;
                    </button>
                  </div> */}

                {/* Selected Payment Method Display */}
                {/* {selectedPaymentMethod && (
                    <div className="alert alert-success mt-3 text-center">
                      Selected Payment Method: <strong>{selectedPaymentMethod.label}</strong>
                    </div>
                  )} */}
                {/* </div> */}

                {/* <div className="row"> */}
                {/* Left Scroll Button */}
                <div className="position-relative">
                  <button
                    className="btn position-absolute start-0 top-50 translate-middle-y"
                    onClick={scrollLeft}
                  >
                    &#10094;
                  </button>
                  <div
                    className="d-flex overflow-auto px-5 py-3 col-11" //border rounded
                    ref={sliderRef}
                    style={{ scrollBehavior: "smooth", whiteSpace: "nowrap" }}
                  >
                    {paymentMethod.map((method) => (
                      <div
                        key={method.value}
                        className={`col-2 default-cover item payment-method-btn d-flex justify-content-center m-2 align-items-center ${
                          selectedPaymentMethod.value === method.value
                            ? "active btn btn-primary"
                            : ""
                        }`}
                        onClick={() => setSelectedPaymentMethod(method)}
                      >
                        <Link to="#">
                          <div
                            className={`fs-6 font-bold
                        ${
                          selectedPaymentMethod.value === method.value
                            ? "text-white"
                            : ""
                        }`}
                          >
                            {method.label}
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                  {/* Right Scroll Button */}
                  <button
                    className="btn position-absolute end-0 top-50 translate-middle-y"
                    onClick={scrollRight}
                  >
                    &#10095;
                  </button>
                </div>
                {/* <div
                    className={`default-cover item payment-method-btn d-flex justify-content-center align-items-center w-100 ${
                      paymentMethod === 2 ? "active" : ""
                    }`}
                    onClick={() => setPaymentMethod(2)}
                  >
                    <Link to="#">
                      <span className="fs-6 font-bold">Card</span>
                    </Link>
                  </div>
                  <div
                    className={`default-cover item payment-method-btn d-flex justify-content-center align-items-center w-100 ${
                      paymentMethod === 3 ? "active" : ""
                    }`}
                    onClick={() => setPaymentMethod(3)}
                  >
                    <Link to="#">
                      <span className="fs-6 font-bold">Check</span>
                    </Link>
                  </div> */}
                {/* </div> */}

                <div className="col-xxl-12 col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center gap-2 p-3">
                  <div className="col-4">
                    <div className="col-form-label">
                      Deposit To:<span className="text-danger">*</span>
                    </div>
                    <Select
                      options={accountsData}
                      placeholder="Select"
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      id="DepositTo"
                      name="DepositTo"
                      onChange={(event) =>
                        handlePaymentChangeInput(event, "DepositTo")
                      }
                      value={
                        depositTo
                          ? accountsData?.find(
                              (option) => option.value === depositTo
                            )
                          : null
                      }
                      className="custom-search-select"
                      formatOptionLabel={({
                        label,
                        parentName,
                        AccountType,
                      }) => (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <span>{label}</span>
                          <span
                            style={{
                              fontStyle: "italic",
                              color: "#666",
                              marginLeft: "1rem",
                            }}
                          >
                            {parentName
                              ? `Sub-account of ${parentName}`
                              : AccountType}
                          </span>
                        </div>
                      )}
                    />
                    {showDepositToError && (
                      <p className="text-danger mb-0">* Account is required</p>
                    )}
                    {depositTo > 0 && (
                      <span>
                        {/* className="ms-3" */}
                        Account Bal.:{" "}
                        {
                          accountsData?.find((el) => el?.value == depositTo)
                            ?.Amount
                        }
                      </span>
                    )}
                  </div>
                  <div className="col-4">
                    <div className="col-form-label">Reference Number:</div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Ref No."
                      name="ReferenceNumber"
                      id="ReferenceNumber"
                      onChange={(event) =>
                        handlePaymentChangeInput(event, "ReferenceNumber")
                      }
                      value={referenceNumber}
                    />
                  </div>
                  <div className="col-4">
                    <div className="col-form-label">Amount Received:</div>
                    <input
                      type="number"
                      className="form-control form-control-sm"
                      name="AmountReceived"
                      id="AmountReceived"
                      value={totalReceivingAmount}
                      onChange={(event) =>
                        handlePaymentChangeInput(event, "AmountReceived")
                      }
                      onFocus={handleFocus}
                      min={0}
                    />
                  </div>
                </div>
                <div className="col-xxl-12 col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center gap-2 p-3">
                  <div className="col-6">
                    <div className="col-form-label">Attachment:</div>
                    <input
                      type="file"
                      className="form-control form-control-sm"
                      id="PaymentAttachment"
                      name="PaymentAttachment"
                      accept=".pdf,.jpg,.jpeg,.heic,.png"
                      onChange={(e) => handleFileChange(e, "PaymentAttachment")}
                    />
                    {attachmentUrl && (
                      <Link to={attachmentUrl} target="_blank">
                        Attachment Link
                      </Link>
                    )}
                  </div>
                  <div className="col-6">
                    <div className="col-form-label">Memo:</div>
                    <textarea
                      className="form-control"
                      name="Memo"
                      placeholder="Memo"
                      // style={{ width: "100%", height: "150px" }}
                      onChange={(event) =>
                        handlePaymentChangeInput(event, "Memo")
                      }
                      value={memoData}
                    ></textarea>
                  </div>
                </div>
                {extraPaymentAmount > 0 && (
                  <div className="col-xxl-12 col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center gap-2 p-3">
                    <div className="col-6 d-flex align-items-center gap-2">
                      <input
                        type="radio"
                        name="day"
                        value="unapplied"
                        checked={radioOption === "unapplied"}
                        onChange={handleRadioChange}
                      />
                      <div className="col-form-label">Add To Credit</div>
                    </div>
                    <div className="col-6 d-flex align-items-center gap-2">
                      <input
                        type="radio"
                        name="day"
                        value="chnageBack"
                        checked={radioOption === "chnageBack"}
                        onChange={handleRadioChange}
                      />
                      <div className="col-form-label">
                        Change Return to Customer
                      </div>
                    </div>
                  </div>
                )}
                <div className="row justify-content-center">
                  <div className="col-md-6 d-flex justify-content-center">
                    <button
                      className="btn btn-sm btn-primary mt-3 mb-3"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      disabled={depositTo == 0}
                      onClick={() => {
                        handelSubmitInvoice("Payment");
                      }}
                    >
                      Receive Payment
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="col-xxl-3 col-lg-3 col-md-3 col-sm-3 p-3"
                style={{ borderLeft: "1px solid black" }}
              >
                <div className="text-lg font-semibold mb-2 text-center">
                  <p className="mt-2">Sale Amount</p>{" "}
                  <span>
                    {CurrencySymbols(
                      Number(finalAmountData.total),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </span>
                </div>
                <hr></hr>
                <div className="text-lg font-semibold mb-2 text-center">
                  <p className="mt-2">Total Items</p>{" "}
                  <span>{cartTotalQty}</span>
                </div>
                <hr></hr>
                <div className="text-lg font-semibold mb-2 text-center">
                  <p>Total Payable</p>
                  <span className="mt-2">
                    {CurrencySymbols(
                      Number(
                        saleId > 0 ? salesOpenBalance : finalAmountData.total
                      ),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </span>
                </div>
                <hr></hr>
                <div className="text-lg font-semibold mb-2 text-center">
                  <p>Total Paying</p>
                  <span className="mt-2">
                    {CurrencySymbols(
                      Number(totalReceivingAmount),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </span>
                </div>
                <hr></hr>
                <div
                  className="text-lg font-semibold mb-2 text-center"
                  style={{ color: "#ff0000", fontWeight: "bold" }}
                >
                  {" "}
                  {/* Red text for Change Return */}
                  <pageYOffset className="mt-2">Change Return</pageYOffset>
                  <p>
                    {CurrencySymbols(
                      Number(extraPaymentAmount),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </p>
                </div>
                <hr></hr>
                <div className="text-lg font-semibold mb-2 text-center">
                  <p>Balance</p>
                  <span className="mt-2">
                    {CurrencySymbols(
                      Math.max(
                        saleId > 0
                          ? salesOpenBalance - totalReceivingAmount
                          : finalAmountData.total - totalReceivingAmount,
                        0
                      ),
                      { CurrencySymbol },
                      FractionDigits
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade pos-modal"
        id="AdditionalDiscountModel"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Additional Discount</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="row p-2">
              <div className="col-12">
                <div className="input-block">
                  <div className="d-flex">
                    <label className="pos-lable-font">
                      Additional Discount
                    </label>
                    <label className="pos-lable-font ms-auto">
                      Change Discount type
                    </label>
                  </div>

                  <div className="d-flex align-items-center border-radious">
                    {/* Input field */}
                    <input
                      className="pos-form-control "
                      type="number"
                      onChange={(e) =>
                        handelFinalAmount(
                          e.target.value ? e.target.value : 0,
                          "FinalDisValue"
                        )
                      }
                      onFocus={handleFocus}
                      value={finalData.FinalDisValue}
                      // placeholder="Additional Discount"
                      placeholder="Additional Discount"
                      style={{ border: "none" }}
                    />

                    {/* Toggle Button */}
                    <span
                      className="btn btn-sm btn-outline-secondary input-percent-fixed"
                      role="button"
                      onClick={() => {
                        handelFinalAmount(
                          finalData.FinalDisType === "Percentage"
                            ? "Fixed"
                            : "Percentage",
                          "FinalDisType"
                        );
                      }}
                    >
                      {finalData.FinalDisType === "Percentage" ? "%" : "$"}
                    </span>
                  </div>
                  <div className="text-center mt-3">
                    <button
                      className="btn btn-primary btn-sm col-2"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade pos-modal"
        id="AdditionalTaxModel"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Order Tax</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="row p-2">
              <div className="col-12">
                <div className="input-block">
                  {/* <label className="pos-lable-font">Order Tax</label> */}
                  <div className="d-flex">
                    <label className="pos-lable-font">Order Tax</label>
                    <label className="pos-lable-font ms-auto">
                      Change Tax type
                    </label>
                  </div>
                  <div className="d-flex align-items-center border-radious">
                    {/* Input field */}
                    <input
                      className="pos-form-control "
                      type="number"
                      onChange={(e) =>
                        handelFinalAmount(
                          e.target.value ? e.target.value : 0,
                          "FinalGstValue"
                        )
                      }
                      onFocus={handleFocus}
                      value={finalData.FinalGstValue}
                      placeholder="Order Tax"
                      style={{ border: "none" }}
                    />

                    {/* Toggle Button */}
                    <span
                      className="btn btn-sm btn-outline-secondary input-percent-fixed"
                      role="button"
                      onClick={() => {
                        handelFinalAmount(
                          finalData.FinalGstType === "Percentage"
                            ? "Fixed"
                            : "Percentage",
                          "FinalGstType"
                        );
                      }}
                    >
                      {finalData.FinalGstType === "Percentage" ? "%" : "$"}
                    </span>
                  </div>
                  <div className="text-center mt-3">
                    <button
                      className="btn btn-primary btn-sm col-2"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade pos-modal"
        id="AdditionalShippingModel"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Shipping Fee</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="col-12">
              <div className="input-block">
                <div className="d-flex">
                  <label className="pos-lable-font">Shipping</label>
                </div>
                <input
                  className="pos-form-control mr-2"
                  type="number"
                  onChange={(e) =>
                    handelFinalAmount(e.target.value, "FinalShipValue")
                  }
                  // onFocus={handleFocus}
                  // onKeyDown={(e) => {
                  //   if (e.key === "Enter") {
                  //     // Close the modal
                  //     document.getElementById("AdditionalShippingModel").classList.remove("show");
                  //     document.body.classList.remove("modal-open");
                  //     document.body.style.paddingRight = "";
                  //     const backdrop = document.querySelector(".modal-backdrop");
                  //     if (backdrop) backdrop.remove();
                  //   }
                  // }}
                  value={finalData.FinalShipValue}
                  placeholder="Shipping Fee"
                />
                <div className="text-center mt-3">
                  <button
                    className="btn btn-primary btn-sm col-2"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade pos-modal"
        id="DelivaryMethod"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Delivary Method</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="col-12">
              <div className="payment-method">
                {/* <h6>Payment Method</h6> */}
                <div className="">
                  <Select
                    options={saleTypeMethod}
                    className="custom-search-select"
                    placeholder="Delivary Method"
                    value={saleTypeMethod?.find(
                      (el) => el.value === deliveryMethodId
                    )} // Use deliveryMethodId for the selected value
                    // onChange={(e) => setDeliveryMethodId(e.value)} // Pass the entire selected object
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Date Model */}
      <div
        className="modal fade pos-modal"
        id="TermDateModel"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Select Term And Due Date</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="row p-2">
              <div className="p-2 col-md-12">
                <label className="pos-lable-font">Select Term</label>
                <Select
                  value={termOptions.find(
                    (option) => option.value === selectedTerm
                  )}
                  options={termOptions}
                  onChange={handleTermChange}
                  isClearable={true}
                  backspaceRemovesValue={false}
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  // placeholder="Select Terms"
                  id="TermsID"
                  name="TermsID"
                  className="custom-search-select"
                  // menuPlacement="top"
                />
              </div>
              <div className="d-flex col-12 gap-2">
                <div>
                  <lable className="pos-lable-font">Invoice Date </lable>
                  <CommonDatePicker
                    FinalDate={startDate}
                    handleDateChange={handleChangeCustomStartingDate}
                    showDefaultDate={true}
                    dateplaceholder={"Invoice Date"}
                  />
                </div>
                {/* <label>Due Date</label> */}
                <div>
                  <lable className="pos-lable-font">Due Date </lable>
                  <CommonDatePicker
                    FinalDate={dueDate}
                    handleDateChange={handleChangeCustomEndingDate}
                    showDefaultDate={true}
                    readOnly={true} // Make due date readonly
                    dateplaceholder={"Due Date"}
                  />
                </div>
              </div>
              <div className="text-center mt-3">
                <button
                  className="btn btn-primary btn-sm col-2"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Date Model */}

      {/* Scanner Model */}
      <div
        className="modal fade pos-modal"
        id="ScannerModel"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            {/* <div className="modal-header p-4">
              <h5 className="modal-title">Scan BarCode and QR Code</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setStartScannerCamera(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div> */}
            <div className="row p-2">
              <div className="col-12">
                {startScannerCamera && (
                  <Scanner
                    customerData={customerDetail}
                    callbackBulkCartData={callbackScannerBulkCartData}
                    setStartScannerCamera={setStartScannerCamera}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Internal Notes Model */}
      <div
        className="modal fade pos-modal"
        id="CommentMemo"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title ml-3">Note to customer</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="col-12">
              <div className="payment-method">
                {/* <h6>Payment Method</h6> */}
                <div className="ml-5 mr-5">
                  <form
                    onSubmit={AddMessageInvoice}
                    className="d-flex"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid lightgray",
                      borderRadius: "5px",
                      width: "100%",
                    }}
                  >
                    <textarea
                      id="comment"
                      name="comment"
                      placeholder="Note to customer"
                      className="form-control w-100"
                      onChange={handleChangeAccountSalesData}
                      value={accountSaleData.comment}
                      style={{ border: "none", minHeight: "100px" }}
                    ></textarea>
                  </form>
                  <div className="ms-auto d-flex justify-content-end mt-4 mb-4 gap-3">
                    <button
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      className="btn-primary btn-sm"
                      type="submit"
                    >
                      Submit
                      {/* <i className="fa fa-check" aria-hidden="true"></i> */}
                    </button>
                    <button
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      type="submit"
                      className="btn-primary btn-sm"
                      onClick={() =>
                        setAccountSaleData({
                          ...accountSaleData,
                          comment: "",
                        })
                      }
                    >
                      Cancel
                      {/* <i
                        style={{ padding: "6px 4px" }}
                        className="fa fa-times"
                        aria-hidden="true"
                      ></i> */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Internal Notes Model */}
      <div
        className="modal fade pos-modal"
        id="InternalNotes"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title ml-3">
                Internal customer notes(hidden)
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <form onSubmit={AddMessageInvoice}>
              <div className="col-12">
                <div className="payment-method px-4">
                  <textarea
                    id="InvoiceMessage"
                    name="InvoiceMessage"
                    placeholder={
                      !customerDetail?.IsCustomerHasInternalNote &&
                      !accountSaleData?.InvoiceMessage
                        ? "This Internal note will not sync into QuickBooks as this is not added from Customer's Internal Note."
                        : ""
                    }
                    className="form-control"
                    onChange={handleChangeAccountSalesData}
                    value={accountSaleData.InvoiceMessage}
                    style={{
                      border: "1px solid lightgray",
                      borderRadius: "5px",
                      minHeight: "120px",
                    }}
                  />
                </div>
              </div>
              <div
                className="d-flex justify-content-end p-3"
                style={{
                  backgroundColor: "#f8f9fa",
                  borderTop: "1px solid #dee2e6",
                }}
              >
                <button
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  className="btn btn-primary me-2"
                  type="submit"
                >
                  Submit
                </button>
                <button
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  type="button"
                  className="btn btn-primary"
                  onClick={() =>
                    setAccountSaleData({
                      ...accountSaleData,
                      InvoiceMessage: "",
                    })
                  }
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/*  Message on Statement Model */}
      <div
        className="modal fade pos-modal"
        id="MessageonStatement"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title ml-3">Memo on statement</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <form onSubmit={AddMessageInvoice}>
              <div className="col-12 px-4">
                <textarea
                  id="InvoiceStatement"
                  name="InvoiceStatement"
                  placeholder="Memo on statement"
                  className="form-control"
                  onChange={handleChangeAccountSalesData}
                  value={accountSaleData.InvoiceStatement}
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                    minHeight: "120px",
                  }}
                />
              </div>

              <div
                className="d-flex justify-content-end p-3"
                style={{
                  backgroundColor: "#f8f9fa",
                  borderTop: "1px solid #dee2e6",
                }}
              >
                <button
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  className="btn btn-primary me-2"
                  type="submit"
                >
                  Submit
                </button>
                <button
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  type="button"
                  className="btn btn-primary"
                  onClick={() =>
                    setAccountSaleData({
                      ...accountSaleData,
                      InvoiceStatement: "",
                    })
                  }
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/*  Tags Model */}
      <div
        className="modal fade pos-modal"
        id="Tags"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title"> Tags</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="col-12">
              <div className="payment-method">
                {/* <h6>Payment Method</h6> */}
                <div>
                  <label className="col-form-label">Tags:</label>
                  <Select
                    onChange={(event) => handleTagChange(event, "Tags")} // Handle changes in selection
                    value={tagOptions.filter((obj) =>
                      selectedtags.includes(obj.value)
                    )} // Filter selected tags from tagOptions
                    options={tagOptions}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    isMulti={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    id="Tags"
                    name="Tags"
                    className="custom-search-select"
                  />
                  <div className="text-center mt-3">
                    <button
                      className="btn btn-primary btn-sm col-2"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*  Attachments Model */}
      <div
        className="modal fade pos-modal"
        id="Attachments"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Attachments</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="col-12">
              <div className="payment-method">
                {/* <h6>Payment Method</h6> */}
                <div>
                  <label className="col-form-label">Attachments:</label>
                  <input
                    type="file"
                    className="form-control form-control-sm"
                    id="SalesAttachment"
                    name="SalesAttachment"
                    onChange={(e) => handleFileChange(e, "SalesAttachment")}
                  />
                  {accountSaleData?.Attachment == undefined ||
                  accountSaleData?.Attachment == "" ? (
                    ""
                  ) : (
                    <Link to={accountSaleData?.Attachment} target="_blank">
                      Attachment Link
                    </Link>
                  )}
                </div>
                <div className="text-center mt-3">
                  <button
                    className="btn btn-primary btn-sm col-2"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*  PaymentDetail Model */}
      <div
        className="modal fade pos-modal"
        id="PaymentDetail"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Payment Detail</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="col-12">
              <div className="payment-method">
                {/* <h6>Payment Method</h6> */}

                {paramObject.saleId > 0 && (
                  <div className="flex-row">
                    <div className="p-2 col-md-12">
                      <CommonPreviousInvoiceComponent
                        moduleType={
                          saleTypeId == 2
                            ? "Memo"
                            : saleTypeId == 1
                            ? "Invoice"
                            : ""
                        }
                        moduleId={paramObject.saleId}
                        invoiceTotal={finalAmountData?.total}
                      />
                    </div>
                  </div>
                )}

                <div className="text-center mt-3">
                  <button
                    className="btn btn-primary btn-sm col-2"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*  Attachments Model */}

      {/*  Hold Sale Model */}
      <div
        className="modal fade pos-modal"
        id="holdSale"
        tabIndex={-1}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
          style={{
            maxWidth: "100vw" /* 100% of the viewport width */,
            maxHeight: "100vh" /* 100% of the viewport height */,
            margin: "0" /* Remove margin for full width */,
          }}
        >
          <div className="modal-content">
            <div className="modal-header p-4">
              <h5 className="modal-title">Hold Sale and Draft</h5>
              <div className="m-2">
                <button
                  className="btn btn-primary btn-sm mr-2"
                  onClick={() => handelAddToDraft()}
                >
                  Add to Hold
                </button>
                <button
                  className="btn btn-primary btn-sm mr-2"
                  disabled={holdListCount === 0}
                  onClick={() => removeDraft()}
                >
                  Delete from draft
                </button>
              </div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ padding: "20px" }}
              >
                <span style={{ fontSize: "40px" }} aria-hidden="true">
                  ×
                </span>
              </button>
            </div>
            <div className="col-12">
              <div className="payment-method mb-4">
                {/* <h6>Payment Method</h6> */}
                <div>
                  <div>
                    <p className="text-danger">
                      *Select Row to apply or Delete{" "}
                    </p>
                    <table className="styled-table">
                      <thead>
                        <tr>
                          <th>Checkbox</th>
                          <th>Draft ID</th>
                          <th>Cust ID</th>
                          <th>Customer Name</th>
                          <th>Total</th>
                          <th>Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {holdList?.map((draft, index) => (
                          <tr key={index}>
                            <td style={{ paddingLeft: "18px" }}>
                              <input
                                type="checkbox"
                                onChange={(e) =>
                                  handelDraftSelect(e.target.checked, index)
                                }
                              />
                            </td>
                            <td>{draft?.DraftId}</td>
                            <td>{draft?.customerId}</td>
                            <td>{`${draft?.customerDetail?.FirstName} ${draft?.customerDetail?.LastName} (${draft?.customerDetail?.CompanyName})`}</td>
                            <td>{draft?.finalAmountData?.total}</td>
                            <td>{draft?.draftDate}</td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm"
                                onClick={() => retrieveDraft(draft)}
                                // disabled={holdListCount !== 1}
                              >
                                Apply
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="text-center mt-3">
                  <button
                    className="btn btn-primary btn-sm col-2"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Hold Sale Model */}

      {/* /Recent Transactions */}

      {/* Supplier Customer Detail Model */}
      <CustomerSupplierDetailModel
        id={customerId}
        model="customer"
        show={showCustomerModal}
        handleClose={() => {
          setShowCustomerModal(false);
        }}
      />

      <CustomerConfirm
        open={CustomerPopup}
        handleClose={handleCustomerPospup}
        Module={"Customer"}
      />
      {/* Supplier Customer Detail Model */}

      {/* Item Detail Model */}
      <ItemsDetailsModal
        id={itemDetailModelId}
        setItemsId={() => setItemDetailModelId(0)}
        saleCustomerId={customerId}
      />
      {/* Item Detail Model */}

      {/* History Model */}
      <HistoryModel model="sales" id={showHistoryList ? 1 : 0} />
      {/* History Model */}

      {/* Lookup Receipt Sale Model */}
      <LookupReceiptSaleModal />
      {/* Lookup Receipt Sale Model */}

      {/* Manage Delivery Model */}
      <Deliveriescard
        callback={callbackSalesDeliveryModel}
        shippingadd={shippingAddressOption} // shipping adderess array
        setShippingAddressId={setShippingAddressId}
        customerid={customerId}
        selectedshippingadd={shippingAddressId}
        salesDeliveryDetails={salesDeliveryData}
        // salesDeliveryDetails={customerDetail}
        salesdeliverydata={{
          ...salesDeliveryData,
          deliveryMethodId: deliveryMethodId,
          DeliveryFees: finalData?.FinalShipValue || 0,
        }}
        saleDeliveryOtherSection={{ deliveryMethodId: deliveryMethodId }}
        show={show}
        handlecloses={() => {
          setShow(false);
        }} // add for the delivery module pass delivery id.
      />
      {/* Manage Delivery Model */}

      {/* Item Grid */}
      <FilterModal
        callback={callbackItemGrid}
        runApi={runApi}
        closepopup={() => setRunApi(false)}
        customerId={customerId}
      />
      <DeleteConfirmationModalBanner
        deleteApiUrl={`${config.salesconfigBaseUrl}/sales/batchdelete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        data11={false}
        isSaleVoid={1}
      />
      {/* Item Grid */}
    </div>
  );
};

export default PosPage;
